//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(null as any);
    }

    /**
     * @return Success
     */
    isRegisterAvailable(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsRegisterAvailable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsRegisterAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsRegisterAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsRegisterAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }
}

@Injectable()
export class AlertServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AlertDto> {
        let url_ = this.baseUrl + "/api/services/app/Alert/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AlertDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Alert/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AlertDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAlertDto | undefined): Observable<AlertDto> {
        let url_ = this.baseUrl + "/api/services/app/Alert/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAlertDto | undefined): Observable<AlertDto> {
        let url_ = this.baseUrl + "/api/services/app/Alert/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AlertDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Alert/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AssetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    createAssetsAllowed(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Asset/CreateAssetsAllowed";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssetsAllowed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssetsAllowed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateAssetsAllowed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param number (optional) 
     * @return Success
     */
    getByNumber(number: string | null | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetByNumber?";
        if (number !== undefined && number !== null)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processGetByNumber(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAssetDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAssetDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: AssetImportItemImportItemsInput | undefined): Observable<AssetImportItemImportItemsResult> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetImportItemImportItemsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetImportItemImportItemsResult>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<AssetImportItemImportItemsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetImportItemImportItemsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetImportItemImportItemsResult>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param filter (optional) 
     * @param requireRevision (optional) 
     * @param markedForRemove (optional) 
     * @param physicalLocationId (optional) 
     * @param costCenterIds (optional) 
     * @param statuses (optional) 
     * @param startCreationTime (optional) 
     * @param endCreationTime (optional) 
     * @param beneficiaryId (optional) 
     * @return Success
     */
    getFiltered(skip: number | undefined, take: number | undefined, filter: string | null | undefined, requireRevision: boolean | undefined, markedForRemove: boolean | undefined, physicalLocationId: string | null | undefined, costCenterIds: string[] | null | undefined, statuses: number[] | null | undefined, startCreationTime: moment.Moment | null | undefined, endCreationTime: moment.Moment | null | undefined, beneficiaryId: string | null | undefined): Observable<AssetConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetFiltered?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (requireRevision === null)
            throw new Error("The parameter 'requireRevision' cannot be null.");
        else if (requireRevision !== undefined)
            url_ += "RequireRevision=" + encodeURIComponent("" + requireRevision) + "&";
        if (markedForRemove === null)
            throw new Error("The parameter 'markedForRemove' cannot be null.");
        else if (markedForRemove !== undefined)
            url_ += "MarkedForRemove=" + encodeURIComponent("" + markedForRemove) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (costCenterIds !== undefined && costCenterIds !== null)
            costCenterIds && costCenterIds.forEach(item => { url_ += "CostCenterIds=" + encodeURIComponent("" + item) + "&"; });
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (startCreationTime !== undefined && startCreationTime !== null)
            url_ += "StartCreationTime=" + encodeURIComponent(startCreationTime ? "" + startCreationTime.toISOString() : "") + "&";
        if (endCreationTime !== undefined && endCreationTime !== null)
            url_ += "EndCreationTime=" + encodeURIComponent(endCreationTime ? "" + endCreationTime.toISOString() : "") + "&";
        if (beneficiaryId !== undefined && beneficiaryId !== null)
            url_ += "BeneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiltered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiltered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetConfigDto[]>;
        }));
    }

    protected processGetFiltered(response: HttpResponseBase): Observable<AssetConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetConfigDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetConfigDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportCsv(body: AssetFilterParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Asset/ExportCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportCsv(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteSelected(body: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/DeleteSelected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSelected(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @param includeScan (optional) 
     * @param includeRevision (optional) 
     * @param includeRepair (optional) 
     * @return Success
     */
    getAssetHistory(assetId: string | undefined, skip: number | undefined, take: number | undefined, includeScan: boolean | undefined, includeRevision: boolean | undefined, includeRepair: boolean | undefined): Observable<AssetHistoryItem[]> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAssetHistory?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (includeScan === null)
            throw new Error("The parameter 'includeScan' cannot be null.");
        else if (includeScan !== undefined)
            url_ += "includeScan=" + encodeURIComponent("" + includeScan) + "&";
        if (includeRevision === null)
            throw new Error("The parameter 'includeRevision' cannot be null.");
        else if (includeRevision !== undefined)
            url_ += "includeRevision=" + encodeURIComponent("" + includeRevision) + "&";
        if (includeRepair === null)
            throw new Error("The parameter 'includeRepair' cannot be null.");
        else if (includeRepair !== undefined)
            url_ += "includeRepair=" + encodeURIComponent("" + includeRepair) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetHistoryItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetHistoryItem[]>;
        }));
    }

    protected processGetAssetHistory(response: HttpResponseBase): Observable<AssetHistoryItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetHistoryItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetHistoryItem[]>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @param includeScan (optional) 
     * @param includeRevision (optional) 
     * @param includeRepair (optional) 
     * @return Success
     */
    exportExcelAssetHistory(assetId: string | undefined, includeScan: boolean | undefined, includeRevision: boolean | undefined, includeRepair: boolean | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Asset/ExportExcelAssetHistory?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (includeScan === null)
            throw new Error("The parameter 'includeScan' cannot be null.");
        else if (includeScan !== undefined)
            url_ += "includeScan=" + encodeURIComponent("" + includeScan) + "&";
        if (includeRevision === null)
            throw new Error("The parameter 'includeRevision' cannot be null.");
        else if (includeRevision !== undefined)
            url_ += "includeRevision=" + encodeURIComponent("" + includeRevision) + "&";
        if (includeRepair === null)
            throw new Error("The parameter 'includeRepair' cannot be null.");
        else if (includeRepair !== undefined)
            url_ += "includeRepair=" + encodeURIComponent("" + includeRepair) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcelAssetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcelAssetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcelAssetHistory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    maintenancePlanningUpdated(assetId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/MaintenancePlanningUpdated?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMaintenancePlanningUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMaintenancePlanningUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMaintenancePlanningUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    repairPlanningUpdated(assetId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/RepairPlanningUpdated?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRepairPlanningUpdated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRepairPlanningUpdated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRepairPlanningUpdated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BeneficiaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBeneficiaryDto | undefined): Observable<BeneficiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeneficiaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeneficiaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BeneficiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BeneficiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<BeneficiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeneficiaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeneficiaryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BeneficiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BeneficiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateBeneficiaryDto | undefined): Observable<BeneficiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeneficiaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeneficiaryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BeneficiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BeneficiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: BeneficiaryGetAllInput | undefined): Observable<BeneficiaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeneficiaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeneficiaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BeneficiaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BeneficiaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllAssetsNotAssigned(): Observable<BeneficiaryAssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/GetAllAssetsNotAssigned";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssetsNotAssigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssetsNotAssigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeneficiaryAssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeneficiaryAssetDto[]>;
        }));
    }

    protected processGetAllAssetsNotAssigned(response: HttpResponseBase): Observable<BeneficiaryAssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BeneficiaryAssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryAssetDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllSummary(): Observable<BeneficiaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/GetAllSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeneficiaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeneficiaryDto[]>;
        }));
    }

    protected processGetAllSummary(response: HttpResponseBase): Observable<BeneficiaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BeneficiaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcell(body: BeneficiaryFilter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/ExportExcell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcell(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: BeneficiaryImportItemImportItemsInput | undefined): Observable<BeneficiaryImportItemImportItemsResult> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeneficiaryImportItemImportItemsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeneficiaryImportItemImportItemsResult>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<BeneficiaryImportItemImportItemsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BeneficiaryImportItemImportItemsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryImportItemImportItemsResult>(null as any);
    }

    /**
     * @param pdiList (optional) 
     * @return Success
     */
    deleteList(pdiList: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/DeleteList?";
        if (pdiList !== undefined && pdiList !== null)
            pdiList && pdiList.forEach(item => { url_ += "pdiList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param beneficiaryId (optional) 
     * @return Success
     */
    getBeneficiaryAssets(beneficiaryId: string | undefined): Observable<AssetTransferDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/GetBeneficiaryAssets?";
        if (beneficiaryId === null)
            throw new Error("The parameter 'beneficiaryId' cannot be null.");
        else if (beneficiaryId !== undefined)
            url_ += "beneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBeneficiaryAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeneficiaryAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetTransferDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetTransferDto[]>;
        }));
    }

    protected processGetBeneficiaryAssets(response: HttpResponseBase): Observable<AssetTransferDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetTransferDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetTransferDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transferBeneficiaryAssets(body: BeneficiaryTransferDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Beneficiary/TransferBeneficiaryAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferBeneficiaryAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferBeneficiaryAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransferBeneficiaryAssets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CostCenterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllUnrestricted(): Observable<CostCenterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetAllUnrestricted";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnrestricted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnrestricted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterDto[]>;
        }));
    }

    protected processGetAllUnrestricted(response: HttpResponseBase): Observable<CostCenterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CostCenterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CostCenterDto[]>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<CostCenterDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CostCenterDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostCenterDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CostCenterDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    exportExcell(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/ExportExcell";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcell(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFiltered(filter: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CostCenterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetAllFiltered?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFiltered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFiltered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterDto[]>;
        }));
    }

    protected processGetAllFiltered(response: HttpResponseBase): Observable<CostCenterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CostCenterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CostCenterDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCostCenterDto | undefined): Observable<CostCenterDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CostCenterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostCenterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CostCenterDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param costCenterId (optional) 
     * @return Success
     */
    getCostCenterAssets(costCenterId: string | undefined): Observable<AssetTransferDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/GetCostCenterAssets?";
        if (costCenterId === null)
            throw new Error("The parameter 'costCenterId' cannot be null.");
        else if (costCenterId !== undefined)
            url_ += "costCenterId=" + encodeURIComponent("" + costCenterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCostCenterAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCostCenterAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetTransferDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetTransferDto[]>;
        }));
    }

    protected processGetCostCenterAssets(response: HttpResponseBase): Observable<AssetTransferDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetTransferDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetTransferDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    transferCostCenterAssets(body: CostCenterTransferDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/TransferCostCenterAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferCostCenterAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferCostCenterAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransferCostCenterAssets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: CostCenterImportItemImportItemsInput | undefined): Observable<CostCenterImportItemImportItemsResult> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterImportItemImportItemsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterImportItemImportItemsResult>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<CostCenterImportItemImportItemsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostCenterImportItemImportItemsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CostCenterImportItemImportItemsResult>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<CostCenterDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CostCenterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostCenterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CostCenterDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCostCenterDto | undefined): Observable<CostCenterDto> {
        let url_ = this.baseUrl + "/api/services/app/CostCenter/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostCenterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostCenterDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CostCenterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostCenterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CostCenterDto>(null as any);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param currentDate (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getDashboardMaintenanceSummary(currentDate: moment.Moment | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<DashboardMaintenanceSummary> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardMaintenanceSummary?";
        if (currentDate === null)
            throw new Error("The parameter 'currentDate' cannot be null.");
        else if (currentDate !== undefined)
            url_ += "CurrentDate=" + encodeURIComponent(currentDate ? "" + currentDate.toISOString() : "") + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardMaintenanceSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardMaintenanceSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardMaintenanceSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardMaintenanceSummary>;
        }));
    }

    protected processGetDashboardMaintenanceSummary(response: HttpResponseBase): Observable<DashboardMaintenanceSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardMaintenanceSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardMaintenanceSummary>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getDashboardSummary(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<DashboardSummary> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetDashboardSummary?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardSummary>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardSummary>;
        }));
    }

    protected processGetDashboardSummary(response: HttpResponseBase): Observable<DashboardSummary> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardSummary>(null as any);
    }
}

@Injectable()
export class DocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInventoryDecisionDetails(): Observable<DocumentDetails> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetInventoryDecisionDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventoryDecisionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryDecisionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDetails>;
        }));
    }

    protected processGetInventoryDecisionDetails(response: HttpResponseBase): Observable<DocumentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDetails>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateInventoryDecisionDocument(body: DocumentParameterBase[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/GenerateInventoryDecisionDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateInventoryDecisionDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateInventoryDecisionDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateInventoryDecisionDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getManagerialStatementsDetails(): Observable<DocumentDetails> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetManagerialStatementsDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManagerialStatementsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManagerialStatementsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDetails>;
        }));
    }

    protected processGetManagerialStatementsDetails(response: HttpResponseBase): Observable<DocumentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDetails>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateManagerialStatementsDocument(body: DocumentParameterBase[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/GenerateManagerialStatementsDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateManagerialStatementsDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateManagerialStatementsDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateManagerialStatementsDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param physicalLocationId (optional) 
     * @param markedForRemove (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getForCassationsAssets(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, physicalLocationId: string | null | undefined, markedForRemove: boolean | null | undefined, costCenters: string[] | null | undefined): Observable<CassateItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetForCassationsAssets?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (markedForRemove !== undefined && markedForRemove !== null)
            url_ += "MarkedForRemove=" + encodeURIComponent("" + markedForRemove) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForCassationsAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForCassationsAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CassateItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CassateItemDto[]>;
        }));
    }

    protected processGetForCassationsAssets(response: HttpResponseBase): Observable<CassateItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CassateItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CassateItemDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getInventoryCassationDetails(): Observable<DocumentDetails> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetInventoryCassationDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventoryCassationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryCassationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDetails>;
        }));
    }

    protected processGetInventoryCassationDetails(response: HttpResponseBase): Observable<DocumentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDetails>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateInventoryCassationDocument(body: CassateInputParamsGenerateDocumentInputAssetsList | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/GenerateInventoryCassationDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateInventoryCassationDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateInventoryCassationDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateInventoryCassationDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportForCassationAssets(body: CassateInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/ExportForCassationAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportForCassationAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportForCassationAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportForCassationAssets(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getInventoryStatementDetails(): Observable<DocumentDetails> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetInventoryStatementDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventoryStatementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryStatementDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDetails>;
        }));
    }

    protected processGetInventoryStatementDetails(response: HttpResponseBase): Observable<DocumentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDetails>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param filter (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getInventoryStatementAssets(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, filter: string | null | undefined, costCenters: string[] | null | undefined): Observable<PhysicalItemReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetInventoryStatementAssets?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInventoryStatementAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInventoryStatementAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalItemReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalItemReportDto[]>;
        }));
    }

    protected processGetInventoryStatementAssets(response: HttpResponseBase): Observable<PhysicalItemReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PhysicalItemReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalItemReportDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateInventoryStatementDocument(body: InventoryStatementInputParamsGenerateDocumentInputAssetsList | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/GenerateInventoryStatementDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateInventoryStatementDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateInventoryStatementDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateInventoryStatementDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportInventoryStatementAssets(body: InventoryStatementInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/ExportInventoryStatementAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportInventoryStatementAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportInventoryStatementAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportInventoryStatementAssets(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getUpdateCassationsAssets(): Observable<CassateItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetUpdateCassationsAssets";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateCassationsAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateCassationsAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CassateItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CassateItemDto[]>;
        }));
    }

    protected processGetUpdateCassationsAssets(response: HttpResponseBase): Observable<CassateItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CassateItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CassateItemDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportUpdateCassationAssets(body: string[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/ExportUpdateCassationAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportUpdateCassationAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportUpdateCassationAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportUpdateCassationAssets(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getUpdateCassationDetails(): Observable<DocumentDetails> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetUpdateCassationDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateCassationDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateCassationDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDetails>;
        }));
    }

    protected processGetUpdateCassationDetails(response: HttpResponseBase): Observable<DocumentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDetails>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateUpdateCassationDocument(body: GenerateDocumentDefaultInputAssetsList | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/GenerateUpdateCassationDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateUpdateCassationDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateUpdateCassationDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateUpdateCassationDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param beneficiaryId (optional) 
     * @return Success
     */
    getBeneficiaryAssetsStatementDetails(beneficiaryId: string | undefined): Observable<DocumentDetails> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetBeneficiaryAssetsStatementDetails?";
        if (beneficiaryId === null)
            throw new Error("The parameter 'beneficiaryId' cannot be null.");
        else if (beneficiaryId !== undefined)
            url_ += "beneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBeneficiaryAssetsStatementDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeneficiaryAssetsStatementDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentDetails>;
        }));
    }

    protected processGetBeneficiaryAssetsStatementDetails(response: HttpResponseBase): Observable<DocumentDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDetails>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateBeneficiaryAssetsStatementDocument(body: GenerateDocumentInputBeneficiaryAssets | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Document/GenerateBeneficiaryAssetsStatementDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateBeneficiaryAssetsStatementDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateBeneficiaryAssetsStatementDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGenerateBeneficiaryAssetsStatementDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class DocumentHistoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getDocumentHistories(skip: number | undefined, take: number | undefined): Observable<DocumentHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DocumentHistory/GetDocumentHistories?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentHistories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentHistories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DocumentHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DocumentHistoryDto[]>;
        }));
    }

    protected processGetDocumentHistories(response: HttpResponseBase): Observable<DocumentHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(DocumentHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentHistoryDto[]>(null as any);
    }

    /**
     * @param documentIds (optional) 
     * @return Success
     */
    deleteDocuments(documentIds: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DocumentHistory/DeleteDocuments?";
        if (documentIds !== undefined && documentIds !== null)
            documentIds && documentIds.forEach(item => { url_ += "documentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocuments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    exportExcel(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/DocumentHistory/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    upload(file: FileParameter | undefined): Observable<UploadResultDto> {
        let url_ = this.baseUrl + "/api/File/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadResultDto>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<UploadResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadResultDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    remove(fileId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/Remove?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param t (optional) 
     * @return Success
     */
    get(fileId: string | undefined, t: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/Get?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        if (t !== undefined && t !== null)
            url_ += "t=" + encodeURIComponent("" + t) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param reportName (optional) 
     * @param fileMimeType (optional) 
     * @return Success
     */
    getTempReport(id: string | null | undefined, reportName: string | null | undefined, fileMimeType: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/GetTempReport?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (reportName !== undefined && reportName !== null)
            url_ += "reportName=" + encodeURIComponent("" + reportName) + "&";
        if (fileMimeType !== undefined && fileMimeType !== null)
            url_ += "fileMimeType=" + encodeURIComponent("" + fileMimeType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTempReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTempReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetTempReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    fileView(fileId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/File/FileView?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileView(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MaintenanceOperationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<MaintenanceOperationDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceOperation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceOperationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MaintenanceOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaintenanceOperationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMaintenanceOperationDto | undefined): Observable<MaintenanceOperationDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceOperation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceOperationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MaintenanceOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaintenanceOperationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceOperation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMaintenanceOperationDto | undefined): Observable<MaintenanceOperationDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceOperation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceOperationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceOperationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MaintenanceOperationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceOperationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaintenanceOperationDto>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param includeInactives (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFiltered(filter: string | null | undefined, includeInactives: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MaintenanceOperationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceOperation/GetAllFiltered?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (includeInactives === null)
            throw new Error("The parameter 'includeInactives' cannot be null.");
        else if (includeInactives !== undefined)
            url_ += "IncludeInactives=" + encodeURIComponent("" + includeInactives) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFiltered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFiltered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceOperationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceOperationDto[]>;
        }));
    }

    protected processGetAllFiltered(response: HttpResponseBase): Observable<MaintenanceOperationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(MaintenanceOperationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaintenanceOperationDto[]>(null as any);
    }

    /**
     * @param filter (optional) 
     * @param includeInactives (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | null | undefined, includeInactives: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MaintenanceOperationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceOperation/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (includeInactives === null)
            throw new Error("The parameter 'includeInactives' cannot be null.");
        else if (includeInactives !== undefined)
            url_ += "IncludeInactives=" + encodeURIComponent("" + includeInactives) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceOperationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceOperationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MaintenanceOperationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceOperationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MaintenanceOperationDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class OnPremiseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAPIVersion(): Observable<string> {
        let url_ = this.baseUrl + "/api/OnPremise/GetAPIVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAPIVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAPIVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetAPIVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param localKey (optional) 
     * @return Success
     */
    getLatestVersion(localKey: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/OnPremise/GetLatestVersion?";
        if (localKey !== undefined && localKey !== null)
            url_ += "localKey=" + encodeURIComponent("" + localKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLatestVersion(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getLicenseExpirationMessage(): Observable<OnPremiseExpirationStatus> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/GetLicenseExpirationMessage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenseExpirationMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenseExpirationMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnPremiseExpirationStatus>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnPremiseExpirationStatus>;
        }));
    }

    protected processGetLicenseExpirationMessage(response: HttpResponseBase): Observable<OnPremiseExpirationStatus> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnPremiseExpirationStatus.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnPremiseExpirationStatus>(null as any);
    }

    /**
     * @return Success
     */
    getLicenseInfo(): Observable<OnPremiseLicenseInfo> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/GetLicenseInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLicenseInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLicenseInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OnPremiseLicenseInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OnPremiseLicenseInfo>;
        }));
    }

    protected processGetLicenseInfo(response: HttpResponseBase): Observable<OnPremiseLicenseInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnPremiseLicenseInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OnPremiseLicenseInfo>(null as any);
    }

    /**
     * @return Success
     */
    getNewVersionUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/GetNewVersionUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewVersionUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewVersionUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetNewVersionUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    setNewKey(key: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/SetNewKey?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNewKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNewKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNewKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getKeys(): Observable<ExternalClientDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/GetKeys";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKeys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKeys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalClientDto[]>;
        }));
    }

    protected processGetKeys(response: HttpResponseBase): Observable<ExternalClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalClientDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateKey(body: GenerateKeyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/GenerateKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    getTenantInfoFromLocalKey(key: string | null | undefined): Observable<ExternalTenantInfo> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/GetTenantInfoFromLocalKey?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantInfoFromLocalKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantInfoFromLocalKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalTenantInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalTenantInfo>;
        }));
    }

    protected processGetTenantInfoFromLocalKey(response: HttpResponseBase): Observable<ExternalTenantInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalTenantInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalTenantInfo>(null as any);
    }

    /**
     * @return Success
     */
    getLocalInstallUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/GetLocalInstallUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLocalInstallUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLocalInstallUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLocalInstallUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @return Success
     */
    getTenantProfile(): Observable<TenantProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/GetTenantProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantProfileDto>;
        }));
    }

    protected processGetTenantProfile(response: HttpResponseBase): Observable<TenantProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantProfileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantProfile(body: TenantProfileDto | undefined): Observable<TenantProfileDto> {
        let url_ = this.baseUrl + "/api/services/app/OnPremise/UpdateTenantProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantProfileDto>;
        }));
    }

    protected processUpdateTenantProfile(response: HttpResponseBase): Observable<TenantProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantProfileDto>(null as any);
    }
}

@Injectable()
export class PhysicalItemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PhysicalItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalItem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalItemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PhysicalItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalItemDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteInventory(id: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalItem/DeleteInventory?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteInventory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteInventory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDeleteInventory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePhysicalItemDto | undefined): Observable<PhysicalItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalItem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalItemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PhysicalItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePhysicalItemDto | undefined): Observable<PhysicalItemDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalItem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalItemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PhysicalItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalItemDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bindAll(body: BindPhysicalAssetItemDto[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalItem/BindAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBindAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBindAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBindAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PhysicalItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalItem/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PhysicalItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalItemDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalItem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PhysicalLocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFiltered(filter: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PhysicalLocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/GetAllFiltered?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFiltered(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFiltered(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalLocationDto[]>;
        }));
    }

    protected processGetAllFiltered(response: HttpResponseBase): Observable<PhysicalLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PhysicalLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalLocationDto[]>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PhysicalLocationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalLocationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalLocationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PhysicalLocationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalLocationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalLocationDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<PhysicalLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalLocationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PhysicalLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalLocationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePhysicalLocationDto | undefined): Observable<PhysicalLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalLocationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PhysicalLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalLocationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePhysicalLocationDto | undefined): Observable<PhysicalLocationDto> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalLocationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalLocationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PhysicalLocationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalLocationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalLocationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    exportExcell(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/ExportExcell";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcell(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    import(body: PhysicalLocationImportItemImportItemsInput | undefined): Observable<PhysicalLocationImportItemImportItemsResult> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalLocationImportItemImportItemsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalLocationImportItemImportItemsResult>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<PhysicalLocationImportItemImportItemsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhysicalLocationImportItemImportItemsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalLocationImportItemImportItemsResult>(null as any);
    }

    /**
     * @param latitude (optional) 
     * @param longitude (optional) 
     * @return Success
     */
    getAllNearby(latitude: number | undefined, longitude: number | undefined): Observable<PhysicalLocationLimitsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/GetAllNearby?";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNearby(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNearby(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalLocationLimitsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalLocationLimitsDto[]>;
        }));
    }

    protected processGetAllNearby(response: HttpResponseBase): Observable<PhysicalLocationLimitsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PhysicalLocationLimitsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalLocationLimitsDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getAllUnrestricted(): Observable<PhysicalLocationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/GetAllUnrestricted";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnrestricted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnrestricted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalLocationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalLocationDto[]>;
        }));
    }

    protected processGetAllUnrestricted(response: HttpResponseBase): Observable<PhysicalLocationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PhysicalLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalLocationDto[]>(null as any);
    }

    /**
     * @param pdiList (optional) 
     * @return Success
     */
    deleteList(pdiList: string[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhysicalLocation/DeleteList?";
        if (pdiList !== undefined && pdiList !== null)
            pdiList && pdiList.forEach(item => { url_ += "pdiList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteList(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RepairServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<RepairDto> {
        let url_ = this.baseUrl + "/api/services/app/Repair/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairDto>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @param startRepairDate (optional) 
     * @param endRepairDate (optional) 
     * @return Success
     */
    getLastRepair(assetId: string | undefined, startRepairDate: moment.Moment | undefined, endRepairDate: moment.Moment | undefined): Observable<RepairDto> {
        let url_ = this.baseUrl + "/api/services/app/Repair/GetLastRepair?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (startRepairDate === null)
            throw new Error("The parameter 'startRepairDate' cannot be null.");
        else if (startRepairDate !== undefined)
            url_ += "startRepairDate=" + encodeURIComponent(startRepairDate ? "" + startRepairDate.toISOString() : "") + "&";
        if (endRepairDate === null)
            throw new Error("The parameter 'endRepairDate' cannot be null.");
        else if (endRepairDate !== undefined)
            url_ += "endRepairDate=" + encodeURIComponent(endRepairDate ? "" + endRepairDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastRepair(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastRepair(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairDto>;
        }));
    }

    protected processGetLastRepair(response: HttpResponseBase): Observable<RepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRepairDto | undefined): Observable<RepairDto> {
        let url_ = this.baseUrl + "/api/services/app/Repair/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateRepairDto | undefined): Observable<RepairDto> {
        let url_ = this.baseUrl + "/api/services/app/Repair/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RepairDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairDto>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getAssetRepairHistory(assetId: string | undefined, skip: number | undefined, take: number | undefined): Observable<AssetRepairHistory[]> {
        let url_ = this.baseUrl + "/api/services/app/Repair/GetAssetRepairHistory?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetRepairHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetRepairHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRepairHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRepairHistory[]>;
        }));
    }

    protected processGetAssetRepairHistory(response: HttpResponseBase): Observable<AssetRepairHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetRepairHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRepairHistory[]>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    exportRepairHistory(assetId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Repair/ExportRepairHistory?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRepairHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRepairHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportRepairHistory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    getRepairInstructionsFiles(assetId: string | undefined): Observable<RepairFileDetails[]> {
        let url_ = this.baseUrl + "/api/services/app/Repair/GetRepairInstructionsFiles?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepairInstructionsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepairInstructionsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairFileDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairFileDetails[]>;
        }));
    }

    protected processGetRepairInstructionsFiles(response: HttpResponseBase): Observable<RepairFileDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RepairFileDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairFileDetails[]>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<RepairDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Repair/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RepairDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Repair/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RepairFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<RepairFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RepairFile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairFileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RepairFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairFileDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<RepairFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RepairFile/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairFileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairFileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RepairFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairFileDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: RepairFileDto | undefined): Observable<RepairFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RepairFile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairFileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RepairFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairFileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RepairFileDto | undefined): Observable<RepairFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RepairFile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairFileDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RepairFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RepairFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairFileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RepairFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RevisionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<RevisionDto> {
        let url_ = this.baseUrl + "/api/services/app/Revision/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RevisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionDto>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @param maintenanceId (optional) 
     * @param maintenanceOperationId (optional) 
     * @param startRevisionDate (optional) 
     * @param endRevisionDate (optional) 
     * @return Success
     */
    getLastRevision(assetId: string | undefined, maintenanceId: string | undefined, maintenanceOperationId: string | null | undefined, startRevisionDate: moment.Moment | undefined, endRevisionDate: moment.Moment | undefined): Observable<RevisionDto> {
        let url_ = this.baseUrl + "/api/services/app/Revision/GetLastRevision?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (maintenanceId === null)
            throw new Error("The parameter 'maintenanceId' cannot be null.");
        else if (maintenanceId !== undefined)
            url_ += "maintenanceId=" + encodeURIComponent("" + maintenanceId) + "&";
        if (maintenanceOperationId !== undefined && maintenanceOperationId !== null)
            url_ += "maintenanceOperationId=" + encodeURIComponent("" + maintenanceOperationId) + "&";
        if (startRevisionDate === null)
            throw new Error("The parameter 'startRevisionDate' cannot be null.");
        else if (startRevisionDate !== undefined)
            url_ += "startRevisionDate=" + encodeURIComponent(startRevisionDate ? "" + startRevisionDate.toISOString() : "") + "&";
        if (endRevisionDate === null)
            throw new Error("The parameter 'endRevisionDate' cannot be null.");
        else if (endRevisionDate !== undefined)
            url_ += "endRevisionDate=" + encodeURIComponent(endRevisionDate ? "" + endRevisionDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionDto>;
        }));
    }

    protected processGetLastRevision(response: HttpResponseBase): Observable<RevisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRevisionDto | undefined): Observable<RevisionDto> {
        let url_ = this.baseUrl + "/api/services/app/Revision/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RevisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateRevisionDto | undefined): Observable<RevisionDto> {
        let url_ = this.baseUrl + "/api/services/app/Revision/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RevisionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionDto>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getAssetRevisionHistory(assetId: string | undefined, skip: number | undefined, take: number | undefined): Observable<AssetRevisionHistory[]> {
        let url_ = this.baseUrl + "/api/services/app/Revision/GetAssetRevisionHistory?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetRevisionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetRevisionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRevisionHistory[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRevisionHistory[]>;
        }));
    }

    protected processGetAssetRevisionHistory(response: HttpResponseBase): Observable<AssetRevisionHistory[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetRevisionHistory.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRevisionHistory[]>(null as any);
    }

    /**
     * @param assetId (optional) 
     * @return Success
     */
    exportRevisionHistory(assetId: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Revision/ExportRevisionHistory?";
        if (assetId === null)
            throw new Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRevisionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRevisionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportRevisionHistory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param assetMaintenanceId (optional) 
     * @return Success
     */
    getRevisionInstructionsFiles(assetMaintenanceId: string | undefined): Observable<RevisionFileDetails[]> {
        let url_ = this.baseUrl + "/api/services/app/Revision/GetRevisionInstructionsFiles?";
        if (assetMaintenanceId === null)
            throw new Error("The parameter 'assetMaintenanceId' cannot be null.");
        else if (assetMaintenanceId !== undefined)
            url_ += "assetMaintenanceId=" + encodeURIComponent("" + assetMaintenanceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisionInstructionsFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisionInstructionsFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionFileDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionFileDetails[]>;
        }));
    }

    protected processGetRevisionInstructionsFiles(response: HttpResponseBase): Observable<RevisionFileDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RevisionFileDetails.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionFileDetails[]>(null as any);
    }

    /**
     * @param revisionId (optional) 
     * @return Success
     */
    getRevisionTasks(revisionId: string | undefined): Observable<RevisionTaskDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Revision/GetRevisionTasks?";
        if (revisionId === null)
            throw new Error("The parameter 'revisionId' cannot be null.");
        else if (revisionId !== undefined)
            url_ += "revisionId=" + encodeURIComponent("" + revisionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisionTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisionTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionTaskDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionTaskDto[]>;
        }));
    }

    protected processGetRevisionTasks(response: HttpResponseBase): Observable<RevisionTaskDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RevisionTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionTaskDto[]>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<RevisionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Revision/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RevisionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Revision/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RevisionFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<RevisionFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RevisionFile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionFileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RevisionFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionFileDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<RevisionFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RevisionFile/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionFileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionFileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RevisionFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionFileDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: RevisionFileDto | undefined): Observable<RevisionFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RevisionFile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionFileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RevisionFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionFileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RevisionFileDto | undefined): Observable<RevisionFileDto> {
        let url_ = this.baseUrl + "/api/services/app/RevisionFile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionFileDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RevisionFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RevisionFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionFileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RevisionFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined && permission !== null)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ScanningReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param filter (optional) 
     * @param status (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getIdentifiedReport(skip: number | undefined, take: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, filter: string | null | undefined, status: number | null | undefined, costCenters: string[] | null | undefined): Observable<PhysicalItemReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetIdentifiedReport?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIdentifiedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIdentifiedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalItemReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalItemReportDto[]>;
        }));
    }

    protected processGetIdentifiedReport(response: HttpResponseBase): Observable<PhysicalItemReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PhysicalItemReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalItemReportDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellIdentified(body: IdentifiedInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellIdentified";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellIdentified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellIdentified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellIdentified(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param physicalLocationId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getNotFoundReport(skip: number | undefined, take: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, physicalLocationId: string | null | undefined, costCenters: string[] | null | undefined): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetNotFoundReport?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotFoundReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotFoundReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processGetNotFoundReport(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param physicalLocationId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getNotFoundReportCount(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, physicalLocationId: string | null | undefined, costCenters: string[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetNotFoundReportCount?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotFoundReportCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotFoundReportCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNotFoundReportCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param physicalLocationId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getNotRevisedReport(skip: number | undefined, take: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, physicalLocationId: string | null | undefined, costCenters: string[] | null | undefined): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetNotRevisedReport?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotRevisedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotRevisedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processGetNotRevisedReport(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto[]>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param physicalLocationId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getNotRepairedReport(skip: number | undefined, take: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, physicalLocationId: string | null | undefined, costCenters: string[] | null | undefined): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetNotRepairedReport?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotRepairedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotRepairedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processGetNotRepairedReport(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param filter (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getRevisedAssets(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, filter: string | null | undefined, skip: number | undefined, take: number | undefined): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRevisedAssets?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisedAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisedAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processGetRevisedAssets(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto[]>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param physicalLocationId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getPlanningForRevisionAssets(skip: number | undefined, take: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, physicalLocationId: string | null | undefined, userId: number | null | undefined): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetPlanningForRevisionAssets?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanningForRevisionAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanningForRevisionAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processGetPlanningForRevisionAssets(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto[]>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param physicalLocationId (optional) 
     * @param userId (optional) 
     * @return Success
     */
    getPlanningForRepairAssets(skip: number | undefined, take: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, physicalLocationId: string | null | undefined, userId: number | null | undefined): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetPlanningForRepairAssets?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanningForRepairAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanningForRepairAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processGetPlanningForRepairAssets(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param filter (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getRepairedAssets(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, filter: string | null | undefined, skip: number | undefined, take: number | undefined): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRepairedAssets?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepairedAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepairedAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processGetRepairedAssets(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellNotFound(body: NotFoundInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellNotFound";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellNotFound(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellNotFound(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellNotFound(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param comment (optional) 
     * @param physicalLocationId (optional) 
     * @return Success
     */
    getNotIdentifiedReport(skip: number | undefined, take: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, comment: string | null | undefined, physicalLocationId: string | null | undefined): Observable<PhysicalItemNIReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetNotIdentifiedReport?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (comment !== undefined && comment !== null)
            url_ += "Comment=" + encodeURIComponent("" + comment) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotIdentifiedReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotIdentifiedReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhysicalItemNIReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhysicalItemNIReportDto[]>;
        }));
    }

    protected processGetNotIdentifiedReport(response: HttpResponseBase): Observable<PhysicalItemNIReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PhysicalItemNIReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PhysicalItemNIReportDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellNotIdentified(body: NotIdentifiedInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellNotIdentified";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellNotIdentified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellNotIdentified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellNotIdentified(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAutoReconciliationReport(body: BindPhysicalAssetItemDto[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportAutoReconciliationReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAutoReconciliationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAutoReconciliationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportAutoReconciliationReport(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param sortByField (optional) 
     * @param sortDirection (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param includeOutdated (optional) 
     * @param userId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getRevisionReport(skip: number | undefined, take: number | undefined, sortByField: string | null | undefined, sortDirection: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, includeOutdated: boolean | undefined, userId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<AssetRevisionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRevisionReport?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (sortByField !== undefined && sortByField !== null)
            url_ += "SortByField=" + encodeURIComponent("" + sortByField) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (includeOutdated === null)
            throw new Error("The parameter 'includeOutdated' cannot be null.");
        else if (includeOutdated !== undefined)
            url_ += "IncludeOutdated=" + encodeURIComponent("" + includeOutdated) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisionReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisionReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRevisionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRevisionDto[]>;
        }));
    }

    protected processGetRevisionReport(response: HttpResponseBase): Observable<AssetRevisionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetRevisionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRevisionDto[]>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param sortByField (optional) 
     * @param sortDirection (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param includeOutdated (optional) 
     * @param userId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getAssetsToMarkForRevision(skip: number | undefined, take: number | undefined, sortByField: string | null | undefined, sortDirection: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, includeOutdated: boolean | undefined, userId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<AssetRevisionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetAssetsToMarkForRevision?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (sortByField !== undefined && sortByField !== null)
            url_ += "SortByField=" + encodeURIComponent("" + sortByField) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (includeOutdated === null)
            throw new Error("The parameter 'includeOutdated' cannot be null.");
        else if (includeOutdated !== undefined)
            url_ += "IncludeOutdated=" + encodeURIComponent("" + includeOutdated) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetsToMarkForRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetsToMarkForRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRevisionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRevisionDto[]>;
        }));
    }

    protected processGetAssetsToMarkForRevision(response: HttpResponseBase): Observable<AssetRevisionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetRevisionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRevisionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellRevision(body: RevisionInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellRevision";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellRevision(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellRevision(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellRevision(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadStructuredFiles(body: StructuredParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/DownloadStructuredFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadStructuredFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadStructuredFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDownloadStructuredFiles(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportRevisionDocuments(body: RevisionInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportRevisionDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRevisionDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRevisionDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportRevisionDocuments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param agentId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getRevisionUserHistoryReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, agentId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<RevisionUser[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRevisionUserHistoryReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisionUserHistoryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisionUserHistoryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionUser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionUser[]>;
        }));
    }

    protected processGetRevisionUserHistoryReport(response: HttpResponseBase): Observable<RevisionUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RevisionUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionUser[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param agentId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getRevisionPDIHistoryReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, agentId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<RevisionPDI[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRevisionPDIHistoryReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisionPDIHistoryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisionPDIHistoryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionPDI[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionPDI[]>;
        }));
    }

    protected processGetRevisionPDIHistoryReport(response: HttpResponseBase): Observable<RevisionPDI[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RevisionPDI.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionPDI[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param agentId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getRevisionAssetHistoryReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, agentId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<RevisionAsset[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRevisionAssetHistoryReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevisionAssetHistoryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevisionAssetHistoryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevisionAsset[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevisionAsset[]>;
        }));
    }

    protected processGetRevisionAssetHistoryReport(response: HttpResponseBase): Observable<RevisionAsset[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RevisionAsset.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevisionAsset[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param agentId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getRepairAssetHistoryReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, agentId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<RepairAsset[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRepairAssetHistoryReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepairAssetHistoryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepairAssetHistoryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairAsset[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairAsset[]>;
        }));
    }

    protected processGetRepairAssetHistoryReport(response: HttpResponseBase): Observable<RepairAsset[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RepairAsset.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairAsset[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellRevisionHistory(body: RevisionHistoryInputParamsGroup | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellRevisionHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellRevisionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellRevisionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellRevisionHistory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellRevisionHistoryAnalytic(body: RevisionHistoryInputParamsGroup | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellRevisionHistoryAnalytic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellRevisionHistoryAnalytic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellRevisionHistoryAnalytic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellRevisionHistoryAnalytic(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellRepairHistory(body: RevisionHistoryInputParamsGroup | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellRepairHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellRepairHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellRepairHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellRepairHistory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellRepairHistoryAnalytic(body: RevisionHistoryInputParamsGroup | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellRepairHistoryAnalytic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellRepairHistoryAnalytic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellRepairHistoryAnalytic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellRepairHistoryAnalytic(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return Success
     */
    exportAssetRevisionHistory(userId: number | null | undefined, body: RevisionUserPDIAsset[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportAssetRevisionHistory?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAssetRevisionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAssetRevisionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportAssetRevisionHistory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param agentId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getAssetRevisionsHistoryReport(skip: number | undefined, take: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, agentId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<AssetRevisionHistoryItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetAssetRevisionsHistoryReport?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetRevisionsHistoryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetRevisionsHistoryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRevisionHistoryItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRevisionHistoryItemDto[]>;
        }));
    }

    protected processGetAssetRevisionsHistoryReport(response: HttpResponseBase): Observable<AssetRevisionHistoryItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetRevisionHistoryItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRevisionHistoryItemDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mapToEntityDto(body: AssetRevisionHistoryItem | undefined): Observable<AssetRevisionHistoryItemDto> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/MapToEntityDto";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMapToEntityDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMapToEntityDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRevisionHistoryItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRevisionHistoryItemDto>;
        }));
    }

    protected processMapToEntityDto(response: HttpResponseBase): Observable<AssetRevisionHistoryItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetRevisionHistoryItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRevisionHistoryItemDto>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param sortByField (optional) 
     * @param sortDirection (optional) 
     * @param assetName (optional) 
     * @param maintenanceOnlyAssets (optional) 
     * @return Success
     */
    getAllAssets(skip: number | undefined, take: number | undefined, sortByField: string | null | undefined, sortDirection: number | undefined, assetName: string | null | undefined, maintenanceOnlyAssets: boolean | undefined): Observable<AssetDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetAllAssets?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (sortByField !== undefined && sortByField !== null)
            url_ += "SortByField=" + encodeURIComponent("" + sortByField) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (maintenanceOnlyAssets === null)
            throw new Error("The parameter 'maintenanceOnlyAssets' cannot be null.");
        else if (maintenanceOnlyAssets !== undefined)
            url_ += "MaintenanceOnlyAssets=" + encodeURIComponent("" + maintenanceOnlyAssets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto[]>;
        }));
    }

    protected processGetAllAssets(response: HttpResponseBase): Observable<AssetDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetDto[]>(null as any);
    }

    /**
     * @param name (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param costCenterIds (optional) 
     * @param category (optional) 
     * @param groupCostCenter (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getStocks(name: string | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, costCenterIds: string[] | null | undefined, category: number | null | undefined, groupCostCenter: boolean | undefined, skip: number | undefined, take: number | undefined): Observable<StockConfigDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetStocks?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (costCenterIds !== undefined && costCenterIds !== null)
            costCenterIds && costCenterIds.forEach(item => { url_ += "CostCenterIds=" + encodeURIComponent("" + item) + "&"; });
        if (category !== undefined && category !== null)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (groupCostCenter === null)
            throw new Error("The parameter 'groupCostCenter' cannot be null.");
        else if (groupCostCenter !== undefined)
            url_ += "GroupCostCenter=" + encodeURIComponent("" + groupCostCenter) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStocks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStocks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockConfigDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockConfigDto[]>;
        }));
    }

    protected processGetStocks(response: HttpResponseBase): Observable<StockConfigDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(StockConfigDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StockConfigDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportStocksExcel(body: StocksInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportStocksExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportStocksExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportStocksExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportStocksExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param sortByField (optional) 
     * @param sortDirection (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param includeOutdated (optional) 
     * @param userId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getRepairReport(skip: number | undefined, take: number | undefined, sortByField: string | null | undefined, sortDirection: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, includeOutdated: boolean | undefined, userId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<AssetRepairDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRepairReport?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (sortByField !== undefined && sortByField !== null)
            url_ += "SortByField=" + encodeURIComponent("" + sortByField) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (includeOutdated === null)
            throw new Error("The parameter 'includeOutdated' cannot be null.");
        else if (includeOutdated !== undefined)
            url_ += "IncludeOutdated=" + encodeURIComponent("" + includeOutdated) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepairReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepairReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRepairDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRepairDto[]>;
        }));
    }

    protected processGetRepairReport(response: HttpResponseBase): Observable<AssetRepairDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetRepairDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRepairDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcellRepair(body: RevisionInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcellRepair";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcellRepair(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcellRepair(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcellRepair(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportRepairDocuments(body: RevisionInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportRepairDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportRepairDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportRepairDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportRepairDocuments(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param skip (optional) 
     * @param take (optional) 
     * @param sortByField (optional) 
     * @param sortDirection (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param includeOutdated (optional) 
     * @param userId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getAssetsToMarkForRepair(skip: number | undefined, take: number | undefined, sortByField: string | null | undefined, sortDirection: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, includeOutdated: boolean | undefined, userId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<AssetRepairDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetAssetsToMarkForRepair?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        if (sortByField !== undefined && sortByField !== null)
            url_ += "SortByField=" + encodeURIComponent("" + sortByField) + "&";
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "SortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (includeOutdated === null)
            throw new Error("The parameter 'includeOutdated' cannot be null.");
        else if (includeOutdated !== undefined)
            url_ += "IncludeOutdated=" + encodeURIComponent("" + includeOutdated) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetsToMarkForRepair(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetsToMarkForRepair(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetRepairDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetRepairDto[]>;
        }));
    }

    protected processGetAssetsToMarkForRepair(response: HttpResponseBase): Observable<AssetRepairDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetRepairDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetRepairDto[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param agentId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getRepairUserHistoryReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, agentId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<RepairUser[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRepairUserHistoryReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepairUserHistoryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepairUserHistoryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairUser[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairUser[]>;
        }));
    }

    protected processGetRepairUserHistoryReport(response: HttpResponseBase): Observable<RepairUser[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RepairUser.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairUser[]>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param assetName (optional) 
     * @param agentId (optional) 
     * @param physicalLocationId (optional) 
     * @param planningUserId (optional) 
     * @param costCenters (optional) 
     * @return Success
     */
    getRepairPDIHistoryReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, assetName: string | null | undefined, agentId: number | null | undefined, physicalLocationId: string | null | undefined, planningUserId: number | null | undefined, costCenters: string[] | null | undefined): Observable<RepairPDI[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetRepairPDIHistoryReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (assetName !== undefined && assetName !== null)
            url_ += "AssetName=" + encodeURIComponent("" + assetName) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (physicalLocationId !== undefined && physicalLocationId !== null)
            url_ += "PhysicalLocationId=" + encodeURIComponent("" + physicalLocationId) + "&";
        if (planningUserId !== undefined && planningUserId !== null)
            url_ += "PlanningUserId=" + encodeURIComponent("" + planningUserId) + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRepairPDIHistoryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRepairPDIHistoryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RepairPDI[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RepairPDI[]>;
        }));
    }

    protected processGetRepairPDIHistoryReport(response: HttpResponseBase): Observable<RepairPDI[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RepairPDI.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RepairPDI[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportAssetRepairHistory(body: RepairUserPDIAsset[] | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportAssetRepairHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportAssetRepairHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportAssetRepairHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportAssetRepairHistory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBeneficiaryAssets(body: GetBeneficiaryAssetsInput | undefined): Observable<BeneficiaryReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetBeneficiaryAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBeneficiaryAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeneficiaryAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeneficiaryReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeneficiaryReportDto[]>;
        }));
    }

    protected processGetBeneficiaryAssets(response: HttpResponseBase): Observable<BeneficiaryReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BeneficiaryReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeneficiaryReportDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportBeneficiaryAssets(body: GetBeneficiaryAssetsInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportBeneficiaryAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportBeneficiaryAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportBeneficiaryAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportBeneficiaryAssets(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param name (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param costCenters (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getAssetsHistory(name: string | null | undefined, startDate: moment.Moment | null | undefined, endDate: moment.Moment | null | undefined, costCenters: string[] | null | undefined, skip: number | undefined, take: number | undefined): Observable<AssetHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/GetAssetsHistory?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (costCenters !== undefined && costCenters !== null)
            costCenters && costCenters.forEach(item => { url_ += "CostCenters=" + encodeURIComponent("" + item) + "&"; });
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetHistoryDto[]>;
        }));
    }

    protected processGetAssetsHistory(response: HttpResponseBase): Observable<AssetHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AssetHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssetHistoryDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportExcelAssetsHistory(body: AssetsHistoryInputParams | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/ScanningReport/ExportExcelAssetsHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcelAssetsHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcelAssetsHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcelAssetsHistory(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }
}

@Injectable()
export class SettingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getSettings(): Observable<SettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/Setting/GetSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SettingsDto>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<SettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSettingDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Setting/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }

    /**
     * @param tenancyName (optional) 
     * @param tenantSelected (optional) 
     * @return Success
     */
    resetPassword(userNameOrEmailAddress: string, tenancyName: string | null | undefined, tenantSelected: boolean | undefined): Observable<ResetPasswordResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/ResetPassword?";
        if (userNameOrEmailAddress === undefined || userNameOrEmailAddress === null)
            throw new Error("The parameter 'userNameOrEmailAddress' must be defined and cannot be null.");
        else
            url_ += "UserNameOrEmailAddress=" + encodeURIComponent("" + userNameOrEmailAddress) + "&";
        if (tenancyName !== undefined && tenancyName !== null)
            url_ += "TenancyName=" + encodeURIComponent("" + tenancyName) + "&";
        if (tenantSelected === null)
            throw new Error("The parameter 'tenantSelected' cannot be null.");
        else if (tenantSelected !== undefined)
            url_ += "TenantSelected=" + encodeURIComponent("" + tenantSelected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResult>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResult>(null as any);
    }

    /**
     * @param passwordResetCode (optional) 
     * @param newPassword (optional) 
     * @return Success
     */
    resetPasswordWithCode(passwordResetCode: string | null | undefined, newPassword: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/ResetPasswordWithCode?";
        if (passwordResetCode !== undefined && passwordResetCode !== null)
            url_ += "PasswordResetCode=" + encodeURIComponent("" + passwordResetCode) + "&";
        if (newPassword !== undefined && newPassword !== null)
            url_ += "NewPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordWithCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordWithCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPasswordWithCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getUser(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAdminId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAdminId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAdminId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAdminId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetAdminId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getUsersWithPermission(permission: string | null | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersWithPermission?";
        if (permission !== undefined && permission !== null)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersWithPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersWithPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUsersWithPermission(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param withAllCurrentUserCenters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, withAllCurrentUserCenters: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword !== undefined && keyword !== null)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (withAllCurrentUserCenters === null)
            throw new Error("The parameter 'withAllCurrentUserCenters' cannot be null.");
        else if (withAllCurrentUserCenters !== undefined)
            url_ += "WithAllCurrentUserCenters=" + encodeURIComponent("" + withAllCurrentUserCenters) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    exportExcel(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/User/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processExportExcel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    tenancyName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.tenancyName = _data["tenancyName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["tenancyName"] = this.tenancyName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    tenancyName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class AlertDto implements IAlertDto {
    type: number;
    email: string | undefined;
    id: string;

    constructor(data?: IAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }

    clone(): AlertDto {
        const json = this.toJSON();
        let result = new AlertDto();
        result.init(json);
        return result;
    }
}

export interface IAlertDto {
    type: number;
    email: string | undefined;
    id: string;
}

export class AlertDtoPagedResultDto implements IAlertDtoPagedResultDto {
    totalCount: number;
    items: AlertDto[] | undefined;

    constructor(data?: IAlertDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AlertDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): AlertDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AlertDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAlertDtoPagedResultDto {
    totalCount: number;
    items: AlertDto[] | undefined;
}

export class CreateAlertDto implements ICreateAlertDto {
    type: number;
    email: string | undefined;

    constructor(data?: ICreateAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["email"] = this.email;
        return data;
    }

    clone(): CreateAlertDto {
        const json = this.toJSON();
        let result = new CreateAlertDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAlertDto {
    type: number;
    email: string | undefined;
}

export class UpdateAlertDto implements IUpdateAlertDto {
    type: number;
    email: string | undefined;
    id: string;

    constructor(data?: IUpdateAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateAlertDto {
        const json = this.toJSON();
        let result = new UpdateAlertDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAlertDto {
    type: number;
    email: string | undefined;
    id: string;
}

export class CostCenterDto implements ICostCenterDto {
    name: string | undefined;
    description: string | undefined;
    id: string;

    constructor(data?: ICostCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CostCenterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): CostCenterDto {
        const json = this.toJSON();
        let result = new CostCenterDto();
        result.init(json);
        return result;
    }
}

export interface ICostCenterDto {
    name: string | undefined;
    description: string | undefined;
    id: string;
}

export class PhysicalLocationDto implements IPhysicalLocationDto {
    name: string | undefined;
    latitude: number;
    longitude: number;
    address: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    selected: boolean;
    id: string;

    constructor(data?: IPhysicalLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.selected = _data["selected"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PhysicalLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["selected"] = this.selected;
        data["id"] = this.id;
        return data;
    }

    clone(): PhysicalLocationDto {
        const json = this.toJSON();
        let result = new PhysicalLocationDto();
        result.init(json);
        return result;
    }
}

export interface IPhysicalLocationDto {
    name: string | undefined;
    latitude: number;
    longitude: number;
    address: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    selected: boolean;
    id: string;
}

export class RepairFileDetails implements IRepairFileDetails {
    fileId: string;
    fileName: string | undefined;

    constructor(data?: IRepairFileDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): RepairFileDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RepairFileDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): RepairFileDetails {
        const json = this.toJSON();
        let result = new RepairFileDetails();
        result.init(json);
        return result;
    }
}

export interface IRepairFileDetails {
    fileId: string;
    fileName: string | undefined;
}

export class AssetFileDetails implements IAssetFileDetails {
    fileId: string;
    fileName: string | undefined;
    type: string | undefined;

    constructor(data?: IAssetFileDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): AssetFileDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AssetFileDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["type"] = this.type;
        return data;
    }

    clone(): AssetFileDetails {
        const json = this.toJSON();
        let result = new AssetFileDetails();
        result.init(json);
        return result;
    }
}

export interface IAssetFileDetails {
    fileId: string;
    fileName: string | undefined;
    type: string | undefined;
}

export class BeneficiaryAssetDto implements IBeneficiaryAssetDto {
    name: string | undefined;
    number: string | undefined;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    id: string;

    constructor(data?: IBeneficiaryAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.aquisitionDate = _data["aquisitionDate"] ? moment(_data["aquisitionDate"].toString()) : <any>undefined;
            this.aquisitionValue = _data["aquisitionValue"];
            this.aquisitionRemainingValue = _data["aquisitionRemainingValue"];
            this.linearAmortization = _data["linearAmortization"];
            this.amortizationMonthsStandard = _data["amortizationMonthsStandard"];
            this.amortizationMonthsRemaining = _data["amortizationMonthsRemaining"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BeneficiaryAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["aquisitionDate"] = this.aquisitionDate ? this.aquisitionDate.toISOString() : <any>undefined;
        data["aquisitionValue"] = this.aquisitionValue;
        data["aquisitionRemainingValue"] = this.aquisitionRemainingValue;
        data["linearAmortization"] = this.linearAmortization;
        data["amortizationMonthsStandard"] = this.amortizationMonthsStandard;
        data["amortizationMonthsRemaining"] = this.amortizationMonthsRemaining;
        data["id"] = this.id;
        return data;
    }

    clone(): BeneficiaryAssetDto {
        const json = this.toJSON();
        let result = new BeneficiaryAssetDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryAssetDto {
    name: string | undefined;
    number: string | undefined;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    id: string;
}

export class BeneficiaryDto implements IBeneficiaryDto {
    mark: string | undefined;
    name: string | undefined;
    jobPosition: string | undefined;
    department: string | undefined;
    address: string | undefined;
    idCardSerial: string | undefined;
    idCardNumber: string | undefined;
    idCardProvider: string | undefined;
    idCardProvidedDate: moment.Moment | undefined;
    ssn: string | undefined;
    contractNumber: string | undefined;
    contractDate: moment.Moment | undefined;
    assets: BeneficiaryAssetDto[] | undefined;
    assetCount: number;
    id: string;

    constructor(data?: IBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mark = _data["mark"];
            this.name = _data["name"];
            this.jobPosition = _data["jobPosition"];
            this.department = _data["department"];
            this.address = _data["address"];
            this.idCardSerial = _data["idCardSerial"];
            this.idCardNumber = _data["idCardNumber"];
            this.idCardProvider = _data["idCardProvider"];
            this.idCardProvidedDate = _data["idCardProvidedDate"] ? moment(_data["idCardProvidedDate"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.contractNumber = _data["contractNumber"];
            this.contractDate = _data["contractDate"] ? moment(_data["contractDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets.push(BeneficiaryAssetDto.fromJS(item));
            }
            this.assetCount = _data["assetCount"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mark"] = this.mark;
        data["name"] = this.name;
        data["jobPosition"] = this.jobPosition;
        data["department"] = this.department;
        data["address"] = this.address;
        data["idCardSerial"] = this.idCardSerial;
        data["idCardNumber"] = this.idCardNumber;
        data["idCardProvider"] = this.idCardProvider;
        data["idCardProvidedDate"] = this.idCardProvidedDate ? this.idCardProvidedDate.toISOString() : <any>undefined;
        data["ssn"] = this.ssn;
        data["contractNumber"] = this.contractNumber;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : <any>undefined;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["assetCount"] = this.assetCount;
        data["id"] = this.id;
        return data;
    }

    clone(): BeneficiaryDto {
        const json = this.toJSON();
        let result = new BeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryDto {
    mark: string | undefined;
    name: string | undefined;
    jobPosition: string | undefined;
    department: string | undefined;
    address: string | undefined;
    idCardSerial: string | undefined;
    idCardNumber: string | undefined;
    idCardProvider: string | undefined;
    idCardProvidedDate: moment.Moment | undefined;
    ssn: string | undefined;
    contractNumber: string | undefined;
    contractDate: moment.Moment | undefined;
    assets: BeneficiaryAssetDto[] | undefined;
    assetCount: number;
    id: string;
}

export class RevisionFileDetails implements IRevisionFileDetails {
    fileId: string;
    fileName: string | undefined;

    constructor(data?: IRevisionFileDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): RevisionFileDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionFileDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        return data;
    }

    clone(): RevisionFileDetails {
        const json = this.toJSON();
        let result = new RevisionFileDetails();
        result.init(json);
        return result;
    }
}

export interface IRevisionFileDetails {
    fileId: string;
    fileName: string | undefined;
}

export class AssetMaintenanceDto implements IAssetMaintenanceDto {
    assetId: string;
    maintenanceOperationId: string | undefined;
    maintenanceFrequencyType: number | undefined;
    creationTime: moment.Moment | undefined;
    lastRevision: moment.Moment | undefined;
    nextRevision: moment.Moment | undefined;
    currentIndex: number | undefined;
    lastRevisionIndex: number | undefined;
    indexDate: moment.Moment | undefined;
    revisionIndex: number | undefined;
    maintenanceInterval: number | undefined;
    revisionComments: string | undefined;
    lastRevisionUsersIds: string | undefined;
    assignedRevisionUserIds: number[] | undefined;
    revisionPlanningUserId: number | undefined;
    revisionPlanningDate: moment.Moment | undefined;
    revisionInstructions: string | undefined;
    revisionInstructionsFilesIds: string[] | undefined;
    revisionInstructionFiles: RevisionFileDetails[] | undefined;
    id: string;

    constructor(data?: IAssetMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.maintenanceOperationId = _data["maintenanceOperationId"];
            this.maintenanceFrequencyType = _data["maintenanceFrequencyType"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastRevision = _data["lastRevision"] ? moment(_data["lastRevision"].toString()) : <any>undefined;
            this.nextRevision = _data["nextRevision"] ? moment(_data["nextRevision"].toString()) : <any>undefined;
            this.currentIndex = _data["currentIndex"];
            this.lastRevisionIndex = _data["lastRevisionIndex"];
            this.indexDate = _data["indexDate"] ? moment(_data["indexDate"].toString()) : <any>undefined;
            this.revisionIndex = _data["revisionIndex"];
            this.maintenanceInterval = _data["maintenanceInterval"];
            this.revisionComments = _data["revisionComments"];
            this.lastRevisionUsersIds = _data["lastRevisionUsersIds"];
            if (Array.isArray(_data["assignedRevisionUserIds"])) {
                this.assignedRevisionUserIds = [] as any;
                for (let item of _data["assignedRevisionUserIds"])
                    this.assignedRevisionUserIds.push(item);
            }
            this.revisionPlanningUserId = _data["revisionPlanningUserId"];
            this.revisionPlanningDate = _data["revisionPlanningDate"] ? moment(_data["revisionPlanningDate"].toString()) : <any>undefined;
            this.revisionInstructions = _data["revisionInstructions"];
            if (Array.isArray(_data["revisionInstructionsFilesIds"])) {
                this.revisionInstructionsFilesIds = [] as any;
                for (let item of _data["revisionInstructionsFilesIds"])
                    this.revisionInstructionsFilesIds.push(item);
            }
            if (Array.isArray(_data["revisionInstructionFiles"])) {
                this.revisionInstructionFiles = [] as any;
                for (let item of _data["revisionInstructionFiles"])
                    this.revisionInstructionFiles.push(RevisionFileDetails.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssetMaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetMaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["maintenanceOperationId"] = this.maintenanceOperationId;
        data["maintenanceFrequencyType"] = this.maintenanceFrequencyType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastRevision"] = this.lastRevision ? this.lastRevision.toISOString() : <any>undefined;
        data["nextRevision"] = this.nextRevision ? this.nextRevision.toISOString() : <any>undefined;
        data["currentIndex"] = this.currentIndex;
        data["lastRevisionIndex"] = this.lastRevisionIndex;
        data["indexDate"] = this.indexDate ? this.indexDate.toISOString() : <any>undefined;
        data["revisionIndex"] = this.revisionIndex;
        data["maintenanceInterval"] = this.maintenanceInterval;
        data["revisionComments"] = this.revisionComments;
        data["lastRevisionUsersIds"] = this.lastRevisionUsersIds;
        if (Array.isArray(this.assignedRevisionUserIds)) {
            data["assignedRevisionUserIds"] = [];
            for (let item of this.assignedRevisionUserIds)
                data["assignedRevisionUserIds"].push(item);
        }
        data["revisionPlanningUserId"] = this.revisionPlanningUserId;
        data["revisionPlanningDate"] = this.revisionPlanningDate ? this.revisionPlanningDate.toISOString() : <any>undefined;
        data["revisionInstructions"] = this.revisionInstructions;
        if (Array.isArray(this.revisionInstructionsFilesIds)) {
            data["revisionInstructionsFilesIds"] = [];
            for (let item of this.revisionInstructionsFilesIds)
                data["revisionInstructionsFilesIds"].push(item);
        }
        if (Array.isArray(this.revisionInstructionFiles)) {
            data["revisionInstructionFiles"] = [];
            for (let item of this.revisionInstructionFiles)
                data["revisionInstructionFiles"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): AssetMaintenanceDto {
        const json = this.toJSON();
        let result = new AssetMaintenanceDto();
        result.init(json);
        return result;
    }
}

export interface IAssetMaintenanceDto {
    assetId: string;
    maintenanceOperationId: string | undefined;
    maintenanceFrequencyType: number | undefined;
    creationTime: moment.Moment | undefined;
    lastRevision: moment.Moment | undefined;
    nextRevision: moment.Moment | undefined;
    currentIndex: number | undefined;
    lastRevisionIndex: number | undefined;
    indexDate: moment.Moment | undefined;
    revisionIndex: number | undefined;
    maintenanceInterval: number | undefined;
    revisionComments: string | undefined;
    lastRevisionUsersIds: string | undefined;
    assignedRevisionUserIds: number[] | undefined;
    revisionPlanningUserId: number | undefined;
    revisionPlanningDate: moment.Moment | undefined;
    revisionInstructions: string | undefined;
    revisionInstructionsFilesIds: string[] | undefined;
    revisionInstructionFiles: RevisionFileDetails[] | undefined;
    id: string;
}

export class AssetDto implements IAssetDto {
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenterId: string;
    costCenter: CostCenterDto;
    pictureFileId: string | undefined;
    lastScanDate: moment.Moment | undefined;
    lastScanUserId: number | undefined;
    lastScanUserName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocation: PhysicalLocationDto;
    physicalLocationDetails: string | undefined;
    status: number;
    lastScanStatus: number;
    category: number;
    requireMaintenance: boolean;
    lastRevision: moment.Moment | undefined;
    markedForRemove: boolean;
    markedForRemoveUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    lastRepair: moment.Moment | undefined;
    nextRepair: moment.Moment | undefined;
    repairInterval: number | undefined;
    repairComments: string | undefined;
    lastRepairUsersIds: string | undefined;
    assignedRepairUserIds: number[] | undefined;
    repairInstructions: string | undefined;
    repairInstructionFiles: RepairFileDetails[] | undefined;
    repairPlanningUserId: number | undefined;
    repairPlanningDate: moment.Moment | undefined;
    assetFiles: AssetFileDetails[] | undefined;
    beneficiaryId: string | undefined;
    beneficiary: BeneficiaryDto;
    maintenances: AssetMaintenanceDto[] | undefined;
    aquisitionDetails: boolean;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;
    id: string;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.idsn = _data["idsn"];
            this.description = _data["description"];
            this.costCenterId = _data["costCenterId"];
            this.costCenter = _data["costCenter"] ? CostCenterDto.fromJS(_data["costCenter"]) : <any>undefined;
            this.pictureFileId = _data["pictureFileId"];
            this.lastScanDate = _data["lastScanDate"] ? moment(_data["lastScanDate"].toString()) : <any>undefined;
            this.lastScanUserId = _data["lastScanUserId"];
            this.lastScanUserName = _data["lastScanUserName"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocation = _data["physicalLocation"] ? PhysicalLocationDto.fromJS(_data["physicalLocation"]) : <any>undefined;
            this.physicalLocationDetails = _data["physicalLocationDetails"];
            this.status = _data["status"];
            this.lastScanStatus = _data["lastScanStatus"];
            this.category = _data["category"];
            this.requireMaintenance = _data["requireMaintenance"];
            this.lastRevision = _data["lastRevision"] ? moment(_data["lastRevision"].toString()) : <any>undefined;
            this.markedForRemove = _data["markedForRemove"];
            this.markedForRemoveUserId = _data["markedForRemoveUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            this.lastRepair = _data["lastRepair"] ? moment(_data["lastRepair"].toString()) : <any>undefined;
            this.nextRepair = _data["nextRepair"] ? moment(_data["nextRepair"].toString()) : <any>undefined;
            this.repairInterval = _data["repairInterval"];
            this.repairComments = _data["repairComments"];
            this.lastRepairUsersIds = _data["lastRepairUsersIds"];
            if (Array.isArray(_data["assignedRepairUserIds"])) {
                this.assignedRepairUserIds = [] as any;
                for (let item of _data["assignedRepairUserIds"])
                    this.assignedRepairUserIds.push(item);
            }
            this.repairInstructions = _data["repairInstructions"];
            if (Array.isArray(_data["repairInstructionFiles"])) {
                this.repairInstructionFiles = [] as any;
                for (let item of _data["repairInstructionFiles"])
                    this.repairInstructionFiles.push(RepairFileDetails.fromJS(item));
            }
            this.repairPlanningUserId = _data["repairPlanningUserId"];
            this.repairPlanningDate = _data["repairPlanningDate"] ? moment(_data["repairPlanningDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["assetFiles"])) {
                this.assetFiles = [] as any;
                for (let item of _data["assetFiles"])
                    this.assetFiles.push(AssetFileDetails.fromJS(item));
            }
            this.beneficiaryId = _data["beneficiaryId"];
            this.beneficiary = _data["beneficiary"] ? BeneficiaryDto.fromJS(_data["beneficiary"]) : <any>undefined;
            if (Array.isArray(_data["maintenances"])) {
                this.maintenances = [] as any;
                for (let item of _data["maintenances"])
                    this.maintenances.push(AssetMaintenanceDto.fromJS(item));
            }
            this.aquisitionDetails = _data["aquisitionDetails"];
            this.aquisitionDate = _data["aquisitionDate"] ? moment(_data["aquisitionDate"].toString()) : <any>undefined;
            this.aquisitionValue = _data["aquisitionValue"];
            this.aquisitionRemainingValue = _data["aquisitionRemainingValue"];
            this.linearAmortization = _data["linearAmortization"];
            this.amortizationMonthsStandard = _data["amortizationMonthsStandard"];
            this.amortizationMonthsRemaining = _data["amortizationMonthsRemaining"];
            this.warrantyPeriod = _data["warrantyPeriod"];
            this.warrantyExpirationDate = _data["warrantyExpirationDate"] ? moment(_data["warrantyExpirationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["idsn"] = this.idsn;
        data["description"] = this.description;
        data["costCenterId"] = this.costCenterId;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        data["pictureFileId"] = this.pictureFileId;
        data["lastScanDate"] = this.lastScanDate ? this.lastScanDate.toISOString() : <any>undefined;
        data["lastScanUserId"] = this.lastScanUserId;
        data["lastScanUserName"] = this.lastScanUserName;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocation"] = this.physicalLocation ? this.physicalLocation.toJSON() : <any>undefined;
        data["physicalLocationDetails"] = this.physicalLocationDetails;
        data["status"] = this.status;
        data["lastScanStatus"] = this.lastScanStatus;
        data["category"] = this.category;
        data["requireMaintenance"] = this.requireMaintenance;
        data["lastRevision"] = this.lastRevision ? this.lastRevision.toISOString() : <any>undefined;
        data["markedForRemove"] = this.markedForRemove;
        data["markedForRemoveUserId"] = this.markedForRemoveUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["lastRepair"] = this.lastRepair ? this.lastRepair.toISOString() : <any>undefined;
        data["nextRepair"] = this.nextRepair ? this.nextRepair.toISOString() : <any>undefined;
        data["repairInterval"] = this.repairInterval;
        data["repairComments"] = this.repairComments;
        data["lastRepairUsersIds"] = this.lastRepairUsersIds;
        if (Array.isArray(this.assignedRepairUserIds)) {
            data["assignedRepairUserIds"] = [];
            for (let item of this.assignedRepairUserIds)
                data["assignedRepairUserIds"].push(item);
        }
        data["repairInstructions"] = this.repairInstructions;
        if (Array.isArray(this.repairInstructionFiles)) {
            data["repairInstructionFiles"] = [];
            for (let item of this.repairInstructionFiles)
                data["repairInstructionFiles"].push(item.toJSON());
        }
        data["repairPlanningUserId"] = this.repairPlanningUserId;
        data["repairPlanningDate"] = this.repairPlanningDate ? this.repairPlanningDate.toISOString() : <any>undefined;
        if (Array.isArray(this.assetFiles)) {
            data["assetFiles"] = [];
            for (let item of this.assetFiles)
                data["assetFiles"].push(item.toJSON());
        }
        data["beneficiaryId"] = this.beneficiaryId;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        if (Array.isArray(this.maintenances)) {
            data["maintenances"] = [];
            for (let item of this.maintenances)
                data["maintenances"].push(item.toJSON());
        }
        data["aquisitionDetails"] = this.aquisitionDetails;
        data["aquisitionDate"] = this.aquisitionDate ? this.aquisitionDate.toISOString() : <any>undefined;
        data["aquisitionValue"] = this.aquisitionValue;
        data["aquisitionRemainingValue"] = this.aquisitionRemainingValue;
        data["linearAmortization"] = this.linearAmortization;
        data["amortizationMonthsStandard"] = this.amortizationMonthsStandard;
        data["amortizationMonthsRemaining"] = this.amortizationMonthsRemaining;
        data["warrantyPeriod"] = this.warrantyPeriod;
        data["warrantyExpirationDate"] = this.warrantyExpirationDate ? this.warrantyExpirationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): AssetDto {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDto {
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenterId: string;
    costCenter: CostCenterDto;
    pictureFileId: string | undefined;
    lastScanDate: moment.Moment | undefined;
    lastScanUserId: number | undefined;
    lastScanUserName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocation: PhysicalLocationDto;
    physicalLocationDetails: string | undefined;
    status: number;
    lastScanStatus: number;
    category: number;
    requireMaintenance: boolean;
    lastRevision: moment.Moment | undefined;
    markedForRemove: boolean;
    markedForRemoveUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    lastRepair: moment.Moment | undefined;
    nextRepair: moment.Moment | undefined;
    repairInterval: number | undefined;
    repairComments: string | undefined;
    lastRepairUsersIds: string | undefined;
    assignedRepairUserIds: number[] | undefined;
    repairInstructions: string | undefined;
    repairInstructionFiles: RepairFileDetails[] | undefined;
    repairPlanningUserId: number | undefined;
    repairPlanningDate: moment.Moment | undefined;
    assetFiles: AssetFileDetails[] | undefined;
    beneficiaryId: string | undefined;
    beneficiary: BeneficiaryDto;
    maintenances: AssetMaintenanceDto[] | undefined;
    aquisitionDetails: boolean;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;
    id: string;
}

export class AssetDtoPagedResultDto implements IAssetDtoPagedResultDto {
    totalCount: number;
    items: AssetDto[] | undefined;

    constructor(data?: IAssetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): AssetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDtoPagedResultDto {
    totalCount: number;
    items: AssetDto[] | undefined;
}

export class CreateAssetDto implements ICreateAssetDto {
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenterId: string;
    physicalLocationId: string | undefined;
    physicalLocationDetails: string | undefined;
    pictureFileId: string | undefined;
    status: number;
    category: number;
    creationTime: moment.Moment;
    requireMaintenance: boolean;
    assetFileIds: string[] | undefined;
    beneficiaryId: string | undefined;
    maintenances: AssetMaintenanceDto[] | undefined;
    aquisitionDetails: boolean;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;

    constructor(data?: ICreateAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.idsn = _data["idsn"];
            this.description = _data["description"];
            this.costCenterId = _data["costCenterId"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocationDetails = _data["physicalLocationDetails"];
            this.pictureFileId = _data["pictureFileId"];
            this.status = _data["status"];
            this.category = _data["category"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.requireMaintenance = _data["requireMaintenance"];
            if (Array.isArray(_data["assetFileIds"])) {
                this.assetFileIds = [] as any;
                for (let item of _data["assetFileIds"])
                    this.assetFileIds.push(item);
            }
            this.beneficiaryId = _data["beneficiaryId"];
            if (Array.isArray(_data["maintenances"])) {
                this.maintenances = [] as any;
                for (let item of _data["maintenances"])
                    this.maintenances.push(AssetMaintenanceDto.fromJS(item));
            }
            this.aquisitionDetails = _data["aquisitionDetails"];
            this.aquisitionDate = _data["aquisitionDate"] ? moment(_data["aquisitionDate"].toString()) : <any>undefined;
            this.aquisitionValue = _data["aquisitionValue"];
            this.aquisitionRemainingValue = _data["aquisitionRemainingValue"];
            this.linearAmortization = _data["linearAmortization"];
            this.amortizationMonthsStandard = _data["amortizationMonthsStandard"];
            this.amortizationMonthsRemaining = _data["amortizationMonthsRemaining"];
            this.warrantyPeriod = _data["warrantyPeriod"];
            this.warrantyExpirationDate = _data["warrantyExpirationDate"] ? moment(_data["warrantyExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["idsn"] = this.idsn;
        data["description"] = this.description;
        data["costCenterId"] = this.costCenterId;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocationDetails"] = this.physicalLocationDetails;
        data["pictureFileId"] = this.pictureFileId;
        data["status"] = this.status;
        data["category"] = this.category;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["requireMaintenance"] = this.requireMaintenance;
        if (Array.isArray(this.assetFileIds)) {
            data["assetFileIds"] = [];
            for (let item of this.assetFileIds)
                data["assetFileIds"].push(item);
        }
        data["beneficiaryId"] = this.beneficiaryId;
        if (Array.isArray(this.maintenances)) {
            data["maintenances"] = [];
            for (let item of this.maintenances)
                data["maintenances"].push(item.toJSON());
        }
        data["aquisitionDetails"] = this.aquisitionDetails;
        data["aquisitionDate"] = this.aquisitionDate ? this.aquisitionDate.toISOString() : <any>undefined;
        data["aquisitionValue"] = this.aquisitionValue;
        data["aquisitionRemainingValue"] = this.aquisitionRemainingValue;
        data["linearAmortization"] = this.linearAmortization;
        data["amortizationMonthsStandard"] = this.amortizationMonthsStandard;
        data["amortizationMonthsRemaining"] = this.amortizationMonthsRemaining;
        data["warrantyPeriod"] = this.warrantyPeriod;
        data["warrantyExpirationDate"] = this.warrantyExpirationDate ? this.warrantyExpirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateAssetDto {
        const json = this.toJSON();
        let result = new CreateAssetDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAssetDto {
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenterId: string;
    physicalLocationId: string | undefined;
    physicalLocationDetails: string | undefined;
    pictureFileId: string | undefined;
    status: number;
    category: number;
    creationTime: moment.Moment;
    requireMaintenance: boolean;
    assetFileIds: string[] | undefined;
    beneficiaryId: string | undefined;
    maintenances: AssetMaintenanceDto[] | undefined;
    aquisitionDetails: boolean;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;
}

export class UpdateAssetDto implements IUpdateAssetDto {
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenterId: string;
    physicalLocationId: string | undefined;
    physicalLocationDetails: string | undefined;
    pictureFileId: string | undefined;
    status: number;
    category: number;
    creationTime: moment.Moment;
    requireMaintenance: boolean;
    markedForRemove: boolean;
    lastRevision: moment.Moment | undefined;
    lastRepair: moment.Moment | undefined;
    nextRepair: moment.Moment | undefined;
    repairInterval: number | undefined;
    repairComments: string | undefined;
    assignedRepairUserIds: number[] | undefined;
    repairInstructions: string | undefined;
    repairInstructionsFiles: string[] | undefined;
    repairPlanningUserId: number | undefined;
    repairPlanningDate: moment.Moment | undefined;
    assetFileIds: string[] | undefined;
    deletedAssetFiles: string[] | undefined;
    beneficiaryId: string | undefined;
    maintenances: AssetMaintenanceDto[] | undefined;
    aquisitionDetails: boolean;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;
    id: string;

    constructor(data?: IUpdateAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.idsn = _data["idsn"];
            this.description = _data["description"];
            this.costCenterId = _data["costCenterId"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocationDetails = _data["physicalLocationDetails"];
            this.pictureFileId = _data["pictureFileId"];
            this.status = _data["status"];
            this.category = _data["category"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.requireMaintenance = _data["requireMaintenance"];
            this.markedForRemove = _data["markedForRemove"];
            this.lastRevision = _data["lastRevision"] ? moment(_data["lastRevision"].toString()) : <any>undefined;
            this.lastRepair = _data["lastRepair"] ? moment(_data["lastRepair"].toString()) : <any>undefined;
            this.nextRepair = _data["nextRepair"] ? moment(_data["nextRepair"].toString()) : <any>undefined;
            this.repairInterval = _data["repairInterval"];
            this.repairComments = _data["repairComments"];
            if (Array.isArray(_data["assignedRepairUserIds"])) {
                this.assignedRepairUserIds = [] as any;
                for (let item of _data["assignedRepairUserIds"])
                    this.assignedRepairUserIds.push(item);
            }
            this.repairInstructions = _data["repairInstructions"];
            if (Array.isArray(_data["repairInstructionsFiles"])) {
                this.repairInstructionsFiles = [] as any;
                for (let item of _data["repairInstructionsFiles"])
                    this.repairInstructionsFiles.push(item);
            }
            this.repairPlanningUserId = _data["repairPlanningUserId"];
            this.repairPlanningDate = _data["repairPlanningDate"] ? moment(_data["repairPlanningDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["assetFileIds"])) {
                this.assetFileIds = [] as any;
                for (let item of _data["assetFileIds"])
                    this.assetFileIds.push(item);
            }
            if (Array.isArray(_data["deletedAssetFiles"])) {
                this.deletedAssetFiles = [] as any;
                for (let item of _data["deletedAssetFiles"])
                    this.deletedAssetFiles.push(item);
            }
            this.beneficiaryId = _data["beneficiaryId"];
            if (Array.isArray(_data["maintenances"])) {
                this.maintenances = [] as any;
                for (let item of _data["maintenances"])
                    this.maintenances.push(AssetMaintenanceDto.fromJS(item));
            }
            this.aquisitionDetails = _data["aquisitionDetails"];
            this.aquisitionDate = _data["aquisitionDate"] ? moment(_data["aquisitionDate"].toString()) : <any>undefined;
            this.aquisitionValue = _data["aquisitionValue"];
            this.aquisitionRemainingValue = _data["aquisitionRemainingValue"];
            this.linearAmortization = _data["linearAmortization"];
            this.amortizationMonthsStandard = _data["amortizationMonthsStandard"];
            this.amortizationMonthsRemaining = _data["amortizationMonthsRemaining"];
            this.warrantyPeriod = _data["warrantyPeriod"];
            this.warrantyExpirationDate = _data["warrantyExpirationDate"] ? moment(_data["warrantyExpirationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["idsn"] = this.idsn;
        data["description"] = this.description;
        data["costCenterId"] = this.costCenterId;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocationDetails"] = this.physicalLocationDetails;
        data["pictureFileId"] = this.pictureFileId;
        data["status"] = this.status;
        data["category"] = this.category;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["requireMaintenance"] = this.requireMaintenance;
        data["markedForRemove"] = this.markedForRemove;
        data["lastRevision"] = this.lastRevision ? this.lastRevision.toISOString() : <any>undefined;
        data["lastRepair"] = this.lastRepair ? this.lastRepair.toISOString() : <any>undefined;
        data["nextRepair"] = this.nextRepair ? this.nextRepair.toISOString() : <any>undefined;
        data["repairInterval"] = this.repairInterval;
        data["repairComments"] = this.repairComments;
        if (Array.isArray(this.assignedRepairUserIds)) {
            data["assignedRepairUserIds"] = [];
            for (let item of this.assignedRepairUserIds)
                data["assignedRepairUserIds"].push(item);
        }
        data["repairInstructions"] = this.repairInstructions;
        if (Array.isArray(this.repairInstructionsFiles)) {
            data["repairInstructionsFiles"] = [];
            for (let item of this.repairInstructionsFiles)
                data["repairInstructionsFiles"].push(item);
        }
        data["repairPlanningUserId"] = this.repairPlanningUserId;
        data["repairPlanningDate"] = this.repairPlanningDate ? this.repairPlanningDate.toISOString() : <any>undefined;
        if (Array.isArray(this.assetFileIds)) {
            data["assetFileIds"] = [];
            for (let item of this.assetFileIds)
                data["assetFileIds"].push(item);
        }
        if (Array.isArray(this.deletedAssetFiles)) {
            data["deletedAssetFiles"] = [];
            for (let item of this.deletedAssetFiles)
                data["deletedAssetFiles"].push(item);
        }
        data["beneficiaryId"] = this.beneficiaryId;
        if (Array.isArray(this.maintenances)) {
            data["maintenances"] = [];
            for (let item of this.maintenances)
                data["maintenances"].push(item.toJSON());
        }
        data["aquisitionDetails"] = this.aquisitionDetails;
        data["aquisitionDate"] = this.aquisitionDate ? this.aquisitionDate.toISOString() : <any>undefined;
        data["aquisitionValue"] = this.aquisitionValue;
        data["aquisitionRemainingValue"] = this.aquisitionRemainingValue;
        data["linearAmortization"] = this.linearAmortization;
        data["amortizationMonthsStandard"] = this.amortizationMonthsStandard;
        data["amortizationMonthsRemaining"] = this.amortizationMonthsRemaining;
        data["warrantyPeriod"] = this.warrantyPeriod;
        data["warrantyExpirationDate"] = this.warrantyExpirationDate ? this.warrantyExpirationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateAssetDto {
        const json = this.toJSON();
        let result = new UpdateAssetDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetDto {
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenterId: string;
    physicalLocationId: string | undefined;
    physicalLocationDetails: string | undefined;
    pictureFileId: string | undefined;
    status: number;
    category: number;
    creationTime: moment.Moment;
    requireMaintenance: boolean;
    markedForRemove: boolean;
    lastRevision: moment.Moment | undefined;
    lastRepair: moment.Moment | undefined;
    nextRepair: moment.Moment | undefined;
    repairInterval: number | undefined;
    repairComments: string | undefined;
    assignedRepairUserIds: number[] | undefined;
    repairInstructions: string | undefined;
    repairInstructionsFiles: string[] | undefined;
    repairPlanningUserId: number | undefined;
    repairPlanningDate: moment.Moment | undefined;
    assetFileIds: string[] | undefined;
    deletedAssetFiles: string[] | undefined;
    beneficiaryId: string | undefined;
    maintenances: AssetMaintenanceDto[] | undefined;
    aquisitionDetails: boolean;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;
    id: string;
}

export class AssetImportItem implements IAssetImportItem {
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenter: string | undefined;
    status: number;
    category: number;
    requireMaintenance: string | undefined;
    nextRevision: moment.Moment | undefined;
    maintenanceInterval: string | undefined;
    revisionAgentEmail: string | undefined;
    revisionInstructions: string | undefined;
    physicalLocationDetails: string | undefined;
    poiName: string | undefined;
    poiLatitude: number | undefined;
    poiLongitude: number | undefined;
    markedForCasation: string | undefined;
    currentIndex: number | undefined;
    indexReadingDate: moment.Moment | undefined;
    dueIndex: number | undefined;
    maintenanceIndex: number | undefined;
    beneficiary: string | undefined;
    beneficiaryMark: string | undefined;
    maintenanceFrequencyType: number | undefined;
    aquisitionDetails: string | undefined;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: string | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warranty: string | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;

    constructor(data?: IAssetImportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.idsn = _data["idsn"];
            this.description = _data["description"];
            this.costCenter = _data["costCenter"];
            this.status = _data["status"];
            this.category = _data["category"];
            this.requireMaintenance = _data["requireMaintenance"];
            this.nextRevision = _data["nextRevision"] ? moment(_data["nextRevision"].toString()) : <any>undefined;
            this.maintenanceInterval = _data["maintenanceInterval"];
            this.revisionAgentEmail = _data["revisionAgentEmail"];
            this.revisionInstructions = _data["revisionInstructions"];
            this.physicalLocationDetails = _data["physicalLocationDetails"];
            this.poiName = _data["poiName"];
            this.poiLatitude = _data["poiLatitude"];
            this.poiLongitude = _data["poiLongitude"];
            this.markedForCasation = _data["markedForCasation"];
            this.currentIndex = _data["currentIndex"];
            this.indexReadingDate = _data["indexReadingDate"] ? moment(_data["indexReadingDate"].toString()) : <any>undefined;
            this.dueIndex = _data["dueIndex"];
            this.maintenanceIndex = _data["maintenanceIndex"];
            this.beneficiary = _data["beneficiary"];
            this.beneficiaryMark = _data["beneficiaryMark"];
            this.maintenanceFrequencyType = _data["maintenanceFrequencyType"];
            this.aquisitionDetails = _data["aquisitionDetails"];
            this.aquisitionDate = _data["aquisitionDate"] ? moment(_data["aquisitionDate"].toString()) : <any>undefined;
            this.aquisitionValue = _data["aquisitionValue"];
            this.aquisitionRemainingValue = _data["aquisitionRemainingValue"];
            this.linearAmortization = _data["linearAmortization"];
            this.amortizationMonthsStandard = _data["amortizationMonthsStandard"];
            this.amortizationMonthsRemaining = _data["amortizationMonthsRemaining"];
            this.warranty = _data["warranty"];
            this.warrantyPeriod = _data["warrantyPeriod"];
            this.warrantyExpirationDate = _data["warrantyExpirationDate"] ? moment(_data["warrantyExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetImportItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["idsn"] = this.idsn;
        data["description"] = this.description;
        data["costCenter"] = this.costCenter;
        data["status"] = this.status;
        data["category"] = this.category;
        data["requireMaintenance"] = this.requireMaintenance;
        data["nextRevision"] = this.nextRevision ? this.nextRevision.toISOString() : <any>undefined;
        data["maintenanceInterval"] = this.maintenanceInterval;
        data["revisionAgentEmail"] = this.revisionAgentEmail;
        data["revisionInstructions"] = this.revisionInstructions;
        data["physicalLocationDetails"] = this.physicalLocationDetails;
        data["poiName"] = this.poiName;
        data["poiLatitude"] = this.poiLatitude;
        data["poiLongitude"] = this.poiLongitude;
        data["markedForCasation"] = this.markedForCasation;
        data["currentIndex"] = this.currentIndex;
        data["indexReadingDate"] = this.indexReadingDate ? this.indexReadingDate.toISOString() : <any>undefined;
        data["dueIndex"] = this.dueIndex;
        data["maintenanceIndex"] = this.maintenanceIndex;
        data["beneficiary"] = this.beneficiary;
        data["beneficiaryMark"] = this.beneficiaryMark;
        data["maintenanceFrequencyType"] = this.maintenanceFrequencyType;
        data["aquisitionDetails"] = this.aquisitionDetails;
        data["aquisitionDate"] = this.aquisitionDate ? this.aquisitionDate.toISOString() : <any>undefined;
        data["aquisitionValue"] = this.aquisitionValue;
        data["aquisitionRemainingValue"] = this.aquisitionRemainingValue;
        data["linearAmortization"] = this.linearAmortization;
        data["amortizationMonthsStandard"] = this.amortizationMonthsStandard;
        data["amortizationMonthsRemaining"] = this.amortizationMonthsRemaining;
        data["warranty"] = this.warranty;
        data["warrantyPeriod"] = this.warrantyPeriod;
        data["warrantyExpirationDate"] = this.warrantyExpirationDate ? this.warrantyExpirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): AssetImportItem {
        const json = this.toJSON();
        let result = new AssetImportItem();
        result.init(json);
        return result;
    }
}

export interface IAssetImportItem {
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenter: string | undefined;
    status: number;
    category: number;
    requireMaintenance: string | undefined;
    nextRevision: moment.Moment | undefined;
    maintenanceInterval: string | undefined;
    revisionAgentEmail: string | undefined;
    revisionInstructions: string | undefined;
    physicalLocationDetails: string | undefined;
    poiName: string | undefined;
    poiLatitude: number | undefined;
    poiLongitude: number | undefined;
    markedForCasation: string | undefined;
    currentIndex: number | undefined;
    indexReadingDate: moment.Moment | undefined;
    dueIndex: number | undefined;
    maintenanceIndex: number | undefined;
    beneficiary: string | undefined;
    beneficiaryMark: string | undefined;
    maintenanceFrequencyType: number | undefined;
    aquisitionDetails: string | undefined;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: string | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warranty: string | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;
}

export class AssetImportItemImportItemsInput implements IAssetImportItemImportItemsInput {
    items: AssetImportItem[] | undefined;
    overwrite: boolean;

    constructor(data?: IAssetImportItemImportItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(AssetImportItem.fromJS(item));
            }
            this.overwrite = _data["overwrite"];
        }
    }

    static fromJS(data: any): AssetImportItemImportItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportItemImportItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["overwrite"] = this.overwrite;
        return data;
    }

    clone(): AssetImportItemImportItemsInput {
        const json = this.toJSON();
        let result = new AssetImportItemImportItemsInput();
        result.init(json);
        return result;
    }
}

export interface IAssetImportItemImportItemsInput {
    items: AssetImportItem[] | undefined;
    overwrite: boolean;
}

export class AssetImportItemImportItemError implements IAssetImportItemImportItemError {
    error: string | undefined;
    item: AssetImportItem;

    constructor(data?: IAssetImportItemImportItemError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.item = _data["item"] ? AssetImportItem.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetImportItemImportItemError {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportItemImportItemError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }

    clone(): AssetImportItemImportItemError {
        const json = this.toJSON();
        let result = new AssetImportItemImportItemError();
        result.init(json);
        return result;
    }
}

export interface IAssetImportItemImportItemError {
    error: string | undefined;
    item: AssetImportItem;
}

export class AssetImportItemImportItemsResult implements IAssetImportItemImportItemsResult {
    itemsErrors: AssetImportItemImportItemError[] | undefined;
    existingItems: AssetImportItem[] | undefined;

    constructor(data?: IAssetImportItemImportItemsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["itemsErrors"])) {
                this.itemsErrors = [] as any;
                for (let item of _data["itemsErrors"])
                    this.itemsErrors.push(AssetImportItemImportItemError.fromJS(item));
            }
            if (Array.isArray(_data["existingItems"])) {
                this.existingItems = [] as any;
                for (let item of _data["existingItems"])
                    this.existingItems.push(AssetImportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetImportItemImportItemsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportItemImportItemsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemsErrors)) {
            data["itemsErrors"] = [];
            for (let item of this.itemsErrors)
                data["itemsErrors"].push(item.toJSON());
        }
        if (Array.isArray(this.existingItems)) {
            data["existingItems"] = [];
            for (let item of this.existingItems)
                data["existingItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): AssetImportItemImportItemsResult {
        const json = this.toJSON();
        let result = new AssetImportItemImportItemsResult();
        result.init(json);
        return result;
    }
}

export interface IAssetImportItemImportItemsResult {
    itemsErrors: AssetImportItemImportItemError[] | undefined;
    existingItems: AssetImportItem[] | undefined;
}

export class AssetConfigDto implements IAssetConfigDto {
    tenantId: number;
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    physicalLocationDetails: string | undefined;
    pictureFileId: string | undefined;
    lastScanDate: moment.Moment | undefined;
    lastScanUserId: number | undefined;
    lastRevision: moment.Moment | undefined;
    status: number;
    category: number;
    creationTime: moment.Moment;
    requireMaintenance: boolean;
    markedForRemove: boolean;
    markedForRemoveUserId: number | undefined;
    assetFiles: AssetFileDetails[] | undefined;
    beneficiaryId: string | undefined;
    beneficiaryName: string | undefined;
    maintenances: AssetMaintenanceDto[] | undefined;
    aquisitionDetails: boolean;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;
    id: string;

    constructor(data?: IAssetConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.idsn = _data["idsn"];
            this.description = _data["description"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocationName = _data["physicalLocationName"];
            this.physicalLocationDetails = _data["physicalLocationDetails"];
            this.pictureFileId = _data["pictureFileId"];
            this.lastScanDate = _data["lastScanDate"] ? moment(_data["lastScanDate"].toString()) : <any>undefined;
            this.lastScanUserId = _data["lastScanUserId"];
            this.lastRevision = _data["lastRevision"] ? moment(_data["lastRevision"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.category = _data["category"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.requireMaintenance = _data["requireMaintenance"];
            this.markedForRemove = _data["markedForRemove"];
            this.markedForRemoveUserId = _data["markedForRemoveUserId"];
            if (Array.isArray(_data["assetFiles"])) {
                this.assetFiles = [] as any;
                for (let item of _data["assetFiles"])
                    this.assetFiles.push(AssetFileDetails.fromJS(item));
            }
            this.beneficiaryId = _data["beneficiaryId"];
            this.beneficiaryName = _data["beneficiaryName"];
            if (Array.isArray(_data["maintenances"])) {
                this.maintenances = [] as any;
                for (let item of _data["maintenances"])
                    this.maintenances.push(AssetMaintenanceDto.fromJS(item));
            }
            this.aquisitionDetails = _data["aquisitionDetails"];
            this.aquisitionDate = _data["aquisitionDate"] ? moment(_data["aquisitionDate"].toString()) : <any>undefined;
            this.aquisitionValue = _data["aquisitionValue"];
            this.aquisitionRemainingValue = _data["aquisitionRemainingValue"];
            this.linearAmortization = _data["linearAmortization"];
            this.amortizationMonthsStandard = _data["amortizationMonthsStandard"];
            this.amortizationMonthsRemaining = _data["amortizationMonthsRemaining"];
            this.warrantyPeriod = _data["warrantyPeriod"];
            this.warrantyExpirationDate = _data["warrantyExpirationDate"] ? moment(_data["warrantyExpirationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssetConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["number"] = this.number;
        data["idsn"] = this.idsn;
        data["description"] = this.description;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocationName"] = this.physicalLocationName;
        data["physicalLocationDetails"] = this.physicalLocationDetails;
        data["pictureFileId"] = this.pictureFileId;
        data["lastScanDate"] = this.lastScanDate ? this.lastScanDate.toISOString() : <any>undefined;
        data["lastScanUserId"] = this.lastScanUserId;
        data["lastRevision"] = this.lastRevision ? this.lastRevision.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["category"] = this.category;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["requireMaintenance"] = this.requireMaintenance;
        data["markedForRemove"] = this.markedForRemove;
        data["markedForRemoveUserId"] = this.markedForRemoveUserId;
        if (Array.isArray(this.assetFiles)) {
            data["assetFiles"] = [];
            for (let item of this.assetFiles)
                data["assetFiles"].push(item.toJSON());
        }
        data["beneficiaryId"] = this.beneficiaryId;
        data["beneficiaryName"] = this.beneficiaryName;
        if (Array.isArray(this.maintenances)) {
            data["maintenances"] = [];
            for (let item of this.maintenances)
                data["maintenances"].push(item.toJSON());
        }
        data["aquisitionDetails"] = this.aquisitionDetails;
        data["aquisitionDate"] = this.aquisitionDate ? this.aquisitionDate.toISOString() : <any>undefined;
        data["aquisitionValue"] = this.aquisitionValue;
        data["aquisitionRemainingValue"] = this.aquisitionRemainingValue;
        data["linearAmortization"] = this.linearAmortization;
        data["amortizationMonthsStandard"] = this.amortizationMonthsStandard;
        data["amortizationMonthsRemaining"] = this.amortizationMonthsRemaining;
        data["warrantyPeriod"] = this.warrantyPeriod;
        data["warrantyExpirationDate"] = this.warrantyExpirationDate ? this.warrantyExpirationDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): AssetConfigDto {
        const json = this.toJSON();
        let result = new AssetConfigDto();
        result.init(json);
        return result;
    }
}

export interface IAssetConfigDto {
    tenantId: number;
    name: string | undefined;
    number: string | undefined;
    idsn: string | undefined;
    description: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    physicalLocationDetails: string | undefined;
    pictureFileId: string | undefined;
    lastScanDate: moment.Moment | undefined;
    lastScanUserId: number | undefined;
    lastRevision: moment.Moment | undefined;
    status: number;
    category: number;
    creationTime: moment.Moment;
    requireMaintenance: boolean;
    markedForRemove: boolean;
    markedForRemoveUserId: number | undefined;
    assetFiles: AssetFileDetails[] | undefined;
    beneficiaryId: string | undefined;
    beneficiaryName: string | undefined;
    maintenances: AssetMaintenanceDto[] | undefined;
    aquisitionDetails: boolean;
    aquisitionDate: moment.Moment | undefined;
    aquisitionValue: number | undefined;
    aquisitionRemainingValue: number | undefined;
    linearAmortization: boolean | undefined;
    amortizationMonthsStandard: number | undefined;
    amortizationMonthsRemaining: number | undefined;
    warrantyPeriod: number | undefined;
    warrantyExpirationDate: moment.Moment | undefined;
    id: string;
}

export class AssetFilterParams implements IAssetFilterParams {
    skip: number;
    take: number;
    filter: string | undefined;
    requireRevision: boolean;
    markedForRemove: boolean;
    physicalLocationId: string | undefined;
    costCenterIds: string[] | undefined;
    statuses: number[] | undefined;
    startCreationTime: moment.Moment | undefined;
    endCreationTime: moment.Moment | undefined;
    beneficiaryId: string | undefined;

    constructor(data?: IAssetFilterParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
            this.filter = _data["filter"];
            this.requireRevision = _data["requireRevision"];
            this.markedForRemove = _data["markedForRemove"];
            this.physicalLocationId = _data["physicalLocationId"];
            if (Array.isArray(_data["costCenterIds"])) {
                this.costCenterIds = [] as any;
                for (let item of _data["costCenterIds"])
                    this.costCenterIds.push(item);
            }
            if (Array.isArray(_data["statuses"])) {
                this.statuses = [] as any;
                for (let item of _data["statuses"])
                    this.statuses.push(item);
            }
            this.startCreationTime = _data["startCreationTime"] ? moment(_data["startCreationTime"].toString()) : <any>undefined;
            this.endCreationTime = _data["endCreationTime"] ? moment(_data["endCreationTime"].toString()) : <any>undefined;
            this.beneficiaryId = _data["beneficiaryId"];
        }
    }

    static fromJS(data: any): AssetFilterParams {
        data = typeof data === 'object' ? data : {};
        let result = new AssetFilterParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        data["filter"] = this.filter;
        data["requireRevision"] = this.requireRevision;
        data["markedForRemove"] = this.markedForRemove;
        data["physicalLocationId"] = this.physicalLocationId;
        if (Array.isArray(this.costCenterIds)) {
            data["costCenterIds"] = [];
            for (let item of this.costCenterIds)
                data["costCenterIds"].push(item);
        }
        if (Array.isArray(this.statuses)) {
            data["statuses"] = [];
            for (let item of this.statuses)
                data["statuses"].push(item);
        }
        data["startCreationTime"] = this.startCreationTime ? this.startCreationTime.toISOString() : <any>undefined;
        data["endCreationTime"] = this.endCreationTime ? this.endCreationTime.toISOString() : <any>undefined;
        data["beneficiaryId"] = this.beneficiaryId;
        return data;
    }

    clone(): AssetFilterParams {
        const json = this.toJSON();
        let result = new AssetFilterParams();
        result.init(json);
        return result;
    }
}

export interface IAssetFilterParams {
    skip: number;
    take: number;
    filter: string | undefined;
    requireRevision: boolean;
    markedForRemove: boolean;
    physicalLocationId: string | undefined;
    costCenterIds: string[] | undefined;
    statuses: number[] | undefined;
    startCreationTime: moment.Moment | undefined;
    endCreationTime: moment.Moment | undefined;
    beneficiaryId: string | undefined;
}

export class AssetHistoryItem implements IAssetHistoryItem {
    id: string;
    tenantId: number;
    status: number;
    comment: string | undefined;
    assetId: string | undefined;
    date: moment.Moment;
    physicalLocation: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    actionType: number;
    user: string | undefined;

    constructor(data?: IAssetHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.status = _data["status"];
            this.comment = _data["comment"];
            this.assetId = _data["assetId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.physicalLocation = _data["physicalLocation"];
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.actionType = _data["actionType"];
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): AssetHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssetHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["comment"] = this.comment;
        data["assetId"] = this.assetId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["physicalLocation"] = this.physicalLocation;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["actionType"] = this.actionType;
        data["user"] = this.user;
        return data;
    }

    clone(): AssetHistoryItem {
        const json = this.toJSON();
        let result = new AssetHistoryItem();
        result.init(json);
        return result;
    }
}

export interface IAssetHistoryItem {
    id: string;
    tenantId: number;
    status: number;
    comment: string | undefined;
    assetId: string | undefined;
    date: moment.Moment;
    physicalLocation: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    actionType: number;
    user: string | undefined;
}

export class CreateBeneficiaryDto implements ICreateBeneficiaryDto {
    name: string | undefined;
    mark: string | undefined;
    jobPosition: string | undefined;
    department: string | undefined;
    address: string | undefined;
    idCardSerial: string | undefined;
    idCardNumber: string | undefined;
    idCardProvider: string | undefined;
    idCardProvidedDate: moment.Moment | undefined;
    ssn: string | undefined;
    contractNumber: string | undefined;
    contractDate: moment.Moment | undefined;
    assets: string[] | undefined;

    constructor(data?: ICreateBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.mark = _data["mark"];
            this.jobPosition = _data["jobPosition"];
            this.department = _data["department"];
            this.address = _data["address"];
            this.idCardSerial = _data["idCardSerial"];
            this.idCardNumber = _data["idCardNumber"];
            this.idCardProvider = _data["idCardProvider"];
            this.idCardProvidedDate = _data["idCardProvidedDate"] ? moment(_data["idCardProvidedDate"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.contractNumber = _data["contractNumber"];
            this.contractDate = _data["contractDate"] ? moment(_data["contractDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets.push(item);
            }
        }
    }

    static fromJS(data: any): CreateBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["mark"] = this.mark;
        data["jobPosition"] = this.jobPosition;
        data["department"] = this.department;
        data["address"] = this.address;
        data["idCardSerial"] = this.idCardSerial;
        data["idCardNumber"] = this.idCardNumber;
        data["idCardProvider"] = this.idCardProvider;
        data["idCardProvidedDate"] = this.idCardProvidedDate ? this.idCardProvidedDate.toISOString() : <any>undefined;
        data["ssn"] = this.ssn;
        data["contractNumber"] = this.contractNumber;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : <any>undefined;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item);
        }
        return data;
    }

    clone(): CreateBeneficiaryDto {
        const json = this.toJSON();
        let result = new CreateBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBeneficiaryDto {
    name: string | undefined;
    mark: string | undefined;
    jobPosition: string | undefined;
    department: string | undefined;
    address: string | undefined;
    idCardSerial: string | undefined;
    idCardNumber: string | undefined;
    idCardProvider: string | undefined;
    idCardProvidedDate: moment.Moment | undefined;
    ssn: string | undefined;
    contractNumber: string | undefined;
    contractDate: moment.Moment | undefined;
    assets: string[] | undefined;
}

export class UpdateBeneficiaryDto implements IUpdateBeneficiaryDto {
    mark: string | undefined;
    name: string | undefined;
    jobPosition: string | undefined;
    department: string | undefined;
    address: string | undefined;
    idCardSerial: string | undefined;
    idCardNumber: string | undefined;
    idCardProvider: string | undefined;
    idCardProvidedDate: moment.Moment | undefined;
    ssn: string | undefined;
    contractNumber: string | undefined;
    contractDate: moment.Moment | undefined;
    assets: string[] | undefined;
    id: string;

    constructor(data?: IUpdateBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mark = _data["mark"];
            this.name = _data["name"];
            this.jobPosition = _data["jobPosition"];
            this.department = _data["department"];
            this.address = _data["address"];
            this.idCardSerial = _data["idCardSerial"];
            this.idCardNumber = _data["idCardNumber"];
            this.idCardProvider = _data["idCardProvider"];
            this.idCardProvidedDate = _data["idCardProvidedDate"] ? moment(_data["idCardProvidedDate"].toString()) : <any>undefined;
            this.ssn = _data["ssn"];
            this.contractNumber = _data["contractNumber"];
            this.contractDate = _data["contractDate"] ? moment(_data["contractDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mark"] = this.mark;
        data["name"] = this.name;
        data["jobPosition"] = this.jobPosition;
        data["department"] = this.department;
        data["address"] = this.address;
        data["idCardSerial"] = this.idCardSerial;
        data["idCardNumber"] = this.idCardNumber;
        data["idCardProvider"] = this.idCardProvider;
        data["idCardProvidedDate"] = this.idCardProvidedDate ? this.idCardProvidedDate.toISOString() : <any>undefined;
        data["ssn"] = this.ssn;
        data["contractNumber"] = this.contractNumber;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : <any>undefined;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateBeneficiaryDto {
        const json = this.toJSON();
        let result = new UpdateBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBeneficiaryDto {
    mark: string | undefined;
    name: string | undefined;
    jobPosition: string | undefined;
    department: string | undefined;
    address: string | undefined;
    idCardSerial: string | undefined;
    idCardNumber: string | undefined;
    idCardProvider: string | undefined;
    idCardProvidedDate: moment.Moment | undefined;
    ssn: string | undefined;
    contractNumber: string | undefined;
    contractDate: moment.Moment | undefined;
    assets: string[] | undefined;
    id: string;
}

export class BeneficiaryFilter implements IBeneficiaryFilter {
    query: string | undefined;

    constructor(data?: IBeneficiaryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
        }
    }

    static fromJS(data: any): BeneficiaryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        return data;
    }

    clone(): BeneficiaryFilter {
        const json = this.toJSON();
        let result = new BeneficiaryFilter();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryFilter {
    query: string | undefined;
}

export class BeneficiaryGetAllInput implements IBeneficiaryGetAllInput {
    filter: BeneficiaryFilter;
    skipCount: number;
    maxResultCount: number;

    constructor(data?: IBeneficiaryGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.filter = new BeneficiaryFilter();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? BeneficiaryFilter.fromJS(_data["filter"]) : new BeneficiaryFilter();
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): BeneficiaryGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }

    clone(): BeneficiaryGetAllInput {
        const json = this.toJSON();
        let result = new BeneficiaryGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryGetAllInput {
    filter: BeneficiaryFilter;
    skipCount: number;
    maxResultCount: number;
}

export class BeneficiaryImportItem implements IBeneficiaryImportItem {
    name: string | undefined;
    mark: string | undefined;
    jobPosition: string | undefined;
    department: string | undefined;
    address: string | undefined;
    idCardSerial: string | undefined;
    idCardNumber: string | undefined;
    idCardProvider: string | undefined;
    idCardProvidedDate: string | undefined;
    ssn: string | undefined;
    contractNumber: string | undefined;
    contractDate: string | undefined;

    constructor(data?: IBeneficiaryImportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.mark = _data["mark"];
            this.jobPosition = _data["jobPosition"];
            this.department = _data["department"];
            this.address = _data["address"];
            this.idCardSerial = _data["idCardSerial"];
            this.idCardNumber = _data["idCardNumber"];
            this.idCardProvider = _data["idCardProvider"];
            this.idCardProvidedDate = _data["idCardProvidedDate"];
            this.ssn = _data["ssn"];
            this.contractNumber = _data["contractNumber"];
            this.contractDate = _data["contractDate"];
        }
    }

    static fromJS(data: any): BeneficiaryImportItem {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryImportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["mark"] = this.mark;
        data["jobPosition"] = this.jobPosition;
        data["department"] = this.department;
        data["address"] = this.address;
        data["idCardSerial"] = this.idCardSerial;
        data["idCardNumber"] = this.idCardNumber;
        data["idCardProvider"] = this.idCardProvider;
        data["idCardProvidedDate"] = this.idCardProvidedDate;
        data["ssn"] = this.ssn;
        data["contractNumber"] = this.contractNumber;
        data["contractDate"] = this.contractDate;
        return data;
    }

    clone(): BeneficiaryImportItem {
        const json = this.toJSON();
        let result = new BeneficiaryImportItem();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryImportItem {
    name: string | undefined;
    mark: string | undefined;
    jobPosition: string | undefined;
    department: string | undefined;
    address: string | undefined;
    idCardSerial: string | undefined;
    idCardNumber: string | undefined;
    idCardProvider: string | undefined;
    idCardProvidedDate: string | undefined;
    ssn: string | undefined;
    contractNumber: string | undefined;
    contractDate: string | undefined;
}

export class BeneficiaryImportItemImportItemsInput implements IBeneficiaryImportItemImportItemsInput {
    items: BeneficiaryImportItem[] | undefined;
    overwrite: boolean;

    constructor(data?: IBeneficiaryImportItemImportItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BeneficiaryImportItem.fromJS(item));
            }
            this.overwrite = _data["overwrite"];
        }
    }

    static fromJS(data: any): BeneficiaryImportItemImportItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryImportItemImportItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["overwrite"] = this.overwrite;
        return data;
    }

    clone(): BeneficiaryImportItemImportItemsInput {
        const json = this.toJSON();
        let result = new BeneficiaryImportItemImportItemsInput();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryImportItemImportItemsInput {
    items: BeneficiaryImportItem[] | undefined;
    overwrite: boolean;
}

export class BeneficiaryImportItemImportItemError implements IBeneficiaryImportItemImportItemError {
    error: string | undefined;
    item: BeneficiaryImportItem;

    constructor(data?: IBeneficiaryImportItemImportItemError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.item = _data["item"] ? BeneficiaryImportItem.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BeneficiaryImportItemImportItemError {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryImportItemImportItemError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }

    clone(): BeneficiaryImportItemImportItemError {
        const json = this.toJSON();
        let result = new BeneficiaryImportItemImportItemError();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryImportItemImportItemError {
    error: string | undefined;
    item: BeneficiaryImportItem;
}

export class BeneficiaryImportItemImportItemsResult implements IBeneficiaryImportItemImportItemsResult {
    itemsErrors: BeneficiaryImportItemImportItemError[] | undefined;
    existingItems: BeneficiaryImportItem[] | undefined;

    constructor(data?: IBeneficiaryImportItemImportItemsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["itemsErrors"])) {
                this.itemsErrors = [] as any;
                for (let item of _data["itemsErrors"])
                    this.itemsErrors.push(BeneficiaryImportItemImportItemError.fromJS(item));
            }
            if (Array.isArray(_data["existingItems"])) {
                this.existingItems = [] as any;
                for (let item of _data["existingItems"])
                    this.existingItems.push(BeneficiaryImportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BeneficiaryImportItemImportItemsResult {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryImportItemImportItemsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemsErrors)) {
            data["itemsErrors"] = [];
            for (let item of this.itemsErrors)
                data["itemsErrors"].push(item.toJSON());
        }
        if (Array.isArray(this.existingItems)) {
            data["existingItems"] = [];
            for (let item of this.existingItems)
                data["existingItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): BeneficiaryImportItemImportItemsResult {
        const json = this.toJSON();
        let result = new BeneficiaryImportItemImportItemsResult();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryImportItemImportItemsResult {
    itemsErrors: BeneficiaryImportItemImportItemError[] | undefined;
    existingItems: BeneficiaryImportItem[] | undefined;
}

export class AssetTransferDto implements IAssetTransferDto {
    tenantId: number;
    name: string | undefined;
    number: string | undefined;
    swapped: boolean;
    id: string;

    constructor(data?: IAssetTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.swapped = _data["swapped"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssetTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["number"] = this.number;
        data["swapped"] = this.swapped;
        data["id"] = this.id;
        return data;
    }

    clone(): AssetTransferDto {
        const json = this.toJSON();
        let result = new AssetTransferDto();
        result.init(json);
        return result;
    }
}

export interface IAssetTransferDto {
    tenantId: number;
    name: string | undefined;
    number: string | undefined;
    swapped: boolean;
    id: string;
}

export class BeneficiaryTransferDto implements IBeneficiaryTransferDto {
    beneficiaryId1: string;
    beneficiaryId2: string;
    assetIds1: string[] | undefined;
    assetIds2: string[] | undefined;

    constructor(data?: IBeneficiaryTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beneficiaryId1 = _data["beneficiaryId1"];
            this.beneficiaryId2 = _data["beneficiaryId2"];
            if (Array.isArray(_data["assetIds1"])) {
                this.assetIds1 = [] as any;
                for (let item of _data["assetIds1"])
                    this.assetIds1.push(item);
            }
            if (Array.isArray(_data["assetIds2"])) {
                this.assetIds2 = [] as any;
                for (let item of _data["assetIds2"])
                    this.assetIds2.push(item);
            }
        }
    }

    static fromJS(data: any): BeneficiaryTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiaryId1"] = this.beneficiaryId1;
        data["beneficiaryId2"] = this.beneficiaryId2;
        if (Array.isArray(this.assetIds1)) {
            data["assetIds1"] = [];
            for (let item of this.assetIds1)
                data["assetIds1"].push(item);
        }
        if (Array.isArray(this.assetIds2)) {
            data["assetIds2"] = [];
            for (let item of this.assetIds2)
                data["assetIds2"].push(item);
        }
        return data;
    }

    clone(): BeneficiaryTransferDto {
        const json = this.toJSON();
        let result = new BeneficiaryTransferDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryTransferDto {
    beneficiaryId1: string;
    beneficiaryId2: string;
    assetIds1: string[] | undefined;
    assetIds2: string[] | undefined;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class CostCenterDtoPagedResultDto implements ICostCenterDtoPagedResultDto {
    totalCount: number;
    items: CostCenterDto[] | undefined;

    constructor(data?: ICostCenterDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CostCenterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostCenterDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CostCenterDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CostCenterDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICostCenterDtoPagedResultDto {
    totalCount: number;
    items: CostCenterDto[] | undefined;
}

export class CreateCostCenterDto implements ICreateCostCenterDto {
    name: string | undefined;
    description: string | undefined;

    constructor(data?: ICreateCostCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateCostCenterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCostCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateCostCenterDto {
        const json = this.toJSON();
        let result = new CreateCostCenterDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCostCenterDto {
    name: string | undefined;
    description: string | undefined;
}

export class CostCenterTransferDto implements ICostCenterTransferDto {
    costCenterId1: string;
    costCenterId2: string;
    assetIds1: string[] | undefined;
    assetIds2: string[] | undefined;

    constructor(data?: ICostCenterTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costCenterId1 = _data["costCenterId1"];
            this.costCenterId2 = _data["costCenterId2"];
            if (Array.isArray(_data["assetIds1"])) {
                this.assetIds1 = [] as any;
                for (let item of _data["assetIds1"])
                    this.assetIds1.push(item);
            }
            if (Array.isArray(_data["assetIds2"])) {
                this.assetIds2 = [] as any;
                for (let item of _data["assetIds2"])
                    this.assetIds2.push(item);
            }
        }
    }

    static fromJS(data: any): CostCenterTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costCenterId1"] = this.costCenterId1;
        data["costCenterId2"] = this.costCenterId2;
        if (Array.isArray(this.assetIds1)) {
            data["assetIds1"] = [];
            for (let item of this.assetIds1)
                data["assetIds1"].push(item);
        }
        if (Array.isArray(this.assetIds2)) {
            data["assetIds2"] = [];
            for (let item of this.assetIds2)
                data["assetIds2"].push(item);
        }
        return data;
    }

    clone(): CostCenterTransferDto {
        const json = this.toJSON();
        let result = new CostCenterTransferDto();
        result.init(json);
        return result;
    }
}

export interface ICostCenterTransferDto {
    costCenterId1: string;
    costCenterId2: string;
    assetIds1: string[] | undefined;
    assetIds2: string[] | undefined;
}

export class CostCenterImportItem implements ICostCenterImportItem {
    name: string | undefined;
    description: string | undefined;

    constructor(data?: ICostCenterImportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CostCenterImportItem {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterImportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): CostCenterImportItem {
        const json = this.toJSON();
        let result = new CostCenterImportItem();
        result.init(json);
        return result;
    }
}

export interface ICostCenterImportItem {
    name: string | undefined;
    description: string | undefined;
}

export class CostCenterImportItemImportItemsInput implements ICostCenterImportItemImportItemsInput {
    items: CostCenterImportItem[] | undefined;
    overwrite: boolean;

    constructor(data?: ICostCenterImportItemImportItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CostCenterImportItem.fromJS(item));
            }
            this.overwrite = _data["overwrite"];
        }
    }

    static fromJS(data: any): CostCenterImportItemImportItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterImportItemImportItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["overwrite"] = this.overwrite;
        return data;
    }

    clone(): CostCenterImportItemImportItemsInput {
        const json = this.toJSON();
        let result = new CostCenterImportItemImportItemsInput();
        result.init(json);
        return result;
    }
}

export interface ICostCenterImportItemImportItemsInput {
    items: CostCenterImportItem[] | undefined;
    overwrite: boolean;
}

export class CostCenterImportItemImportItemError implements ICostCenterImportItemImportItemError {
    error: string | undefined;
    item: CostCenterImportItem;

    constructor(data?: ICostCenterImportItemImportItemError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.item = _data["item"] ? CostCenterImportItem.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CostCenterImportItemImportItemError {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterImportItemImportItemError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }

    clone(): CostCenterImportItemImportItemError {
        const json = this.toJSON();
        let result = new CostCenterImportItemImportItemError();
        result.init(json);
        return result;
    }
}

export interface ICostCenterImportItemImportItemError {
    error: string | undefined;
    item: CostCenterImportItem;
}

export class CostCenterImportItemImportItemsResult implements ICostCenterImportItemImportItemsResult {
    itemsErrors: CostCenterImportItemImportItemError[] | undefined;
    existingItems: CostCenterImportItem[] | undefined;

    constructor(data?: ICostCenterImportItemImportItemsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["itemsErrors"])) {
                this.itemsErrors = [] as any;
                for (let item of _data["itemsErrors"])
                    this.itemsErrors.push(CostCenterImportItemImportItemError.fromJS(item));
            }
            if (Array.isArray(_data["existingItems"])) {
                this.existingItems = [] as any;
                for (let item of _data["existingItems"])
                    this.existingItems.push(CostCenterImportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostCenterImportItemImportItemsResult {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterImportItemImportItemsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemsErrors)) {
            data["itemsErrors"] = [];
            for (let item of this.itemsErrors)
                data["itemsErrors"].push(item.toJSON());
        }
        if (Array.isArray(this.existingItems)) {
            data["existingItems"] = [];
            for (let item of this.existingItems)
                data["existingItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): CostCenterImportItemImportItemsResult {
        const json = this.toJSON();
        let result = new CostCenterImportItemImportItemsResult();
        result.init(json);
        return result;
    }
}

export interface ICostCenterImportItemImportItemsResult {
    itemsErrors: CostCenterImportItemImportItemError[] | undefined;
    existingItems: CostCenterImportItem[] | undefined;
}

export class UpdateCostCenterDto implements IUpdateCostCenterDto {
    name: string | undefined;
    description: string | undefined;
    id: string;

    constructor(data?: IUpdateCostCenterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateCostCenterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCostCenterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateCostCenterDto {
        const json = this.toJSON();
        let result = new UpdateCostCenterDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCostCenterDto {
    name: string | undefined;
    description: string | undefined;
    id: string;
}

export class DashboardMaintenanceSummary implements IDashboardMaintenanceSummary {
    status0Count: number;
    status1Count: number;
    status2Count: number;
    noStatusCount: number;
    status4Count: number;
    assetsCount: number;
    maintenanceOutdatedCount: number;
    maintenancePlannedCount: number;
    maintenanceDoneCount: number;

    constructor(data?: IDashboardMaintenanceSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status0Count = _data["status0Count"];
            this.status1Count = _data["status1Count"];
            this.status2Count = _data["status2Count"];
            this.noStatusCount = _data["noStatusCount"];
            this.status4Count = _data["status4Count"];
            this.assetsCount = _data["assetsCount"];
            this.maintenanceOutdatedCount = _data["maintenanceOutdatedCount"];
            this.maintenancePlannedCount = _data["maintenancePlannedCount"];
            this.maintenanceDoneCount = _data["maintenanceDoneCount"];
        }
    }

    static fromJS(data: any): DashboardMaintenanceSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMaintenanceSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status0Count"] = this.status0Count;
        data["status1Count"] = this.status1Count;
        data["status2Count"] = this.status2Count;
        data["noStatusCount"] = this.noStatusCount;
        data["status4Count"] = this.status4Count;
        data["assetsCount"] = this.assetsCount;
        data["maintenanceOutdatedCount"] = this.maintenanceOutdatedCount;
        data["maintenancePlannedCount"] = this.maintenancePlannedCount;
        data["maintenanceDoneCount"] = this.maintenanceDoneCount;
        return data;
    }

    clone(): DashboardMaintenanceSummary {
        const json = this.toJSON();
        let result = new DashboardMaintenanceSummary();
        result.init(json);
        return result;
    }
}

export interface IDashboardMaintenanceSummary {
    status0Count: number;
    status1Count: number;
    status2Count: number;
    noStatusCount: number;
    status4Count: number;
    assetsCount: number;
    maintenanceOutdatedCount: number;
    maintenancePlannedCount: number;
    maintenanceDoneCount: number;
}

export class DashboardSummary implements IDashboardSummary {
    scannedAssetsCount: number;
    notScannedAssetsCount: number;
    status0Count: number;
    status1Count: number;
    status2Count: number;
    noStatusCount: number;
    status4Count: number;
    assetsCount: number;
    toBeClarifiedCount: number;

    constructor(data?: IDashboardSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scannedAssetsCount = _data["scannedAssetsCount"];
            this.notScannedAssetsCount = _data["notScannedAssetsCount"];
            this.status0Count = _data["status0Count"];
            this.status1Count = _data["status1Count"];
            this.status2Count = _data["status2Count"];
            this.noStatusCount = _data["noStatusCount"];
            this.status4Count = _data["status4Count"];
            this.assetsCount = _data["assetsCount"];
            this.toBeClarifiedCount = _data["toBeClarifiedCount"];
        }
    }

    static fromJS(data: any): DashboardSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scannedAssetsCount"] = this.scannedAssetsCount;
        data["notScannedAssetsCount"] = this.notScannedAssetsCount;
        data["status0Count"] = this.status0Count;
        data["status1Count"] = this.status1Count;
        data["status2Count"] = this.status2Count;
        data["noStatusCount"] = this.noStatusCount;
        data["status4Count"] = this.status4Count;
        data["assetsCount"] = this.assetsCount;
        data["toBeClarifiedCount"] = this.toBeClarifiedCount;
        return data;
    }

    clone(): DashboardSummary {
        const json = this.toJSON();
        let result = new DashboardSummary();
        result.init(json);
        return result;
    }
}

export interface IDashboardSummary {
    scannedAssetsCount: number;
    notScannedAssetsCount: number;
    status0Count: number;
    status1Count: number;
    status2Count: number;
    noStatusCount: number;
    status4Count: number;
    assetsCount: number;
    toBeClarifiedCount: number;
}

export class CustomValueBase implements ICustomValueBase {
    preText: string | undefined;
    postText: string | undefined;
    preRenderingValue: string | undefined;
    postRenderingValue: string | undefined;

    constructor(data?: ICustomValueBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preText = _data["preText"];
            this.postText = _data["postText"];
            this.preRenderingValue = _data["preRenderingValue"];
            this.postRenderingValue = _data["postRenderingValue"];
        }
    }

    static fromJS(data: any): CustomValueBase {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValueBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preText"] = this.preText;
        data["postText"] = this.postText;
        data["preRenderingValue"] = this.preRenderingValue;
        data["postRenderingValue"] = this.postRenderingValue;
        return data;
    }

    clone(): CustomValueBase {
        const json = this.toJSON();
        let result = new CustomValueBase();
        result.init(json);
        return result;
    }
}

export interface ICustomValueBase {
    preText: string | undefined;
    postText: string | undefined;
    preRenderingValue: string | undefined;
    postRenderingValue: string | undefined;
}

export class CustomValueRowDescription implements ICustomValueRowDescription {
    items: CustomValueBase[] | undefined;
    preRenderingValue: string | undefined;
    postRenderingValue: string | undefined;

    constructor(data?: ICustomValueRowDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomValueBase.fromJS(item));
            }
            this.preRenderingValue = _data["preRenderingValue"];
            this.postRenderingValue = _data["postRenderingValue"];
        }
    }

    static fromJS(data: any): CustomValueRowDescription {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValueRowDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["preRenderingValue"] = this.preRenderingValue;
        data["postRenderingValue"] = this.postRenderingValue;
        return data;
    }

    clone(): CustomValueRowDescription {
        const json = this.toJSON();
        let result = new CustomValueRowDescription();
        result.init(json);
        return result;
    }
}

export interface ICustomValueRowDescription {
    items: CustomValueBase[] | undefined;
    preRenderingValue: string | undefined;
    postRenderingValue: string | undefined;
}

export class CustomValue implements ICustomValue {
    value: string | undefined;
    preText: string | undefined;
    postText: string | undefined;
    preRenderingValue: string | undefined;
    postRenderingValue: string | undefined;

    constructor(data?: ICustomValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.preText = _data["preText"];
            this.postText = _data["postText"];
            this.preRenderingValue = _data["preRenderingValue"];
            this.postRenderingValue = _data["postRenderingValue"];
        }
    }

    static fromJS(data: any): CustomValue {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["preText"] = this.preText;
        data["postText"] = this.postText;
        data["preRenderingValue"] = this.preRenderingValue;
        data["postRenderingValue"] = this.postRenderingValue;
        return data;
    }

    clone(): CustomValue {
        const json = this.toJSON();
        let result = new CustomValue();
        result.init(json);
        return result;
    }
}

export interface ICustomValue {
    value: string | undefined;
    preText: string | undefined;
    postText: string | undefined;
    preRenderingValue: string | undefined;
    postRenderingValue: string | undefined;
}

export class CustomValueRow implements ICustomValueRow {
    preRenderingValue: string | undefined;
    postRenderingValue: string | undefined;
    items: CustomValue[] | undefined;

    constructor(data?: ICustomValueRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preRenderingValue = _data["preRenderingValue"];
            this.postRenderingValue = _data["postRenderingValue"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomValueRow {
        data = typeof data === 'object' ? data : {};
        let result = new CustomValueRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preRenderingValue"] = this.preRenderingValue;
        data["postRenderingValue"] = this.postRenderingValue;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomValueRow {
        const json = this.toJSON();
        let result = new CustomValueRow();
        result.init(json);
        return result;
    }
}

export interface ICustomValueRow {
    preRenderingValue: string | undefined;
    postRenderingValue: string | undefined;
    items: CustomValue[] | undefined;
}

export class DocumentParameter implements IDocumentParameter {
    label: string | undefined;
    choices: string[] | undefined;
    customValuesRowDescription: CustomValueRowDescription;
    type: number;
    keyName: string | undefined;
    value: string | undefined;
    customValuesRow: CustomValueRow[] | undefined;
    customValuesSepparator: string | undefined;

    constructor(data?: IDocumentParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices.push(item);
            }
            this.customValuesRowDescription = _data["customValuesRowDescription"] ? CustomValueRowDescription.fromJS(_data["customValuesRowDescription"]) : <any>undefined;
            this.type = _data["type"];
            this.keyName = _data["keyName"];
            this.value = _data["value"];
            if (Array.isArray(_data["customValuesRow"])) {
                this.customValuesRow = [] as any;
                for (let item of _data["customValuesRow"])
                    this.customValuesRow.push(CustomValueRow.fromJS(item));
            }
            this.customValuesSepparator = _data["customValuesSepparator"];
        }
    }

    static fromJS(data: any): DocumentParameter {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item);
        }
        data["customValuesRowDescription"] = this.customValuesRowDescription ? this.customValuesRowDescription.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["keyName"] = this.keyName;
        data["value"] = this.value;
        if (Array.isArray(this.customValuesRow)) {
            data["customValuesRow"] = [];
            for (let item of this.customValuesRow)
                data["customValuesRow"].push(item.toJSON());
        }
        data["customValuesSepparator"] = this.customValuesSepparator;
        return data;
    }

    clone(): DocumentParameter {
        const json = this.toJSON();
        let result = new DocumentParameter();
        result.init(json);
        return result;
    }
}

export interface IDocumentParameter {
    label: string | undefined;
    choices: string[] | undefined;
    customValuesRowDescription: CustomValueRowDescription;
    type: number;
    keyName: string | undefined;
    value: string | undefined;
    customValuesRow: CustomValueRow[] | undefined;
    customValuesSepparator: string | undefined;
}

export class DocumentDetails implements IDocumentDetails {
    content: string | undefined;
    parameters: DocumentParameter[] | undefined;

    constructor(data?: IDocumentDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters.push(DocumentParameter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDetails {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        return data;
    }

    clone(): DocumentDetails {
        const json = this.toJSON();
        let result = new DocumentDetails();
        result.init(json);
        return result;
    }
}

export interface IDocumentDetails {
    content: string | undefined;
    parameters: DocumentParameter[] | undefined;
}

export class DocumentParameterBase implements IDocumentParameterBase {
    type: number;
    keyName: string | undefined;
    value: string | undefined;
    customValuesRow: CustomValueRow[] | undefined;
    customValuesSepparator: string | undefined;

    constructor(data?: IDocumentParameterBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.keyName = _data["keyName"];
            this.value = _data["value"];
            if (Array.isArray(_data["customValuesRow"])) {
                this.customValuesRow = [] as any;
                for (let item of _data["customValuesRow"])
                    this.customValuesRow.push(CustomValueRow.fromJS(item));
            }
            this.customValuesSepparator = _data["customValuesSepparator"];
        }
    }

    static fromJS(data: any): DocumentParameterBase {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentParameterBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["keyName"] = this.keyName;
        data["value"] = this.value;
        if (Array.isArray(this.customValuesRow)) {
            data["customValuesRow"] = [];
            for (let item of this.customValuesRow)
                data["customValuesRow"].push(item.toJSON());
        }
        data["customValuesSepparator"] = this.customValuesSepparator;
        return data;
    }

    clone(): DocumentParameterBase {
        const json = this.toJSON();
        let result = new DocumentParameterBase();
        result.init(json);
        return result;
    }
}

export interface IDocumentParameterBase {
    type: number;
    keyName: string | undefined;
    value: string | undefined;
    customValuesRow: CustomValueRow[] | undefined;
    customValuesSepparator: string | undefined;
}

export class CassateItemDto implements ICassateItemDto {
    number: string | undefined;
    name: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    costCenterName: string | undefined;
    lastScanDate: moment.Moment | undefined;
    status: number | undefined;
    username: string | undefined;
    markedForRemove: boolean;
    id: string;

    constructor(data?: ICassateItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.costCenterName = _data["costCenterName"];
            this.lastScanDate = _data["lastScanDate"] ? moment(_data["lastScanDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.username = _data["username"];
            this.markedForRemove = _data["markedForRemove"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CassateItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CassateItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["name"] = this.name;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["costCenterName"] = this.costCenterName;
        data["lastScanDate"] = this.lastScanDate ? this.lastScanDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["username"] = this.username;
        data["markedForRemove"] = this.markedForRemove;
        data["id"] = this.id;
        return data;
    }

    clone(): CassateItemDto {
        const json = this.toJSON();
        let result = new CassateItemDto();
        result.init(json);
        return result;
    }
}

export interface ICassateItemDto {
    number: string | undefined;
    name: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    costCenterName: string | undefined;
    lastScanDate: moment.Moment | undefined;
    status: number | undefined;
    username: string | undefined;
    markedForRemove: boolean;
    id: string;
}

export class CassateInputParams implements ICassateInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    assetName: string | undefined;
    physicalLocationId: string | undefined;
    markedForRemove: boolean | undefined;
    costCenters: string[] | undefined;

    constructor(data?: ICassateInputParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.assetName = _data["assetName"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.markedForRemove = _data["markedForRemove"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters.push(item);
            }
        }
    }

    static fromJS(data: any): CassateInputParams {
        data = typeof data === 'object' ? data : {};
        let result = new CassateInputParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["assetName"] = this.assetName;
        data["physicalLocationId"] = this.physicalLocationId;
        data["markedForRemove"] = this.markedForRemove;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item);
        }
        return data;
    }

    clone(): CassateInputParams {
        const json = this.toJSON();
        let result = new CassateInputParams();
        result.init(json);
        return result;
    }
}

export interface ICassateInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    assetName: string | undefined;
    physicalLocationId: string | undefined;
    markedForRemove: boolean | undefined;
    costCenters: string[] | undefined;
}

export class CassateInputParamsGenerateDocumentInputAssetsList implements ICassateInputParamsGenerateDocumentInputAssetsList {
    parametersInput: DocumentParameterBase[] | undefined;
    filters: CassateInputParams;
    assetIds: string[] | undefined;

    constructor(data?: ICassateInputParamsGenerateDocumentInputAssetsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parametersInput"])) {
                this.parametersInput = [] as any;
                for (let item of _data["parametersInput"])
                    this.parametersInput.push(DocumentParameterBase.fromJS(item));
            }
            this.filters = _data["filters"] ? CassateInputParams.fromJS(_data["filters"]) : <any>undefined;
            if (Array.isArray(_data["assetIds"])) {
                this.assetIds = [] as any;
                for (let item of _data["assetIds"])
                    this.assetIds.push(item);
            }
        }
    }

    static fromJS(data: any): CassateInputParamsGenerateDocumentInputAssetsList {
        data = typeof data === 'object' ? data : {};
        let result = new CassateInputParamsGenerateDocumentInputAssetsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parametersInput)) {
            data["parametersInput"] = [];
            for (let item of this.parametersInput)
                data["parametersInput"].push(item.toJSON());
        }
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        if (Array.isArray(this.assetIds)) {
            data["assetIds"] = [];
            for (let item of this.assetIds)
                data["assetIds"].push(item);
        }
        return data;
    }

    clone(): CassateInputParamsGenerateDocumentInputAssetsList {
        const json = this.toJSON();
        let result = new CassateInputParamsGenerateDocumentInputAssetsList();
        result.init(json);
        return result;
    }
}

export interface ICassateInputParamsGenerateDocumentInputAssetsList {
    parametersInput: DocumentParameterBase[] | undefined;
    filters: CassateInputParams;
    assetIds: string[] | undefined;
}

export class PhysicalItemReportDto implements IPhysicalItemReportDto {
    id: string;
    tenantId: number;
    status: number;
    assetId: string | undefined;
    assetNumber: string | undefined;
    assetName: string | undefined;
    assetCostCenterId: string | undefined;
    costCenterName: string | undefined;
    scanDate: moment.Moment;
    comment: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    pictureFileId: string | undefined;
    userName: string | undefined;

    constructor(data?: IPhysicalItemReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.assetNumber = _data["assetNumber"];
            this.assetName = _data["assetName"];
            this.assetCostCenterId = _data["assetCostCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.scanDate = _data["scanDate"] ? moment(_data["scanDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocationName = _data["physicalLocationName"];
            this.pictureFileId = _data["pictureFileId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): PhysicalItemReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalItemReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["assetNumber"] = this.assetNumber;
        data["assetName"] = this.assetName;
        data["assetCostCenterId"] = this.assetCostCenterId;
        data["costCenterName"] = this.costCenterName;
        data["scanDate"] = this.scanDate ? this.scanDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocationName"] = this.physicalLocationName;
        data["pictureFileId"] = this.pictureFileId;
        data["userName"] = this.userName;
        return data;
    }

    clone(): PhysicalItemReportDto {
        const json = this.toJSON();
        let result = new PhysicalItemReportDto();
        result.init(json);
        return result;
    }
}

export interface IPhysicalItemReportDto {
    id: string;
    tenantId: number;
    status: number;
    assetId: string | undefined;
    assetNumber: string | undefined;
    assetName: string | undefined;
    assetCostCenterId: string | undefined;
    costCenterName: string | undefined;
    scanDate: moment.Moment;
    comment: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    pictureFileId: string | undefined;
    userName: string | undefined;
}

export class InventoryStatementInputParams implements IInventoryStatementInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    filter: string | undefined;
    costCenters: string[] | undefined;

    constructor(data?: IInventoryStatementInputParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.filter = _data["filter"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters.push(item);
            }
        }
    }

    static fromJS(data: any): InventoryStatementInputParams {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryStatementInputParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["filter"] = this.filter;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item);
        }
        return data;
    }

    clone(): InventoryStatementInputParams {
        const json = this.toJSON();
        let result = new InventoryStatementInputParams();
        result.init(json);
        return result;
    }
}

export interface IInventoryStatementInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    filter: string | undefined;
    costCenters: string[] | undefined;
}

export class InventoryStatementInputParamsGenerateDocumentInputAssetsList implements IInventoryStatementInputParamsGenerateDocumentInputAssetsList {
    parametersInput: DocumentParameterBase[] | undefined;
    filters: InventoryStatementInputParams;
    assetIds: string[] | undefined;

    constructor(data?: IInventoryStatementInputParamsGenerateDocumentInputAssetsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parametersInput"])) {
                this.parametersInput = [] as any;
                for (let item of _data["parametersInput"])
                    this.parametersInput.push(DocumentParameterBase.fromJS(item));
            }
            this.filters = _data["filters"] ? InventoryStatementInputParams.fromJS(_data["filters"]) : <any>undefined;
            if (Array.isArray(_data["assetIds"])) {
                this.assetIds = [] as any;
                for (let item of _data["assetIds"])
                    this.assetIds.push(item);
            }
        }
    }

    static fromJS(data: any): InventoryStatementInputParamsGenerateDocumentInputAssetsList {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryStatementInputParamsGenerateDocumentInputAssetsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parametersInput)) {
            data["parametersInput"] = [];
            for (let item of this.parametersInput)
                data["parametersInput"].push(item.toJSON());
        }
        data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
        if (Array.isArray(this.assetIds)) {
            data["assetIds"] = [];
            for (let item of this.assetIds)
                data["assetIds"].push(item);
        }
        return data;
    }

    clone(): InventoryStatementInputParamsGenerateDocumentInputAssetsList {
        const json = this.toJSON();
        let result = new InventoryStatementInputParamsGenerateDocumentInputAssetsList();
        result.init(json);
        return result;
    }
}

export interface IInventoryStatementInputParamsGenerateDocumentInputAssetsList {
    parametersInput: DocumentParameterBase[] | undefined;
    filters: InventoryStatementInputParams;
    assetIds: string[] | undefined;
}

export class GenerateDocumentDefaultInputAssetsList implements IGenerateDocumentDefaultInputAssetsList {
    parametersInput: DocumentParameterBase[] | undefined;
    assetIds: string[] | undefined;

    constructor(data?: IGenerateDocumentDefaultInputAssetsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parametersInput"])) {
                this.parametersInput = [] as any;
                for (let item of _data["parametersInput"])
                    this.parametersInput.push(DocumentParameterBase.fromJS(item));
            }
            if (Array.isArray(_data["assetIds"])) {
                this.assetIds = [] as any;
                for (let item of _data["assetIds"])
                    this.assetIds.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateDocumentDefaultInputAssetsList {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDocumentDefaultInputAssetsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parametersInput)) {
            data["parametersInput"] = [];
            for (let item of this.parametersInput)
                data["parametersInput"].push(item.toJSON());
        }
        if (Array.isArray(this.assetIds)) {
            data["assetIds"] = [];
            for (let item of this.assetIds)
                data["assetIds"].push(item);
        }
        return data;
    }

    clone(): GenerateDocumentDefaultInputAssetsList {
        const json = this.toJSON();
        let result = new GenerateDocumentDefaultInputAssetsList();
        result.init(json);
        return result;
    }
}

export interface IGenerateDocumentDefaultInputAssetsList {
    parametersInput: DocumentParameterBase[] | undefined;
    assetIds: string[] | undefined;
}

export class GenerateDocumentInputBeneficiaryAssets implements IGenerateDocumentInputBeneficiaryAssets {
    parametersInput: DocumentParameterBase[] | undefined;
    beneficiaryId: string;
    receivedAssets: string[] | undefined;
    returnedAssets: string[] | undefined;

    constructor(data?: IGenerateDocumentInputBeneficiaryAssets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parametersInput"])) {
                this.parametersInput = [] as any;
                for (let item of _data["parametersInput"])
                    this.parametersInput.push(DocumentParameterBase.fromJS(item));
            }
            this.beneficiaryId = _data["beneficiaryId"];
            if (Array.isArray(_data["receivedAssets"])) {
                this.receivedAssets = [] as any;
                for (let item of _data["receivedAssets"])
                    this.receivedAssets.push(item);
            }
            if (Array.isArray(_data["returnedAssets"])) {
                this.returnedAssets = [] as any;
                for (let item of _data["returnedAssets"])
                    this.returnedAssets.push(item);
            }
        }
    }

    static fromJS(data: any): GenerateDocumentInputBeneficiaryAssets {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateDocumentInputBeneficiaryAssets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parametersInput)) {
            data["parametersInput"] = [];
            for (let item of this.parametersInput)
                data["parametersInput"].push(item.toJSON());
        }
        data["beneficiaryId"] = this.beneficiaryId;
        if (Array.isArray(this.receivedAssets)) {
            data["receivedAssets"] = [];
            for (let item of this.receivedAssets)
                data["receivedAssets"].push(item);
        }
        if (Array.isArray(this.returnedAssets)) {
            data["returnedAssets"] = [];
            for (let item of this.returnedAssets)
                data["returnedAssets"].push(item);
        }
        return data;
    }

    clone(): GenerateDocumentInputBeneficiaryAssets {
        const json = this.toJSON();
        let result = new GenerateDocumentInputBeneficiaryAssets();
        result.init(json);
        return result;
    }
}

export interface IGenerateDocumentInputBeneficiaryAssets {
    parametersInput: DocumentParameterBase[] | undefined;
    beneficiaryId: string;
    receivedAssets: string[] | undefined;
    returnedAssets: string[] | undefined;
}

export class DocumentHistoryDto implements IDocumentHistoryDto {
    type: string | undefined;
    inventoryFileId: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    fileName: string | undefined;
    mimeType: string | undefined;
    selected: boolean;
    number: number;
    id: string;

    constructor(data?: IDocumentHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.inventoryFileId = _data["inventoryFileId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserName = _data["creatorUserName"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.selected = _data["selected"];
            this.number = _data["number"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DocumentHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["inventoryFileId"] = this.inventoryFileId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["selected"] = this.selected;
        data["number"] = this.number;
        data["id"] = this.id;
        return data;
    }

    clone(): DocumentHistoryDto {
        const json = this.toJSON();
        let result = new DocumentHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentHistoryDto {
    type: string | undefined;
    inventoryFileId: string;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    fileName: string | undefined;
    mimeType: string | undefined;
    selected: boolean;
    number: number;
    id: string;
}

export class UploadResultDto implements IUploadResultDto {
    success: boolean;
    inventoryFileId: string;
    errorMessage: string | undefined;
    type: string | undefined;

    constructor(data?: IUploadResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.inventoryFileId = _data["inventoryFileId"];
            this.errorMessage = _data["errorMessage"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): UploadResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["inventoryFileId"] = this.inventoryFileId;
        data["errorMessage"] = this.errorMessage;
        data["type"] = this.type;
        return data;
    }

    clone(): UploadResultDto {
        const json = this.toJSON();
        let result = new UploadResultDto();
        result.init(json);
        return result;
    }
}

export interface IUploadResultDto {
    success: boolean;
    inventoryFileId: string;
    errorMessage: string | undefined;
    type: string | undefined;
}

export class MaintenanceOperationTaskDto implements IMaintenanceOperationTaskDto {
    id: string | undefined;
    name: string | undefined;

    constructor(data?: IMaintenanceOperationTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): MaintenanceOperationTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceOperationTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): MaintenanceOperationTaskDto {
        const json = this.toJSON();
        let result = new MaintenanceOperationTaskDto();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceOperationTaskDto {
    id: string | undefined;
    name: string | undefined;
}

export class MaintenanceOperationDto implements IMaintenanceOperationDto {
    name: string | undefined;
    tenantId: number;
    tasks: MaintenanceOperationTaskDto[] | undefined;
    id: string;

    constructor(data?: IMaintenanceOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks.push(MaintenanceOperationTaskDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): MaintenanceOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): MaintenanceOperationDto {
        const json = this.toJSON();
        let result = new MaintenanceOperationDto();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceOperationDto {
    name: string | undefined;
    tenantId: number;
    tasks: MaintenanceOperationTaskDto[] | undefined;
    id: string;
}

export class CreateMaintenanceOperationDto implements ICreateMaintenanceOperationDto {
    name: string | undefined;
    tasks: MaintenanceOperationTaskDto[] | undefined;

    constructor(data?: ICreateMaintenanceOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks.push(MaintenanceOperationTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMaintenanceOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaintenanceOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateMaintenanceOperationDto {
        const json = this.toJSON();
        let result = new CreateMaintenanceOperationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMaintenanceOperationDto {
    name: string | undefined;
    tasks: MaintenanceOperationTaskDto[] | undefined;
}

export class UpdateMaintenanceOperationDto implements IUpdateMaintenanceOperationDto {
    name: string | undefined;
    tasks: MaintenanceOperationTaskDto[] | undefined;
    id: string;

    constructor(data?: IUpdateMaintenanceOperationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks.push(MaintenanceOperationTaskDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateMaintenanceOperationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMaintenanceOperationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateMaintenanceOperationDto {
        const json = this.toJSON();
        let result = new UpdateMaintenanceOperationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMaintenanceOperationDto {
    name: string | undefined;
    tasks: MaintenanceOperationTaskDto[] | undefined;
    id: string;
}

export class MaintenanceOperationDtoPagedResultDto implements IMaintenanceOperationDtoPagedResultDto {
    totalCount: number;
    items: MaintenanceOperationDto[] | undefined;

    constructor(data?: IMaintenanceOperationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(MaintenanceOperationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceOperationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceOperationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): MaintenanceOperationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MaintenanceOperationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceOperationDtoPagedResultDto {
    totalCount: number;
    items: MaintenanceOperationDto[] | undefined;
}

export class OnPremiseExpirationStatus implements IOnPremiseExpirationStatus {
    isWarn: boolean;
    message: string | undefined;

    constructor(data?: IOnPremiseExpirationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isWarn = _data["isWarn"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): OnPremiseExpirationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new OnPremiseExpirationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isWarn"] = this.isWarn;
        data["message"] = this.message;
        return data;
    }

    clone(): OnPremiseExpirationStatus {
        const json = this.toJSON();
        let result = new OnPremiseExpirationStatus();
        result.init(json);
        return result;
    }
}

export interface IOnPremiseExpirationStatus {
    isWarn: boolean;
    message: string | undefined;
}

export class OnPremiseLicenseInfo implements IOnPremiseLicenseInfo {
    localKey: string | undefined;
    availableLicenses: number;
    validLicense: boolean;
    until: moment.Moment | undefined;

    constructor(data?: IOnPremiseLicenseInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localKey = _data["localKey"];
            this.availableLicenses = _data["availableLicenses"];
            this.validLicense = _data["validLicense"];
            this.until = _data["until"] ? moment(_data["until"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OnPremiseLicenseInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OnPremiseLicenseInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localKey"] = this.localKey;
        data["availableLicenses"] = this.availableLicenses;
        data["validLicense"] = this.validLicense;
        data["until"] = this.until ? this.until.toISOString() : <any>undefined;
        return data;
    }

    clone(): OnPremiseLicenseInfo {
        const json = this.toJSON();
        let result = new OnPremiseLicenseInfo();
        result.init(json);
        return result;
    }
}

export interface IOnPremiseLicenseInfo {
    localKey: string | undefined;
    availableLicenses: number;
    validLicense: boolean;
    until: moment.Moment | undefined;
}

export class ExternalTenantInfo implements IExternalTenantInfo {
    companyName: string | undefined;
    licensesCount: number;
    serverName: string | undefined;
    creationTime: moment.Moment;
    otherInfo: string | undefined;
    vat: string | undefined;
    alias: string | undefined;
    expirationTime: moment.Moment | undefined;

    constructor(data?: IExternalTenantInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.licensesCount = _data["licensesCount"];
            this.serverName = _data["serverName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.otherInfo = _data["otherInfo"];
            this.vat = _data["vat"];
            this.alias = _data["alias"];
            this.expirationTime = _data["expirationTime"] ? moment(_data["expirationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalTenantInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTenantInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["licensesCount"] = this.licensesCount;
        data["serverName"] = this.serverName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["otherInfo"] = this.otherInfo;
        data["vat"] = this.vat;
        data["alias"] = this.alias;
        data["expirationTime"] = this.expirationTime ? this.expirationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ExternalTenantInfo {
        const json = this.toJSON();
        let result = new ExternalTenantInfo();
        result.init(json);
        return result;
    }
}

export interface IExternalTenantInfo {
    companyName: string | undefined;
    licensesCount: number;
    serverName: string | undefined;
    creationTime: moment.Moment;
    otherInfo: string | undefined;
    vat: string | undefined;
    alias: string | undefined;
    expirationTime: moment.Moment | undefined;
}

export class ExternalClientDto implements IExternalClientDto {
    localKey: string | undefined;
    isActive: boolean;
    generatedKey: string | undefined;
    timestamp: moment.Moment;
    tenantInfo: ExternalTenantInfo;
    id: string;

    constructor(data?: IExternalClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localKey = _data["localKey"];
            this.isActive = _data["isActive"];
            this.generatedKey = _data["generatedKey"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.tenantInfo = _data["tenantInfo"] ? ExternalTenantInfo.fromJS(_data["tenantInfo"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExternalClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localKey"] = this.localKey;
        data["isActive"] = this.isActive;
        data["generatedKey"] = this.generatedKey;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["tenantInfo"] = this.tenantInfo ? this.tenantInfo.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): ExternalClientDto {
        const json = this.toJSON();
        let result = new ExternalClientDto();
        result.init(json);
        return result;
    }
}

export interface IExternalClientDto {
    localKey: string | undefined;
    isActive: boolean;
    generatedKey: string | undefined;
    timestamp: moment.Moment;
    tenantInfo: ExternalTenantInfo;
    id: string;
}

export class GenerateKeyInput implements IGenerateKeyInput {
    localKey: string | undefined;
    licensesCount: number;
    otherInfo: string | undefined;
    vat: string | undefined;
    expires: moment.Moment | undefined;

    constructor(data?: IGenerateKeyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localKey = _data["localKey"];
            this.licensesCount = _data["licensesCount"];
            this.otherInfo = _data["otherInfo"];
            this.vat = _data["vat"];
            this.expires = _data["expires"] ? moment(_data["expires"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GenerateKeyInput {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateKeyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localKey"] = this.localKey;
        data["licensesCount"] = this.licensesCount;
        data["otherInfo"] = this.otherInfo;
        data["vat"] = this.vat;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>undefined;
        return data;
    }

    clone(): GenerateKeyInput {
        const json = this.toJSON();
        let result = new GenerateKeyInput();
        result.init(json);
        return result;
    }
}

export interface IGenerateKeyInput {
    localKey: string | undefined;
    licensesCount: number;
    otherInfo: string | undefined;
    vat: string | undefined;
    expires: moment.Moment | undefined;
}

export class TenantProfileDto implements ITenantProfileDto {
    address: string | undefined;
    cui: string | undefined;
    registerNumber: string | undefined;
    phoneNumber: string | undefined;
    representativeName: string | undefined;
    id: string;

    constructor(data?: ITenantProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.cui = _data["cui"];
            this.registerNumber = _data["registerNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.representativeName = _data["representativeName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["cui"] = this.cui;
        data["registerNumber"] = this.registerNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["representativeName"] = this.representativeName;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantProfileDto {
        const json = this.toJSON();
        let result = new TenantProfileDto();
        result.init(json);
        return result;
    }
}

export interface ITenantProfileDto {
    address: string | undefined;
    cui: string | undefined;
    registerNumber: string | undefined;
    phoneNumber: string | undefined;
    representativeName: string | undefined;
    id: string;
}

export class UserDto implements IUserDto {
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    isTechnician: boolean;
    isClient: boolean;
    costCenterIds: string[] | undefined;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    id: number;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.isTechnician = _data["isTechnician"];
            this.isClient = _data["isClient"];
            if (Array.isArray(_data["costCenterIds"])) {
                this.costCenterIds = [] as any;
                for (let item of _data["costCenterIds"])
                    this.costCenterIds.push(item);
            }
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["isTechnician"] = this.isTechnician;
        data["isClient"] = this.isClient;
        if (Array.isArray(this.costCenterIds)) {
            data["costCenterIds"] = [];
            for (let item of this.costCenterIds)
                data["costCenterIds"].push(item);
        }
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    isTechnician: boolean;
    isClient: boolean;
    costCenterIds: string[] | undefined;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
    id: number;
}

export class PhysicalItemDto implements IPhysicalItemDto {
    tenantId: number;
    status: number;
    assetId: string | undefined;
    asset: AssetDto;
    scanDate: moment.Moment;
    comment: string | undefined;
    matchingName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocation: PhysicalLocationDto;
    pictureFileId: string | undefined;
    inventoryType: number;
    creatorUser: UserDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IPhysicalItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.scanDate = _data["scanDate"] ? moment(_data["scanDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.matchingName = _data["matchingName"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocation = _data["physicalLocation"] ? PhysicalLocationDto.fromJS(_data["physicalLocation"]) : <any>undefined;
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.creatorUser = _data["creatorUser"] ? UserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PhysicalItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["scanDate"] = this.scanDate ? this.scanDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["matchingName"] = this.matchingName;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocation"] = this.physicalLocation ? this.physicalLocation.toJSON() : <any>undefined;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): PhysicalItemDto {
        const json = this.toJSON();
        let result = new PhysicalItemDto();
        result.init(json);
        return result;
    }
}

export interface IPhysicalItemDto {
    tenantId: number;
    status: number;
    assetId: string | undefined;
    asset: AssetDto;
    scanDate: moment.Moment;
    comment: string | undefined;
    matchingName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocation: PhysicalLocationDto;
    pictureFileId: string | undefined;
    inventoryType: number;
    creatorUser: UserDto;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreatePhysicalItemDto implements ICreatePhysicalItemDto {
    id: string | undefined;
    status: number;
    assetId: string | undefined;
    scanDate: moment.Moment;
    comment: string | undefined;
    matchingName: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;

    constructor(data?: ICreatePhysicalItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.scanDate = _data["scanDate"] ? moment(_data["scanDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.matchingName = _data["matchingName"];
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.physicalLocationId = _data["physicalLocationId"];
        }
    }

    static fromJS(data: any): CreatePhysicalItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePhysicalItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["scanDate"] = this.scanDate ? this.scanDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["matchingName"] = this.matchingName;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["physicalLocationId"] = this.physicalLocationId;
        return data;
    }

    clone(): CreatePhysicalItemDto {
        const json = this.toJSON();
        let result = new CreatePhysicalItemDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePhysicalItemDto {
    id: string | undefined;
    status: number;
    assetId: string | undefined;
    scanDate: moment.Moment;
    comment: string | undefined;
    matchingName: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
}

export class UpdatePhysicalItemDto implements IUpdatePhysicalItemDto {
    status: number;
    assetId: string | undefined;
    scanDate: moment.Moment;
    comment: string | undefined;
    matchingName: string | undefined;
    pictureFileId: string | undefined;
    physicalLocationId: string | undefined;
    id: string;

    constructor(data?: IUpdatePhysicalItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.scanDate = _data["scanDate"] ? moment(_data["scanDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.matchingName = _data["matchingName"];
            this.pictureFileId = _data["pictureFileId"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePhysicalItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhysicalItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["scanDate"] = this.scanDate ? this.scanDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["matchingName"] = this.matchingName;
        data["pictureFileId"] = this.pictureFileId;
        data["physicalLocationId"] = this.physicalLocationId;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdatePhysicalItemDto {
        const json = this.toJSON();
        let result = new UpdatePhysicalItemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePhysicalItemDto {
    status: number;
    assetId: string | undefined;
    scanDate: moment.Moment;
    comment: string | undefined;
    matchingName: string | undefined;
    pictureFileId: string | undefined;
    physicalLocationId: string | undefined;
    id: string;
}

export class BindPhysicalAssetItemDto implements IBindPhysicalAssetItemDto {
    assetId: string | undefined;
    id: string;

    constructor(data?: IBindPhysicalAssetItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BindPhysicalAssetItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BindPhysicalAssetItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["id"] = this.id;
        return data;
    }

    clone(): BindPhysicalAssetItemDto {
        const json = this.toJSON();
        let result = new BindPhysicalAssetItemDto();
        result.init(json);
        return result;
    }
}

export interface IBindPhysicalAssetItemDto {
    assetId: string | undefined;
    id: string;
}

export class PhysicalItemDtoPagedResultDto implements IPhysicalItemDtoPagedResultDto {
    totalCount: number;
    items: PhysicalItemDto[] | undefined;

    constructor(data?: IPhysicalItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PhysicalItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhysicalItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PhysicalItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PhysicalItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPhysicalItemDtoPagedResultDto {
    totalCount: number;
    items: PhysicalItemDto[] | undefined;
}

export class PhysicalLocationDtoPagedResultDto implements IPhysicalLocationDtoPagedResultDto {
    totalCount: number;
    items: PhysicalLocationDto[] | undefined;

    constructor(data?: IPhysicalLocationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PhysicalLocationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhysicalLocationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalLocationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PhysicalLocationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PhysicalLocationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPhysicalLocationDtoPagedResultDto {
    totalCount: number;
    items: PhysicalLocationDto[] | undefined;
}

export class CreatePhysicalLocationDto implements ICreatePhysicalLocationDto {
    name: string | undefined;
    latitude: number;
    longitude: number;
    address: string | undefined;

    constructor(data?: ICreatePhysicalLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): CreatePhysicalLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePhysicalLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        return data;
    }

    clone(): CreatePhysicalLocationDto {
        const json = this.toJSON();
        let result = new CreatePhysicalLocationDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePhysicalLocationDto {
    name: string | undefined;
    latitude: number;
    longitude: number;
    address: string | undefined;
}

export class UpdatePhysicalLocationDto implements IUpdatePhysicalLocationDto {
    name: string | undefined;
    latitude: number;
    longitude: number;
    address: string | undefined;
    id: string;

    constructor(data?: IUpdatePhysicalLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdatePhysicalLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhysicalLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdatePhysicalLocationDto {
        const json = this.toJSON();
        let result = new UpdatePhysicalLocationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePhysicalLocationDto {
    name: string | undefined;
    latitude: number;
    longitude: number;
    address: string | undefined;
    id: string;
}

export class PhysicalLocationImportItem implements IPhysicalLocationImportItem {
    name: string | undefined;
    latitude: number;
    longitude: number;

    constructor(data?: IPhysicalLocationImportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): PhysicalLocationImportItem {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalLocationImportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }

    clone(): PhysicalLocationImportItem {
        const json = this.toJSON();
        let result = new PhysicalLocationImportItem();
        result.init(json);
        return result;
    }
}

export interface IPhysicalLocationImportItem {
    name: string | undefined;
    latitude: number;
    longitude: number;
}

export class PhysicalLocationImportItemImportItemsInput implements IPhysicalLocationImportItemImportItemsInput {
    items: PhysicalLocationImportItem[] | undefined;
    overwrite: boolean;

    constructor(data?: IPhysicalLocationImportItemImportItemsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PhysicalLocationImportItem.fromJS(item));
            }
            this.overwrite = _data["overwrite"];
        }
    }

    static fromJS(data: any): PhysicalLocationImportItemImportItemsInput {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalLocationImportItemImportItemsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["overwrite"] = this.overwrite;
        return data;
    }

    clone(): PhysicalLocationImportItemImportItemsInput {
        const json = this.toJSON();
        let result = new PhysicalLocationImportItemImportItemsInput();
        result.init(json);
        return result;
    }
}

export interface IPhysicalLocationImportItemImportItemsInput {
    items: PhysicalLocationImportItem[] | undefined;
    overwrite: boolean;
}

export class PhysicalLocationImportItemImportItemError implements IPhysicalLocationImportItemImportItemError {
    error: string | undefined;
    item: PhysicalLocationImportItem;

    constructor(data?: IPhysicalLocationImportItemImportItemError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"];
            this.item = _data["item"] ? PhysicalLocationImportItem.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PhysicalLocationImportItemImportItemError {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalLocationImportItemImportItemError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }

    clone(): PhysicalLocationImportItemImportItemError {
        const json = this.toJSON();
        let result = new PhysicalLocationImportItemImportItemError();
        result.init(json);
        return result;
    }
}

export interface IPhysicalLocationImportItemImportItemError {
    error: string | undefined;
    item: PhysicalLocationImportItem;
}

export class PhysicalLocationImportItemImportItemsResult implements IPhysicalLocationImportItemImportItemsResult {
    itemsErrors: PhysicalLocationImportItemImportItemError[] | undefined;
    existingItems: PhysicalLocationImportItem[] | undefined;

    constructor(data?: IPhysicalLocationImportItemImportItemsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["itemsErrors"])) {
                this.itemsErrors = [] as any;
                for (let item of _data["itemsErrors"])
                    this.itemsErrors.push(PhysicalLocationImportItemImportItemError.fromJS(item));
            }
            if (Array.isArray(_data["existingItems"])) {
                this.existingItems = [] as any;
                for (let item of _data["existingItems"])
                    this.existingItems.push(PhysicalLocationImportItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PhysicalLocationImportItemImportItemsResult {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalLocationImportItemImportItemsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.itemsErrors)) {
            data["itemsErrors"] = [];
            for (let item of this.itemsErrors)
                data["itemsErrors"].push(item.toJSON());
        }
        if (Array.isArray(this.existingItems)) {
            data["existingItems"] = [];
            for (let item of this.existingItems)
                data["existingItems"].push(item.toJSON());
        }
        return data;
    }

    clone(): PhysicalLocationImportItemImportItemsResult {
        const json = this.toJSON();
        let result = new PhysicalLocationImportItemImportItemsResult();
        result.init(json);
        return result;
    }
}

export interface IPhysicalLocationImportItemImportItemsResult {
    itemsErrors: PhysicalLocationImportItemImportItemError[] | undefined;
    existingItems: PhysicalLocationImportItem[] | undefined;
}

export class LocationLimits implements ILocationLimits {
    minLatitude: number;
    maxLatitude: number;
    minLongitude: number;
    maxLongitude: number;

    constructor(data?: ILocationLimits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minLatitude = _data["minLatitude"];
            this.maxLatitude = _data["maxLatitude"];
            this.minLongitude = _data["minLongitude"];
            this.maxLongitude = _data["maxLongitude"];
        }
    }

    static fromJS(data: any): LocationLimits {
        data = typeof data === 'object' ? data : {};
        let result = new LocationLimits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLatitude"] = this.minLatitude;
        data["maxLatitude"] = this.maxLatitude;
        data["minLongitude"] = this.minLongitude;
        data["maxLongitude"] = this.maxLongitude;
        return data;
    }

    clone(): LocationLimits {
        const json = this.toJSON();
        let result = new LocationLimits();
        result.init(json);
        return result;
    }
}

export interface ILocationLimits {
    minLatitude: number;
    maxLatitude: number;
    minLongitude: number;
    maxLongitude: number;
}

export class PhysicalLocationLimitsDto implements IPhysicalLocationLimitsDto {
    locationLimits: LocationLimits;
    distanceToCenter: number | undefined;
    name: string | undefined;
    latitude: number;
    longitude: number;
    address: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    selected: boolean;
    id: string;

    constructor(data?: IPhysicalLocationLimitsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationLimits = _data["locationLimits"] ? LocationLimits.fromJS(_data["locationLimits"]) : <any>undefined;
            this.distanceToCenter = _data["distanceToCenter"];
            this.name = _data["name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.address = _data["address"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            this.selected = _data["selected"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PhysicalLocationLimitsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalLocationLimitsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationLimits"] = this.locationLimits ? this.locationLimits.toJSON() : <any>undefined;
        data["distanceToCenter"] = this.distanceToCenter;
        data["name"] = this.name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["address"] = this.address;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        data["selected"] = this.selected;
        data["id"] = this.id;
        return data;
    }

    clone(): PhysicalLocationLimitsDto {
        const json = this.toJSON();
        let result = new PhysicalLocationLimitsDto();
        result.init(json);
        return result;
    }
}

export interface IPhysicalLocationLimitsDto {
    locationLimits: LocationLimits;
    distanceToCenter: number | undefined;
    name: string | undefined;
    latitude: number;
    longitude: number;
    address: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    selected: boolean;
    id: string;
}

export class RepairDto implements IRepairDto {
    tenantId: number;
    repairDate: moment.Moment;
    nextRepairDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    asset: AssetDto;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    physicalLocation: PhysicalLocationDto;
    creatorUser: UserDto;
    files: RepairFileDetails[] | undefined;
    lastRepairDate: moment.Moment | undefined;
    repairInstructions: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.repairDate = _data["repairDate"] ? moment(_data["repairDate"].toString()) : <any>undefined;
            this.nextRepairDate = _data["nextRepairDate"] ? moment(_data["nextRepairDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.comment = _data["comment"];
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocation = _data["physicalLocation"] ? PhysicalLocationDto.fromJS(_data["physicalLocation"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? UserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(RepairFileDetails.fromJS(item));
            }
            this.lastRepairDate = _data["lastRepairDate"] ? moment(_data["lastRepairDate"].toString()) : <any>undefined;
            this.repairInstructions = _data["repairInstructions"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["repairDate"] = this.repairDate ? this.repairDate.toISOString() : <any>undefined;
        data["nextRepairDate"] = this.nextRepairDate ? this.nextRepairDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocation"] = this.physicalLocation ? this.physicalLocation.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["lastRepairDate"] = this.lastRepairDate ? this.lastRepairDate.toISOString() : <any>undefined;
        data["repairInstructions"] = this.repairInstructions;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RepairDto {
        const json = this.toJSON();
        let result = new RepairDto();
        result.init(json);
        return result;
    }
}

export interface IRepairDto {
    tenantId: number;
    repairDate: moment.Moment;
    nextRepairDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    asset: AssetDto;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    physicalLocation: PhysicalLocationDto;
    creatorUser: UserDto;
    files: RepairFileDetails[] | undefined;
    lastRepairDate: moment.Moment | undefined;
    repairInstructions: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateRepairDto implements ICreateRepairDto {
    nextRepairDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    files: string[] | undefined;
    repairInstructions: string | undefined;
    lastPlanningDate: moment.Moment | undefined;

    constructor(data?: ICreateRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextRepairDate = _data["nextRepairDate"] ? moment(_data["nextRepairDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.comment = _data["comment"];
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.physicalLocationId = _data["physicalLocationId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(item);
            }
            this.repairInstructions = _data["repairInstructions"];
            this.lastPlanningDate = _data["lastPlanningDate"] ? moment(_data["lastPlanningDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextRepairDate"] = this.nextRepairDate ? this.nextRepairDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["comment"] = this.comment;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["physicalLocationId"] = this.physicalLocationId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["repairInstructions"] = this.repairInstructions;
        data["lastPlanningDate"] = this.lastPlanningDate ? this.lastPlanningDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateRepairDto {
        const json = this.toJSON();
        let result = new CreateRepairDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRepairDto {
    nextRepairDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    files: string[] | undefined;
    repairInstructions: string | undefined;
    lastPlanningDate: moment.Moment | undefined;
}

export class UpdateRepairDto implements IUpdateRepairDto {
    nextRepairDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    files: string[] | undefined;
    repairInstructions: string | undefined;
    id: string;

    constructor(data?: IUpdateRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextRepairDate = _data["nextRepairDate"] ? moment(_data["nextRepairDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.comment = _data["comment"];
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.physicalLocationId = _data["physicalLocationId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(item);
            }
            this.repairInstructions = _data["repairInstructions"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextRepairDate"] = this.nextRepairDate ? this.nextRepairDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["comment"] = this.comment;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["physicalLocationId"] = this.physicalLocationId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["repairInstructions"] = this.repairInstructions;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateRepairDto {
        const json = this.toJSON();
        let result = new UpdateRepairDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRepairDto {
    nextRepairDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    files: string[] | undefined;
    repairInstructions: string | undefined;
    id: string;
}

export class AssetRepairHistory implements IAssetRepairHistory {
    id: string;
    tenantId: number;
    assetId: string | undefined;
    assetName: string | undefined;
    repairDate: moment.Moment;
    comment: string | undefined;
    physicalLocation: string | undefined;
    user: string | undefined;
    filesNo: number;
    status: number;

    constructor(data?: IAssetRepairHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.repairDate = _data["repairDate"] ? moment(_data["repairDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.physicalLocation = _data["physicalLocation"];
            this.user = _data["user"];
            this.filesNo = _data["filesNo"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AssetRepairHistory {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRepairHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["repairDate"] = this.repairDate ? this.repairDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["physicalLocation"] = this.physicalLocation;
        data["user"] = this.user;
        data["filesNo"] = this.filesNo;
        data["status"] = this.status;
        return data;
    }

    clone(): AssetRepairHistory {
        const json = this.toJSON();
        let result = new AssetRepairHistory();
        result.init(json);
        return result;
    }
}

export interface IAssetRepairHistory {
    id: string;
    tenantId: number;
    assetId: string | undefined;
    assetName: string | undefined;
    repairDate: moment.Moment;
    comment: string | undefined;
    physicalLocation: string | undefined;
    user: string | undefined;
    filesNo: number;
    status: number;
}

export class RepairDtoPagedResultDto implements IRepairDtoPagedResultDto {
    totalCount: number;
    items: RepairDto[] | undefined;

    constructor(data?: IRepairDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RepairDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RepairDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepairDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RepairDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RepairDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRepairDtoPagedResultDto {
    totalCount: number;
    items: RepairDto[] | undefined;
}

export class RepairFileDto implements IRepairFileDto {
    tenantId: number;
    repairId: string;
    fileId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRepairFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.repairId = _data["repairId"];
            this.fileId = _data["fileId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RepairFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepairFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["repairId"] = this.repairId;
        data["fileId"] = this.fileId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RepairFileDto {
        const json = this.toJSON();
        let result = new RepairFileDto();
        result.init(json);
        return result;
    }
}

export interface IRepairFileDto {
    tenantId: number;
    repairId: string;
    fileId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class RepairFileDtoPagedResultDto implements IRepairFileDtoPagedResultDto {
    totalCount: number;
    items: RepairFileDto[] | undefined;

    constructor(data?: IRepairFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RepairFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RepairFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RepairFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RepairFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RepairFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRepairFileDtoPagedResultDto {
    totalCount: number;
    items: RepairFileDto[] | undefined;
}

export class RevisionTaskDto implements IRevisionTaskDto {
    maintenanceOperationTaskId: string | undefined;
    done: boolean;
    revisionTechnicianId: number | undefined;

    constructor(data?: IRevisionTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maintenanceOperationTaskId = _data["maintenanceOperationTaskId"];
            this.done = _data["done"];
            this.revisionTechnicianId = _data["revisionTechnicianId"];
        }
    }

    static fromJS(data: any): RevisionTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maintenanceOperationTaskId"] = this.maintenanceOperationTaskId;
        data["done"] = this.done;
        data["revisionTechnicianId"] = this.revisionTechnicianId;
        return data;
    }

    clone(): RevisionTaskDto {
        const json = this.toJSON();
        let result = new RevisionTaskDto();
        result.init(json);
        return result;
    }
}

export interface IRevisionTaskDto {
    maintenanceOperationTaskId: string | undefined;
    done: boolean;
    revisionTechnicianId: number | undefined;
}

export class RevisionDto implements IRevisionDto {
    tenantId: number;
    revisionDate: moment.Moment;
    nextRevisionDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    asset: AssetDto;
    assetMaintenanceId: string | undefined;
    maintenanceOperationId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    physicalLocation: PhysicalLocationDto;
    creatorUser: UserDto;
    files: RevisionFileDetails[] | undefined;
    lastRevisionDate: moment.Moment | undefined;
    revisionInstructions: string | undefined;
    currentIndex: number | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRevisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.revisionDate = _data["revisionDate"] ? moment(_data["revisionDate"].toString()) : <any>undefined;
            this.nextRevisionDate = _data["nextRevisionDate"] ? moment(_data["nextRevisionDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.assetMaintenanceId = _data["assetMaintenanceId"];
            this.maintenanceOperationId = _data["maintenanceOperationId"];
            this.comment = _data["comment"];
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocation = _data["physicalLocation"] ? PhysicalLocationDto.fromJS(_data["physicalLocation"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? UserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(RevisionFileDetails.fromJS(item));
            }
            this.lastRevisionDate = _data["lastRevisionDate"] ? moment(_data["lastRevisionDate"].toString()) : <any>undefined;
            this.revisionInstructions = _data["revisionInstructions"];
            this.currentIndex = _data["currentIndex"];
            if (Array.isArray(_data["revisionTasks"])) {
                this.revisionTasks = [] as any;
                for (let item of _data["revisionTasks"])
                    this.revisionTasks.push(RevisionTaskDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RevisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["revisionDate"] = this.revisionDate ? this.revisionDate.toISOString() : <any>undefined;
        data["nextRevisionDate"] = this.nextRevisionDate ? this.nextRevisionDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["assetMaintenanceId"] = this.assetMaintenanceId;
        data["maintenanceOperationId"] = this.maintenanceOperationId;
        data["comment"] = this.comment;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocation"] = this.physicalLocation ? this.physicalLocation.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["lastRevisionDate"] = this.lastRevisionDate ? this.lastRevisionDate.toISOString() : <any>undefined;
        data["revisionInstructions"] = this.revisionInstructions;
        data["currentIndex"] = this.currentIndex;
        if (Array.isArray(this.revisionTasks)) {
            data["revisionTasks"] = [];
            for (let item of this.revisionTasks)
                data["revisionTasks"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RevisionDto {
        const json = this.toJSON();
        let result = new RevisionDto();
        result.init(json);
        return result;
    }
}

export interface IRevisionDto {
    tenantId: number;
    revisionDate: moment.Moment;
    nextRevisionDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    asset: AssetDto;
    assetMaintenanceId: string | undefined;
    maintenanceOperationId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    physicalLocation: PhysicalLocationDto;
    creatorUser: UserDto;
    files: RevisionFileDetails[] | undefined;
    lastRevisionDate: moment.Moment | undefined;
    revisionInstructions: string | undefined;
    currentIndex: number | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class CreateRevisionDto implements ICreateRevisionDto {
    nextRevisionDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    assetMaintenanceId: string | undefined;
    maintenanceOperationId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    files: string[] | undefined;
    revisionInstructions: string | undefined;
    lastPlanningDate: moment.Moment | undefined;
    currentIndex: number | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;
    revisionPlanningDate: moment.Moment | undefined;

    constructor(data?: ICreateRevisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextRevisionDate = _data["nextRevisionDate"] ? moment(_data["nextRevisionDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.assetMaintenanceId = _data["assetMaintenanceId"];
            this.maintenanceOperationId = _data["maintenanceOperationId"];
            this.comment = _data["comment"];
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.physicalLocationId = _data["physicalLocationId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(item);
            }
            this.revisionInstructions = _data["revisionInstructions"];
            this.lastPlanningDate = _data["lastPlanningDate"] ? moment(_data["lastPlanningDate"].toString()) : <any>undefined;
            this.currentIndex = _data["currentIndex"];
            if (Array.isArray(_data["revisionTasks"])) {
                this.revisionTasks = [] as any;
                for (let item of _data["revisionTasks"])
                    this.revisionTasks.push(RevisionTaskDto.fromJS(item));
            }
            this.revisionPlanningDate = _data["revisionPlanningDate"] ? moment(_data["revisionPlanningDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateRevisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRevisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextRevisionDate"] = this.nextRevisionDate ? this.nextRevisionDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["assetMaintenanceId"] = this.assetMaintenanceId;
        data["maintenanceOperationId"] = this.maintenanceOperationId;
        data["comment"] = this.comment;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["physicalLocationId"] = this.physicalLocationId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["revisionInstructions"] = this.revisionInstructions;
        data["lastPlanningDate"] = this.lastPlanningDate ? this.lastPlanningDate.toISOString() : <any>undefined;
        data["currentIndex"] = this.currentIndex;
        if (Array.isArray(this.revisionTasks)) {
            data["revisionTasks"] = [];
            for (let item of this.revisionTasks)
                data["revisionTasks"].push(item.toJSON());
        }
        data["revisionPlanningDate"] = this.revisionPlanningDate ? this.revisionPlanningDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateRevisionDto {
        const json = this.toJSON();
        let result = new CreateRevisionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRevisionDto {
    nextRevisionDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    assetMaintenanceId: string | undefined;
    maintenanceOperationId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    files: string[] | undefined;
    revisionInstructions: string | undefined;
    lastPlanningDate: moment.Moment | undefined;
    currentIndex: number | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;
    revisionPlanningDate: moment.Moment | undefined;
}

export class UpdateRevisionDto implements IUpdateRevisionDto {
    nextRevisionDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    assetMaintenanceId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    files: string[] | undefined;
    revisionInstructions: string | undefined;
    currentIndex: number | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;
    id: string;

    constructor(data?: IUpdateRevisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextRevisionDate = _data["nextRevisionDate"] ? moment(_data["nextRevisionDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.assetMaintenanceId = _data["assetMaintenanceId"];
            this.comment = _data["comment"];
            this.pictureFileId = _data["pictureFileId"];
            this.inventoryType = _data["inventoryType"];
            this.physicalLocationId = _data["physicalLocationId"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files.push(item);
            }
            this.revisionInstructions = _data["revisionInstructions"];
            this.currentIndex = _data["currentIndex"];
            if (Array.isArray(_data["revisionTasks"])) {
                this.revisionTasks = [] as any;
                for (let item of _data["revisionTasks"])
                    this.revisionTasks.push(RevisionTaskDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateRevisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRevisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextRevisionDate"] = this.nextRevisionDate ? this.nextRevisionDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["assetMaintenanceId"] = this.assetMaintenanceId;
        data["comment"] = this.comment;
        data["pictureFileId"] = this.pictureFileId;
        data["inventoryType"] = this.inventoryType;
        data["physicalLocationId"] = this.physicalLocationId;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item);
        }
        data["revisionInstructions"] = this.revisionInstructions;
        data["currentIndex"] = this.currentIndex;
        if (Array.isArray(this.revisionTasks)) {
            data["revisionTasks"] = [];
            for (let item of this.revisionTasks)
                data["revisionTasks"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateRevisionDto {
        const json = this.toJSON();
        let result = new UpdateRevisionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRevisionDto {
    nextRevisionDate: moment.Moment | undefined;
    status: number;
    assetId: string | undefined;
    assetMaintenanceId: string | undefined;
    comment: string | undefined;
    pictureFileId: string | undefined;
    inventoryType: number;
    physicalLocationId: string | undefined;
    files: string[] | undefined;
    revisionInstructions: string | undefined;
    currentIndex: number | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;
    id: string;
}

export class AssetRevisionHistory implements IAssetRevisionHistory {
    id: string;
    tenantId: number;
    assetId: string | undefined;
    assetName: string | undefined;
    revisionDate: moment.Moment;
    comment: string | undefined;
    physicalLocation: string | undefined;
    user: string | undefined;
    filesNo: number;
    status: number;

    constructor(data?: IAssetRevisionHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.revisionDate = _data["revisionDate"] ? moment(_data["revisionDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.physicalLocation = _data["physicalLocation"];
            this.user = _data["user"];
            this.filesNo = _data["filesNo"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AssetRevisionHistory {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRevisionHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["revisionDate"] = this.revisionDate ? this.revisionDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["physicalLocation"] = this.physicalLocation;
        data["user"] = this.user;
        data["filesNo"] = this.filesNo;
        data["status"] = this.status;
        return data;
    }

    clone(): AssetRevisionHistory {
        const json = this.toJSON();
        let result = new AssetRevisionHistory();
        result.init(json);
        return result;
    }
}

export interface IAssetRevisionHistory {
    id: string;
    tenantId: number;
    assetId: string | undefined;
    assetName: string | undefined;
    revisionDate: moment.Moment;
    comment: string | undefined;
    physicalLocation: string | undefined;
    user: string | undefined;
    filesNo: number;
    status: number;
}

export class RevisionDtoPagedResultDto implements IRevisionDtoPagedResultDto {
    totalCount: number;
    items: RevisionDto[] | undefined;

    constructor(data?: IRevisionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RevisionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RevisionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RevisionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRevisionDtoPagedResultDto {
    totalCount: number;
    items: RevisionDto[] | undefined;
}

export class RevisionFileDto implements IRevisionFileDto {
    tenantId: number;
    revisionId: string;
    fileId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IRevisionFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.revisionId = _data["revisionId"];
            this.fileId = _data["fileId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RevisionFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["revisionId"] = this.revisionId;
        data["fileId"] = this.fileId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): RevisionFileDto {
        const json = this.toJSON();
        let result = new RevisionFileDto();
        result.init(json);
        return result;
    }
}

export interface IRevisionFileDto {
    tenantId: number;
    revisionId: string;
    fileId: string | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class RevisionFileDtoPagedResultDto implements IRevisionFileDtoPagedResultDto {
    totalCount: number;
    items: RevisionFileDto[] | undefined;

    constructor(data?: IRevisionFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RevisionFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RevisionFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RevisionFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRevisionFileDtoPagedResultDto {
    totalCount: number;
    items: RevisionFileDto[] | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    isStatic: boolean;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    isStatic: boolean;
    id: number;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
    id: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

export class IdentifiedInputParams implements IIdentifiedInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    filter: string | undefined;
    status: number | undefined;
    costCenters: string[] | undefined;

    constructor(data?: IIdentifiedInputParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.filter = _data["filter"];
            this.status = _data["status"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters.push(item);
            }
        }
    }

    static fromJS(data: any): IdentifiedInputParams {
        data = typeof data === 'object' ? data : {};
        let result = new IdentifiedInputParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["filter"] = this.filter;
        data["status"] = this.status;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item);
        }
        return data;
    }

    clone(): IdentifiedInputParams {
        const json = this.toJSON();
        let result = new IdentifiedInputParams();
        result.init(json);
        return result;
    }
}

export interface IIdentifiedInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    filter: string | undefined;
    status: number | undefined;
    costCenters: string[] | undefined;
}

export class NotFoundInputParams implements INotFoundInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    assetName: string | undefined;
    physicalLocationId: string | undefined;
    costCenters: string[] | undefined;

    constructor(data?: INotFoundInputParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.assetName = _data["assetName"];
            this.physicalLocationId = _data["physicalLocationId"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters.push(item);
            }
        }
    }

    static fromJS(data: any): NotFoundInputParams {
        data = typeof data === 'object' ? data : {};
        let result = new NotFoundInputParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["assetName"] = this.assetName;
        data["physicalLocationId"] = this.physicalLocationId;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item);
        }
        return data;
    }

    clone(): NotFoundInputParams {
        const json = this.toJSON();
        let result = new NotFoundInputParams();
        result.init(json);
        return result;
    }
}

export interface INotFoundInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    assetName: string | undefined;
    physicalLocationId: string | undefined;
    costCenters: string[] | undefined;
}

export class PhysicalItemNIReportDto implements IPhysicalItemNIReportDto {
    id: string;
    tenantId: number;
    status: number;
    assetId: string | undefined;
    scanDate: moment.Moment;
    comment: string | undefined;
    matchingName: string | undefined;
    physicalLocationId: string | undefined;
    pictureFileId: string | undefined;
    userName: string | undefined;

    constructor(data?: IPhysicalItemNIReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.status = _data["status"];
            this.assetId = _data["assetId"];
            this.scanDate = _data["scanDate"] ? moment(_data["scanDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.matchingName = _data["matchingName"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.pictureFileId = _data["pictureFileId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): PhysicalItemNIReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhysicalItemNIReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["status"] = this.status;
        data["assetId"] = this.assetId;
        data["scanDate"] = this.scanDate ? this.scanDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["matchingName"] = this.matchingName;
        data["physicalLocationId"] = this.physicalLocationId;
        data["pictureFileId"] = this.pictureFileId;
        data["userName"] = this.userName;
        return data;
    }

    clone(): PhysicalItemNIReportDto {
        const json = this.toJSON();
        let result = new PhysicalItemNIReportDto();
        result.init(json);
        return result;
    }
}

export interface IPhysicalItemNIReportDto {
    id: string;
    tenantId: number;
    status: number;
    assetId: string | undefined;
    scanDate: moment.Moment;
    comment: string | undefined;
    matchingName: string | undefined;
    physicalLocationId: string | undefined;
    pictureFileId: string | undefined;
    userName: string | undefined;
}

export class NotIdentifiedInputParams implements INotIdentifiedInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    comment: string | undefined;
    physicalLocationId: string | undefined;

    constructor(data?: INotIdentifiedInputParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.physicalLocationId = _data["physicalLocationId"];
        }
    }

    static fromJS(data: any): NotIdentifiedInputParams {
        data = typeof data === 'object' ? data : {};
        let result = new NotIdentifiedInputParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["physicalLocationId"] = this.physicalLocationId;
        return data;
    }

    clone(): NotIdentifiedInputParams {
        const json = this.toJSON();
        let result = new NotIdentifiedInputParams();
        result.init(json);
        return result;
    }
}

export interface INotIdentifiedInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    comment: string | undefined;
    physicalLocationId: string | undefined;
}

export class TechnicianUserDto implements ITechnicianUserDto {
    id: number;
    name: string | undefined;
    scanned: boolean;
    inventoryType: number;

    constructor(data?: ITechnicianUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.scanned = _data["scanned"];
            this.inventoryType = _data["inventoryType"];
        }
    }

    static fromJS(data: any): TechnicianUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicianUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["scanned"] = this.scanned;
        data["inventoryType"] = this.inventoryType;
        return data;
    }

    clone(): TechnicianUserDto {
        const json = this.toJSON();
        let result = new TechnicianUserDto();
        result.init(json);
        return result;
    }
}

export interface ITechnicianUserDto {
    id: number;
    name: string | undefined;
    scanned: boolean;
    inventoryType: number;
}

export class AssetRevisionDto implements IAssetRevisionDto {
    tenantId: number;
    id: string;
    name: string | undefined;
    number: string | undefined;
    description: string | undefined;
    costCenterId: string;
    costCenterName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    physicalLocationAddress: string | undefined;
    latitude: number;
    longitude: number;
    pictureFileId: string | undefined;
    lastScanDate: moment.Moment | undefined;
    lastScanUserId: number | undefined;
    lastScanUserName: string | undefined;
    status: number | undefined;
    requireMaintenance: boolean;
    lastRevision: moment.Moment | undefined;
    nextRevision: moment.Moment | undefined;
    maintenanceInterval: number | undefined;
    revisionComments: string | undefined;
    markedForRemove: boolean;
    markedForRemoveUserId: number | undefined;
    assignedRevisionUsers: TechnicianUserDto[] | undefined;
    revisionInstructions: string | undefined;
    revisionDocumentsNo: number;
    planningUserId: number | undefined;
    planningUserName: string | undefined;
    currentIndex: number | undefined;
    revisionIndex: number | undefined;
    lastRepair: moment.Moment | undefined;
    maintenanceFrequencyType: number | undefined;
    maintenanceOperationId: string | undefined;
    assetMaintenanceId: string | undefined;

    constructor(data?: IAssetRevisionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.description = _data["description"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocationName = _data["physicalLocationName"];
            this.physicalLocationAddress = _data["physicalLocationAddress"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.pictureFileId = _data["pictureFileId"];
            this.lastScanDate = _data["lastScanDate"] ? moment(_data["lastScanDate"].toString()) : <any>undefined;
            this.lastScanUserId = _data["lastScanUserId"];
            this.lastScanUserName = _data["lastScanUserName"];
            this.status = _data["status"];
            this.requireMaintenance = _data["requireMaintenance"];
            this.lastRevision = _data["lastRevision"] ? moment(_data["lastRevision"].toString()) : <any>undefined;
            this.nextRevision = _data["nextRevision"] ? moment(_data["nextRevision"].toString()) : <any>undefined;
            this.maintenanceInterval = _data["maintenanceInterval"];
            this.revisionComments = _data["revisionComments"];
            this.markedForRemove = _data["markedForRemove"];
            this.markedForRemoveUserId = _data["markedForRemoveUserId"];
            if (Array.isArray(_data["assignedRevisionUsers"])) {
                this.assignedRevisionUsers = [] as any;
                for (let item of _data["assignedRevisionUsers"])
                    this.assignedRevisionUsers.push(TechnicianUserDto.fromJS(item));
            }
            this.revisionInstructions = _data["revisionInstructions"];
            this.revisionDocumentsNo = _data["revisionDocumentsNo"];
            this.planningUserId = _data["planningUserId"];
            this.planningUserName = _data["planningUserName"];
            this.currentIndex = _data["currentIndex"];
            this.revisionIndex = _data["revisionIndex"];
            this.lastRepair = _data["lastRepair"] ? moment(_data["lastRepair"].toString()) : <any>undefined;
            this.maintenanceFrequencyType = _data["maintenanceFrequencyType"];
            this.maintenanceOperationId = _data["maintenanceOperationId"];
            this.assetMaintenanceId = _data["assetMaintenanceId"];
        }
    }

    static fromJS(data: any): AssetRevisionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRevisionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["description"] = this.description;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocationName"] = this.physicalLocationName;
        data["physicalLocationAddress"] = this.physicalLocationAddress;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["pictureFileId"] = this.pictureFileId;
        data["lastScanDate"] = this.lastScanDate ? this.lastScanDate.toISOString() : <any>undefined;
        data["lastScanUserId"] = this.lastScanUserId;
        data["lastScanUserName"] = this.lastScanUserName;
        data["status"] = this.status;
        data["requireMaintenance"] = this.requireMaintenance;
        data["lastRevision"] = this.lastRevision ? this.lastRevision.toISOString() : <any>undefined;
        data["nextRevision"] = this.nextRevision ? this.nextRevision.toISOString() : <any>undefined;
        data["maintenanceInterval"] = this.maintenanceInterval;
        data["revisionComments"] = this.revisionComments;
        data["markedForRemove"] = this.markedForRemove;
        data["markedForRemoveUserId"] = this.markedForRemoveUserId;
        if (Array.isArray(this.assignedRevisionUsers)) {
            data["assignedRevisionUsers"] = [];
            for (let item of this.assignedRevisionUsers)
                data["assignedRevisionUsers"].push(item.toJSON());
        }
        data["revisionInstructions"] = this.revisionInstructions;
        data["revisionDocumentsNo"] = this.revisionDocumentsNo;
        data["planningUserId"] = this.planningUserId;
        data["planningUserName"] = this.planningUserName;
        data["currentIndex"] = this.currentIndex;
        data["revisionIndex"] = this.revisionIndex;
        data["lastRepair"] = this.lastRepair ? this.lastRepair.toISOString() : <any>undefined;
        data["maintenanceFrequencyType"] = this.maintenanceFrequencyType;
        data["maintenanceOperationId"] = this.maintenanceOperationId;
        data["assetMaintenanceId"] = this.assetMaintenanceId;
        return data;
    }

    clone(): AssetRevisionDto {
        const json = this.toJSON();
        let result = new AssetRevisionDto();
        result.init(json);
        return result;
    }
}

export interface IAssetRevisionDto {
    tenantId: number;
    id: string;
    name: string | undefined;
    number: string | undefined;
    description: string | undefined;
    costCenterId: string;
    costCenterName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    physicalLocationAddress: string | undefined;
    latitude: number;
    longitude: number;
    pictureFileId: string | undefined;
    lastScanDate: moment.Moment | undefined;
    lastScanUserId: number | undefined;
    lastScanUserName: string | undefined;
    status: number | undefined;
    requireMaintenance: boolean;
    lastRevision: moment.Moment | undefined;
    nextRevision: moment.Moment | undefined;
    maintenanceInterval: number | undefined;
    revisionComments: string | undefined;
    markedForRemove: boolean;
    markedForRemoveUserId: number | undefined;
    assignedRevisionUsers: TechnicianUserDto[] | undefined;
    revisionInstructions: string | undefined;
    revisionDocumentsNo: number;
    planningUserId: number | undefined;
    planningUserName: string | undefined;
    currentIndex: number | undefined;
    revisionIndex: number | undefined;
    lastRepair: moment.Moment | undefined;
    maintenanceFrequencyType: number | undefined;
    maintenanceOperationId: string | undefined;
    assetMaintenanceId: string | undefined;
}

export class RevisionInputParams implements IRevisionInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    assetName: string | undefined;
    includeOutdated: boolean;
    userId: number | undefined;
    physicalLocationId: string | undefined;
    planningUserId: number | undefined;
    costCenters: string[] | undefined;

    constructor(data?: IRevisionInputParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.assetName = _data["assetName"];
            this.includeOutdated = _data["includeOutdated"];
            this.userId = _data["userId"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.planningUserId = _data["planningUserId"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters.push(item);
            }
        }
    }

    static fromJS(data: any): RevisionInputParams {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionInputParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["assetName"] = this.assetName;
        data["includeOutdated"] = this.includeOutdated;
        data["userId"] = this.userId;
        data["physicalLocationId"] = this.physicalLocationId;
        data["planningUserId"] = this.planningUserId;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item);
        }
        return data;
    }

    clone(): RevisionInputParams {
        const json = this.toJSON();
        let result = new RevisionInputParams();
        result.init(json);
        return result;
    }
}

export interface IRevisionInputParams {
    startDate: moment.Moment;
    endDate: moment.Moment;
    assetName: string | undefined;
    includeOutdated: boolean;
    userId: number | undefined;
    physicalLocationId: string | undefined;
    planningUserId: number | undefined;
    costCenters: string[] | undefined;
}

export class DirectoryDescriptionParam implements IDirectoryDescriptionParam {
    name: string | undefined;
    fileIds: string[] | undefined;
    directories: DirectoryDescriptionParam[] | undefined;

    constructor(data?: IDirectoryDescriptionParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds.push(item);
            }
            if (Array.isArray(_data["directories"])) {
                this.directories = [] as any;
                for (let item of _data["directories"])
                    this.directories.push(DirectoryDescriptionParam.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DirectoryDescriptionParam {
        data = typeof data === 'object' ? data : {};
        let result = new DirectoryDescriptionParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        if (Array.isArray(this.directories)) {
            data["directories"] = [];
            for (let item of this.directories)
                data["directories"].push(item.toJSON());
        }
        return data;
    }

    clone(): DirectoryDescriptionParam {
        const json = this.toJSON();
        let result = new DirectoryDescriptionParam();
        result.init(json);
        return result;
    }
}

export interface IDirectoryDescriptionParam {
    name: string | undefined;
    fileIds: string[] | undefined;
    directories: DirectoryDescriptionParam[] | undefined;
}

export class StructuredParams implements IStructuredParams {
    directories: DirectoryDescriptionParam[] | undefined;
    fileIds: string[] | undefined;

    constructor(data?: IStructuredParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["directories"])) {
                this.directories = [] as any;
                for (let item of _data["directories"])
                    this.directories.push(DirectoryDescriptionParam.fromJS(item));
            }
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds.push(item);
            }
        }
    }

    static fromJS(data: any): StructuredParams {
        data = typeof data === 'object' ? data : {};
        let result = new StructuredParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.directories)) {
            data["directories"] = [];
            for (let item of this.directories)
                data["directories"].push(item.toJSON());
        }
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }

    clone(): StructuredParams {
        const json = this.toJSON();
        let result = new StructuredParams();
        result.init(json);
        return result;
    }
}

export interface IStructuredParams {
    directories: DirectoryDescriptionParam[] | undefined;
    fileIds: string[] | undefined;
}

export class RevisionUserPDIAsset implements IRevisionUserPDIAsset {
    assetId: string;
    revisionId: string;
    maintenanceOperationId: string | undefined;
    assetName: string | undefined;
    assetNumber: string | undefined;
    revisionDate: moment.Moment;
    lastRevisionDate: moment.Moment | undefined;
    comment: string | undefined;
    revisionFiles: string | undefined;
    revisionFilesNo: number;
    selected: boolean;
    inventoryType: number;
    revisionInstructionsFiles: string | undefined;
    revisionInstructionsFilesNo: number;
    lastPlanningDate: moment.Moment | undefined;
    instructions: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    planningUser: string | undefined;
    revisionPlanningDate: moment.Moment | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;

    constructor(data?: IRevisionUserPDIAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.revisionId = _data["revisionId"];
            this.maintenanceOperationId = _data["maintenanceOperationId"];
            this.assetName = _data["assetName"];
            this.assetNumber = _data["assetNumber"];
            this.revisionDate = _data["revisionDate"] ? moment(_data["revisionDate"].toString()) : <any>undefined;
            this.lastRevisionDate = _data["lastRevisionDate"] ? moment(_data["lastRevisionDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.revisionFiles = _data["revisionFiles"];
            this.revisionFilesNo = _data["revisionFilesNo"];
            this.selected = _data["selected"];
            this.inventoryType = _data["inventoryType"];
            this.revisionInstructionsFiles = _data["revisionInstructionsFiles"];
            this.revisionInstructionsFilesNo = _data["revisionInstructionsFilesNo"];
            this.lastPlanningDate = _data["lastPlanningDate"] ? moment(_data["lastPlanningDate"].toString()) : <any>undefined;
            this.instructions = _data["instructions"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.planningUser = _data["planningUser"];
            this.revisionPlanningDate = _data["revisionPlanningDate"] ? moment(_data["revisionPlanningDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["revisionTasks"])) {
                this.revisionTasks = [] as any;
                for (let item of _data["revisionTasks"])
                    this.revisionTasks.push(RevisionTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionUserPDIAsset {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionUserPDIAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["revisionId"] = this.revisionId;
        data["maintenanceOperationId"] = this.maintenanceOperationId;
        data["assetName"] = this.assetName;
        data["assetNumber"] = this.assetNumber;
        data["revisionDate"] = this.revisionDate ? this.revisionDate.toISOString() : <any>undefined;
        data["lastRevisionDate"] = this.lastRevisionDate ? this.lastRevisionDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["revisionFiles"] = this.revisionFiles;
        data["revisionFilesNo"] = this.revisionFilesNo;
        data["selected"] = this.selected;
        data["inventoryType"] = this.inventoryType;
        data["revisionInstructionsFiles"] = this.revisionInstructionsFiles;
        data["revisionInstructionsFilesNo"] = this.revisionInstructionsFilesNo;
        data["lastPlanningDate"] = this.lastPlanningDate ? this.lastPlanningDate.toISOString() : <any>undefined;
        data["instructions"] = this.instructions;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["planningUser"] = this.planningUser;
        data["revisionPlanningDate"] = this.revisionPlanningDate ? this.revisionPlanningDate.toISOString() : <any>undefined;
        if (Array.isArray(this.revisionTasks)) {
            data["revisionTasks"] = [];
            for (let item of this.revisionTasks)
                data["revisionTasks"].push(item.toJSON());
        }
        return data;
    }

    clone(): RevisionUserPDIAsset {
        const json = this.toJSON();
        let result = new RevisionUserPDIAsset();
        result.init(json);
        return result;
    }
}

export interface IRevisionUserPDIAsset {
    assetId: string;
    revisionId: string;
    maintenanceOperationId: string | undefined;
    assetName: string | undefined;
    assetNumber: string | undefined;
    revisionDate: moment.Moment;
    lastRevisionDate: moment.Moment | undefined;
    comment: string | undefined;
    revisionFiles: string | undefined;
    revisionFilesNo: number;
    selected: boolean;
    inventoryType: number;
    revisionInstructionsFiles: string | undefined;
    revisionInstructionsFilesNo: number;
    lastPlanningDate: moment.Moment | undefined;
    instructions: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    planningUser: string | undefined;
    revisionPlanningDate: moment.Moment | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;
}

export class CommentsItem implements ICommentsItem {
    date: moment.Moment;
    comment: string | undefined;

    constructor(data?: ICommentsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CommentsItem {
        data = typeof data === 'object' ? data : {};
        let result = new CommentsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }

    clone(): CommentsItem {
        const json = this.toJSON();
        let result = new CommentsItem();
        result.init(json);
        return result;
    }
}

export interface ICommentsItem {
    date: moment.Moment;
    comment: string | undefined;
}

export class RevisionUserPDI implements IRevisionUserPDI {
    pdiId: string;
    pdiName: string | undefined;
    assets: RevisionUserPDIAsset[] | undefined;
    assetsCount: number;
    commentsCount: number;
    commentItems: CommentsItem[] | undefined;
    documentsCount: number;

    constructor(data?: IRevisionUserPDI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdiId = _data["pdiId"];
            this.pdiName = _data["pdiName"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets.push(RevisionUserPDIAsset.fromJS(item));
            }
            this.assetsCount = _data["assetsCount"];
            this.commentsCount = _data["commentsCount"];
            if (Array.isArray(_data["commentItems"])) {
                this.commentItems = [] as any;
                for (let item of _data["commentItems"])
                    this.commentItems.push(CommentsItem.fromJS(item));
            }
            this.documentsCount = _data["documentsCount"];
        }
    }

    static fromJS(data: any): RevisionUserPDI {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionUserPDI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdiId"] = this.pdiId;
        data["pdiName"] = this.pdiName;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["assetsCount"] = this.assetsCount;
        data["commentsCount"] = this.commentsCount;
        if (Array.isArray(this.commentItems)) {
            data["commentItems"] = [];
            for (let item of this.commentItems)
                data["commentItems"].push(item.toJSON());
        }
        data["documentsCount"] = this.documentsCount;
        return data;
    }

    clone(): RevisionUserPDI {
        const json = this.toJSON();
        let result = new RevisionUserPDI();
        result.init(json);
        return result;
    }
}

export interface IRevisionUserPDI {
    pdiId: string;
    pdiName: string | undefined;
    assets: RevisionUserPDIAsset[] | undefined;
    assetsCount: number;
    commentsCount: number;
    commentItems: CommentsItem[] | undefined;
    documentsCount: number;
}

export class RevisionUser implements IRevisionUser {
    user: TechnicianUserDto;
    pdIs: RevisionUserPDI[] | undefined;
    selected: boolean;

    constructor(data?: IRevisionUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? TechnicianUserDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["pdIs"])) {
                this.pdIs = [] as any;
                for (let item of _data["pdIs"])
                    this.pdIs.push(RevisionUserPDI.fromJS(item));
            }
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): RevisionUser {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.pdIs)) {
            data["pdIs"] = [];
            for (let item of this.pdIs)
                data["pdIs"].push(item.toJSON());
        }
        data["selected"] = this.selected;
        return data;
    }

    clone(): RevisionUser {
        const json = this.toJSON();
        let result = new RevisionUser();
        result.init(json);
        return result;
    }
}

export interface IRevisionUser {
    user: TechnicianUserDto;
    pdIs: RevisionUserPDI[] | undefined;
    selected: boolean;
}

export class RevisionPDIUser implements IRevisionPDIUser {
    assignedUsers: TechnicianUserDto[] | undefined;
    revisionUsers: TechnicianUserDto[] | undefined;
    assets: RevisionUserPDIAsset[] | undefined;
    assetsCount: number;
    commentsCount: number;
    commentItems: CommentsItem[] | undefined;
    documentsCount: number;

    constructor(data?: IRevisionPDIUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers.push(TechnicianUserDto.fromJS(item));
            }
            if (Array.isArray(_data["revisionUsers"])) {
                this.revisionUsers = [] as any;
                for (let item of _data["revisionUsers"])
                    this.revisionUsers.push(TechnicianUserDto.fromJS(item));
            }
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets.push(RevisionUserPDIAsset.fromJS(item));
            }
            this.assetsCount = _data["assetsCount"];
            this.commentsCount = _data["commentsCount"];
            if (Array.isArray(_data["commentItems"])) {
                this.commentItems = [] as any;
                for (let item of _data["commentItems"])
                    this.commentItems.push(CommentsItem.fromJS(item));
            }
            this.documentsCount = _data["documentsCount"];
        }
    }

    static fromJS(data: any): RevisionPDIUser {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionPDIUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.revisionUsers)) {
            data["revisionUsers"] = [];
            for (let item of this.revisionUsers)
                data["revisionUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["assetsCount"] = this.assetsCount;
        data["commentsCount"] = this.commentsCount;
        if (Array.isArray(this.commentItems)) {
            data["commentItems"] = [];
            for (let item of this.commentItems)
                data["commentItems"].push(item.toJSON());
        }
        data["documentsCount"] = this.documentsCount;
        return data;
    }

    clone(): RevisionPDIUser {
        const json = this.toJSON();
        let result = new RevisionPDIUser();
        result.init(json);
        return result;
    }
}

export interface IRevisionPDIUser {
    assignedUsers: TechnicianUserDto[] | undefined;
    revisionUsers: TechnicianUserDto[] | undefined;
    assets: RevisionUserPDIAsset[] | undefined;
    assetsCount: number;
    commentsCount: number;
    commentItems: CommentsItem[] | undefined;
    documentsCount: number;
}

export class RevisionPDI implements IRevisionPDI {
    pdiId: string;
    pdiName: string | undefined;
    users: RevisionPDIUser[] | undefined;
    selected: boolean;

    constructor(data?: IRevisionPDI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdiId = _data["pdiId"];
            this.pdiName = _data["pdiName"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users.push(RevisionPDIUser.fromJS(item));
            }
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): RevisionPDI {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionPDI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdiId"] = this.pdiId;
        data["pdiName"] = this.pdiName;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["selected"] = this.selected;
        return data;
    }

    clone(): RevisionPDI {
        const json = this.toJSON();
        let result = new RevisionPDI();
        result.init(json);
        return result;
    }
}

export interface IRevisionPDI {
    pdiId: string;
    pdiName: string | undefined;
    users: RevisionPDIUser[] | undefined;
    selected: boolean;
}

export class RevisionAssetDetail implements IRevisionAssetDetail {
    revisionId: string;
    assetMaintenanceId: string;
    maintenanceOperationId: string | undefined;
    pdiId: string;
    pdiName: string | undefined;
    assignedUsers: TechnicianUserDto[] | undefined;
    revisionUsers: TechnicianUserDto[] | undefined;
    revisionDate: moment.Moment;
    lastRevisionDate: moment.Moment | undefined;
    comment: string | undefined;
    inventoryType: number;
    documentsCount: number;
    documents: string | undefined;
    instructions: string | undefined;
    revisionFiles: string | undefined;
    revisionFilesNo: number;
    selected: boolean;
    revisionInstructionsFiles: string | undefined;
    revisionInstructionsFilesNo: number;
    lastPlanningDate: moment.Moment | undefined;
    planningUser: string | undefined;
    revisionPlanningDate: moment.Moment | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;

    constructor(data?: IRevisionAssetDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revisionId = _data["revisionId"];
            this.assetMaintenanceId = _data["assetMaintenanceId"];
            this.maintenanceOperationId = _data["maintenanceOperationId"];
            this.pdiId = _data["pdiId"];
            this.pdiName = _data["pdiName"];
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers.push(TechnicianUserDto.fromJS(item));
            }
            if (Array.isArray(_data["revisionUsers"])) {
                this.revisionUsers = [] as any;
                for (let item of _data["revisionUsers"])
                    this.revisionUsers.push(TechnicianUserDto.fromJS(item));
            }
            this.revisionDate = _data["revisionDate"] ? moment(_data["revisionDate"].toString()) : <any>undefined;
            this.lastRevisionDate = _data["lastRevisionDate"] ? moment(_data["lastRevisionDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.inventoryType = _data["inventoryType"];
            this.documentsCount = _data["documentsCount"];
            this.documents = _data["documents"];
            this.instructions = _data["instructions"];
            this.revisionFiles = _data["revisionFiles"];
            this.revisionFilesNo = _data["revisionFilesNo"];
            this.selected = _data["selected"];
            this.revisionInstructionsFiles = _data["revisionInstructionsFiles"];
            this.revisionInstructionsFilesNo = _data["revisionInstructionsFilesNo"];
            this.lastPlanningDate = _data["lastPlanningDate"] ? moment(_data["lastPlanningDate"].toString()) : <any>undefined;
            this.planningUser = _data["planningUser"];
            this.revisionPlanningDate = _data["revisionPlanningDate"] ? moment(_data["revisionPlanningDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["revisionTasks"])) {
                this.revisionTasks = [] as any;
                for (let item of _data["revisionTasks"])
                    this.revisionTasks.push(RevisionTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RevisionAssetDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionAssetDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revisionId"] = this.revisionId;
        data["assetMaintenanceId"] = this.assetMaintenanceId;
        data["maintenanceOperationId"] = this.maintenanceOperationId;
        data["pdiId"] = this.pdiId;
        data["pdiName"] = this.pdiName;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.revisionUsers)) {
            data["revisionUsers"] = [];
            for (let item of this.revisionUsers)
                data["revisionUsers"].push(item.toJSON());
        }
        data["revisionDate"] = this.revisionDate ? this.revisionDate.toISOString() : <any>undefined;
        data["lastRevisionDate"] = this.lastRevisionDate ? this.lastRevisionDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["inventoryType"] = this.inventoryType;
        data["documentsCount"] = this.documentsCount;
        data["documents"] = this.documents;
        data["instructions"] = this.instructions;
        data["revisionFiles"] = this.revisionFiles;
        data["revisionFilesNo"] = this.revisionFilesNo;
        data["selected"] = this.selected;
        data["revisionInstructionsFiles"] = this.revisionInstructionsFiles;
        data["revisionInstructionsFilesNo"] = this.revisionInstructionsFilesNo;
        data["lastPlanningDate"] = this.lastPlanningDate ? this.lastPlanningDate.toISOString() : <any>undefined;
        data["planningUser"] = this.planningUser;
        data["revisionPlanningDate"] = this.revisionPlanningDate ? this.revisionPlanningDate.toISOString() : <any>undefined;
        if (Array.isArray(this.revisionTasks)) {
            data["revisionTasks"] = [];
            for (let item of this.revisionTasks)
                data["revisionTasks"].push(item.toJSON());
        }
        return data;
    }

    clone(): RevisionAssetDetail {
        const json = this.toJSON();
        let result = new RevisionAssetDetail();
        result.init(json);
        return result;
    }
}

export interface IRevisionAssetDetail {
    revisionId: string;
    assetMaintenanceId: string;
    maintenanceOperationId: string | undefined;
    pdiId: string;
    pdiName: string | undefined;
    assignedUsers: TechnicianUserDto[] | undefined;
    revisionUsers: TechnicianUserDto[] | undefined;
    revisionDate: moment.Moment;
    lastRevisionDate: moment.Moment | undefined;
    comment: string | undefined;
    inventoryType: number;
    documentsCount: number;
    documents: string | undefined;
    instructions: string | undefined;
    revisionFiles: string | undefined;
    revisionFilesNo: number;
    selected: boolean;
    revisionInstructionsFiles: string | undefined;
    revisionInstructionsFilesNo: number;
    lastPlanningDate: moment.Moment | undefined;
    planningUser: string | undefined;
    revisionPlanningDate: moment.Moment | undefined;
    revisionTasks: RevisionTaskDto[] | undefined;
}

export class RevisionAsset implements IRevisionAsset {
    assetId: string;
    assetName: string | undefined;
    assetNumber: string | undefined;
    details: RevisionAssetDetail[] | undefined;
    selected: boolean;
    costCenterId: string | undefined;
    costCenterName: string | undefined;

    constructor(data?: IRevisionAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.assetNumber = _data["assetNumber"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details.push(RevisionAssetDetail.fromJS(item));
            }
            this.selected = _data["selected"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
        }
    }

    static fromJS(data: any): RevisionAsset {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["assetNumber"] = this.assetNumber;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["selected"] = this.selected;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        return data;
    }

    clone(): RevisionAsset {
        const json = this.toJSON();
        let result = new RevisionAsset();
        result.init(json);
        return result;
    }
}

export interface IRevisionAsset {
    assetId: string;
    assetName: string | undefined;
    assetNumber: string | undefined;
    details: RevisionAssetDetail[] | undefined;
    selected: boolean;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
}

export class RepairAssetDetail implements IRepairAssetDetail {
    repairId: string;
    pdiId: string;
    pdiName: string | undefined;
    assignedUsers: TechnicianUserDto[] | undefined;
    repairUsers: TechnicianUserDto[] | undefined;
    repairDate: moment.Moment;
    lastRepairDate: moment.Moment | undefined;
    comment: string | undefined;
    inventoryType: number;
    documentsCount: number;
    documents: string | undefined;
    instructions: string | undefined;
    repairFiles: string | undefined;
    repairFilesNo: number;
    selected: boolean;
    repairInstructionsFiles: string | undefined;
    repairInstructionsFilesNo: number;
    lastPlanningDate: moment.Moment | undefined;
    planningUser: string | undefined;
    repairPlanningDate: moment.Moment | undefined;

    constructor(data?: IRepairAssetDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.repairId = _data["repairId"];
            this.pdiId = _data["pdiId"];
            this.pdiName = _data["pdiName"];
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers.push(TechnicianUserDto.fromJS(item));
            }
            if (Array.isArray(_data["repairUsers"])) {
                this.repairUsers = [] as any;
                for (let item of _data["repairUsers"])
                    this.repairUsers.push(TechnicianUserDto.fromJS(item));
            }
            this.repairDate = _data["repairDate"] ? moment(_data["repairDate"].toString()) : <any>undefined;
            this.lastRepairDate = _data["lastRepairDate"] ? moment(_data["lastRepairDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.inventoryType = _data["inventoryType"];
            this.documentsCount = _data["documentsCount"];
            this.documents = _data["documents"];
            this.instructions = _data["instructions"];
            this.repairFiles = _data["repairFiles"];
            this.repairFilesNo = _data["repairFilesNo"];
            this.selected = _data["selected"];
            this.repairInstructionsFiles = _data["repairInstructionsFiles"];
            this.repairInstructionsFilesNo = _data["repairInstructionsFilesNo"];
            this.lastPlanningDate = _data["lastPlanningDate"] ? moment(_data["lastPlanningDate"].toString()) : <any>undefined;
            this.planningUser = _data["planningUser"];
            this.repairPlanningDate = _data["repairPlanningDate"] ? moment(_data["repairPlanningDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RepairAssetDetail {
        data = typeof data === 'object' ? data : {};
        let result = new RepairAssetDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["repairId"] = this.repairId;
        data["pdiId"] = this.pdiId;
        data["pdiName"] = this.pdiName;
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.repairUsers)) {
            data["repairUsers"] = [];
            for (let item of this.repairUsers)
                data["repairUsers"].push(item.toJSON());
        }
        data["repairDate"] = this.repairDate ? this.repairDate.toISOString() : <any>undefined;
        data["lastRepairDate"] = this.lastRepairDate ? this.lastRepairDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["inventoryType"] = this.inventoryType;
        data["documentsCount"] = this.documentsCount;
        data["documents"] = this.documents;
        data["instructions"] = this.instructions;
        data["repairFiles"] = this.repairFiles;
        data["repairFilesNo"] = this.repairFilesNo;
        data["selected"] = this.selected;
        data["repairInstructionsFiles"] = this.repairInstructionsFiles;
        data["repairInstructionsFilesNo"] = this.repairInstructionsFilesNo;
        data["lastPlanningDate"] = this.lastPlanningDate ? this.lastPlanningDate.toISOString() : <any>undefined;
        data["planningUser"] = this.planningUser;
        data["repairPlanningDate"] = this.repairPlanningDate ? this.repairPlanningDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): RepairAssetDetail {
        const json = this.toJSON();
        let result = new RepairAssetDetail();
        result.init(json);
        return result;
    }
}

export interface IRepairAssetDetail {
    repairId: string;
    pdiId: string;
    pdiName: string | undefined;
    assignedUsers: TechnicianUserDto[] | undefined;
    repairUsers: TechnicianUserDto[] | undefined;
    repairDate: moment.Moment;
    lastRepairDate: moment.Moment | undefined;
    comment: string | undefined;
    inventoryType: number;
    documentsCount: number;
    documents: string | undefined;
    instructions: string | undefined;
    repairFiles: string | undefined;
    repairFilesNo: number;
    selected: boolean;
    repairInstructionsFiles: string | undefined;
    repairInstructionsFilesNo: number;
    lastPlanningDate: moment.Moment | undefined;
    planningUser: string | undefined;
    repairPlanningDate: moment.Moment | undefined;
}

export class RepairAsset implements IRepairAsset {
    assetId: string;
    assetName: string | undefined;
    assetNumber: string | undefined;
    details: RepairAssetDetail[] | undefined;
    selected: boolean;
    costCenterId: string | undefined;
    costCenterName: string | undefined;

    constructor(data?: IRepairAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetName = _data["assetName"];
            this.assetNumber = _data["assetNumber"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details.push(RepairAssetDetail.fromJS(item));
            }
            this.selected = _data["selected"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
        }
    }

    static fromJS(data: any): RepairAsset {
        data = typeof data === 'object' ? data : {};
        let result = new RepairAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetName"] = this.assetName;
        data["assetNumber"] = this.assetNumber;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        data["selected"] = this.selected;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        return data;
    }

    clone(): RepairAsset {
        const json = this.toJSON();
        let result = new RepairAsset();
        result.init(json);
        return result;
    }
}

export interface IRepairAsset {
    assetId: string;
    assetName: string | undefined;
    assetNumber: string | undefined;
    details: RepairAssetDetail[] | undefined;
    selected: boolean;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
}

export class RevisionHistoryInputParamsGroup implements IRevisionHistoryInputParamsGroup {
    groupBy: number;
    usersIds: string[] | undefined;
    pdIs: string[] | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    assetName: string | undefined;
    agentId: number | undefined;
    physicalLocationId: string | undefined;
    planningUserId: number | undefined;
    costCenters: string[] | undefined;

    constructor(data?: IRevisionHistoryInputParamsGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupBy = _data["groupBy"];
            if (Array.isArray(_data["usersIds"])) {
                this.usersIds = [] as any;
                for (let item of _data["usersIds"])
                    this.usersIds.push(item);
            }
            if (Array.isArray(_data["pdIs"])) {
                this.pdIs = [] as any;
                for (let item of _data["pdIs"])
                    this.pdIs.push(item);
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.assetName = _data["assetName"];
            this.agentId = _data["agentId"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.planningUserId = _data["planningUserId"];
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters.push(item);
            }
        }
    }

    static fromJS(data: any): RevisionHistoryInputParamsGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RevisionHistoryInputParamsGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupBy"] = this.groupBy;
        if (Array.isArray(this.usersIds)) {
            data["usersIds"] = [];
            for (let item of this.usersIds)
                data["usersIds"].push(item);
        }
        if (Array.isArray(this.pdIs)) {
            data["pdIs"] = [];
            for (let item of this.pdIs)
                data["pdIs"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["assetName"] = this.assetName;
        data["agentId"] = this.agentId;
        data["physicalLocationId"] = this.physicalLocationId;
        data["planningUserId"] = this.planningUserId;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item);
        }
        return data;
    }

    clone(): RevisionHistoryInputParamsGroup {
        const json = this.toJSON();
        let result = new RevisionHistoryInputParamsGroup();
        result.init(json);
        return result;
    }
}

export interface IRevisionHistoryInputParamsGroup {
    groupBy: number;
    usersIds: string[] | undefined;
    pdIs: string[] | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    assetName: string | undefined;
    agentId: number | undefined;
    physicalLocationId: string | undefined;
    planningUserId: number | undefined;
    costCenters: string[] | undefined;
}

export class AssetRevisionHistoryItemDto implements IAssetRevisionHistoryItemDto {
    userNames: string | undefined;
    usersIds: string | undefined;
    pdiId: string;
    pdiName: string | undefined;
    assetId: string;
    maintenanceOperationId: string | undefined;
    assetMaintenanceId: string | undefined;
    assetName: string | undefined;
    assetNumber: string | undefined;
    revisionId: string;
    revisionDate: moment.Moment;
    lastRevisionDate: moment.Moment | undefined;
    comment: string | undefined;
    revisionFiles: string | undefined;
    status: number;
    inventoryType: number;
    revisionInstructionsFiles: string | undefined;
    lastPlanningDate: moment.Moment | undefined;
    instructions: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    planningUserId: number | undefined;
    revisionPlanningDate: moment.Moment | undefined;

    constructor(data?: IAssetRevisionHistoryItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNames = _data["userNames"];
            this.usersIds = _data["usersIds"];
            this.pdiId = _data["pdiId"];
            this.pdiName = _data["pdiName"];
            this.assetId = _data["assetId"];
            this.maintenanceOperationId = _data["maintenanceOperationId"];
            this.assetMaintenanceId = _data["assetMaintenanceId"];
            this.assetName = _data["assetName"];
            this.assetNumber = _data["assetNumber"];
            this.revisionId = _data["revisionId"];
            this.revisionDate = _data["revisionDate"] ? moment(_data["revisionDate"].toString()) : <any>undefined;
            this.lastRevisionDate = _data["lastRevisionDate"] ? moment(_data["lastRevisionDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.revisionFiles = _data["revisionFiles"];
            this.status = _data["status"];
            this.inventoryType = _data["inventoryType"];
            this.revisionInstructionsFiles = _data["revisionInstructionsFiles"];
            this.lastPlanningDate = _data["lastPlanningDate"] ? moment(_data["lastPlanningDate"].toString()) : <any>undefined;
            this.instructions = _data["instructions"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.planningUserId = _data["planningUserId"];
            this.revisionPlanningDate = _data["revisionPlanningDate"] ? moment(_data["revisionPlanningDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetRevisionHistoryItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRevisionHistoryItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNames"] = this.userNames;
        data["usersIds"] = this.usersIds;
        data["pdiId"] = this.pdiId;
        data["pdiName"] = this.pdiName;
        data["assetId"] = this.assetId;
        data["maintenanceOperationId"] = this.maintenanceOperationId;
        data["assetMaintenanceId"] = this.assetMaintenanceId;
        data["assetName"] = this.assetName;
        data["assetNumber"] = this.assetNumber;
        data["revisionId"] = this.revisionId;
        data["revisionDate"] = this.revisionDate ? this.revisionDate.toISOString() : <any>undefined;
        data["lastRevisionDate"] = this.lastRevisionDate ? this.lastRevisionDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["revisionFiles"] = this.revisionFiles;
        data["status"] = this.status;
        data["inventoryType"] = this.inventoryType;
        data["revisionInstructionsFiles"] = this.revisionInstructionsFiles;
        data["lastPlanningDate"] = this.lastPlanningDate ? this.lastPlanningDate.toISOString() : <any>undefined;
        data["instructions"] = this.instructions;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["planningUserId"] = this.planningUserId;
        data["revisionPlanningDate"] = this.revisionPlanningDate ? this.revisionPlanningDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): AssetRevisionHistoryItemDto {
        const json = this.toJSON();
        let result = new AssetRevisionHistoryItemDto();
        result.init(json);
        return result;
    }
}

export interface IAssetRevisionHistoryItemDto {
    userNames: string | undefined;
    usersIds: string | undefined;
    pdiId: string;
    pdiName: string | undefined;
    assetId: string;
    maintenanceOperationId: string | undefined;
    assetMaintenanceId: string | undefined;
    assetName: string | undefined;
    assetNumber: string | undefined;
    revisionId: string;
    revisionDate: moment.Moment;
    lastRevisionDate: moment.Moment | undefined;
    comment: string | undefined;
    revisionFiles: string | undefined;
    status: number;
    inventoryType: number;
    revisionInstructionsFiles: string | undefined;
    lastPlanningDate: moment.Moment | undefined;
    instructions: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    planningUserId: number | undefined;
    revisionPlanningDate: moment.Moment | undefined;
}

export class AssetRevisionHistoryItem implements IAssetRevisionHistoryItem {
    usersIds: string | undefined;
    pdiId: string;
    pdiName: string | undefined;
    assetId: string;
    maintenanceOperationId: string | undefined;
    assetMaintenanceId: string | undefined;
    assetName: string | undefined;
    assetNumber: string | undefined;
    revisionId: string;
    revisionDate: moment.Moment;
    lastRevisionDate: moment.Moment | undefined;
    comment: string | undefined;
    revisionFiles: string | undefined;
    status: number;
    inventoryType: number;
    revisionInstructionsFiles: string | undefined;
    lastPlanningDate: moment.Moment | undefined;
    instructions: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    planningUserId: number | undefined;
    revisionPlanningDate: moment.Moment | undefined;

    constructor(data?: IAssetRevisionHistoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usersIds = _data["usersIds"];
            this.pdiId = _data["pdiId"];
            this.pdiName = _data["pdiName"];
            this.assetId = _data["assetId"];
            this.maintenanceOperationId = _data["maintenanceOperationId"];
            this.assetMaintenanceId = _data["assetMaintenanceId"];
            this.assetName = _data["assetName"];
            this.assetNumber = _data["assetNumber"];
            this.revisionId = _data["revisionId"];
            this.revisionDate = _data["revisionDate"] ? moment(_data["revisionDate"].toString()) : <any>undefined;
            this.lastRevisionDate = _data["lastRevisionDate"] ? moment(_data["lastRevisionDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.revisionFiles = _data["revisionFiles"];
            this.status = _data["status"];
            this.inventoryType = _data["inventoryType"];
            this.revisionInstructionsFiles = _data["revisionInstructionsFiles"];
            this.lastPlanningDate = _data["lastPlanningDate"] ? moment(_data["lastPlanningDate"].toString()) : <any>undefined;
            this.instructions = _data["instructions"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.planningUserId = _data["planningUserId"];
            this.revisionPlanningDate = _data["revisionPlanningDate"] ? moment(_data["revisionPlanningDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetRevisionHistoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRevisionHistoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usersIds"] = this.usersIds;
        data["pdiId"] = this.pdiId;
        data["pdiName"] = this.pdiName;
        data["assetId"] = this.assetId;
        data["maintenanceOperationId"] = this.maintenanceOperationId;
        data["assetMaintenanceId"] = this.assetMaintenanceId;
        data["assetName"] = this.assetName;
        data["assetNumber"] = this.assetNumber;
        data["revisionId"] = this.revisionId;
        data["revisionDate"] = this.revisionDate ? this.revisionDate.toISOString() : <any>undefined;
        data["lastRevisionDate"] = this.lastRevisionDate ? this.lastRevisionDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["revisionFiles"] = this.revisionFiles;
        data["status"] = this.status;
        data["inventoryType"] = this.inventoryType;
        data["revisionInstructionsFiles"] = this.revisionInstructionsFiles;
        data["lastPlanningDate"] = this.lastPlanningDate ? this.lastPlanningDate.toISOString() : <any>undefined;
        data["instructions"] = this.instructions;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["planningUserId"] = this.planningUserId;
        data["revisionPlanningDate"] = this.revisionPlanningDate ? this.revisionPlanningDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): AssetRevisionHistoryItem {
        const json = this.toJSON();
        let result = new AssetRevisionHistoryItem();
        result.init(json);
        return result;
    }
}

export interface IAssetRevisionHistoryItem {
    usersIds: string | undefined;
    pdiId: string;
    pdiName: string | undefined;
    assetId: string;
    maintenanceOperationId: string | undefined;
    assetMaintenanceId: string | undefined;
    assetName: string | undefined;
    assetNumber: string | undefined;
    revisionId: string;
    revisionDate: moment.Moment;
    lastRevisionDate: moment.Moment | undefined;
    comment: string | undefined;
    revisionFiles: string | undefined;
    status: number;
    inventoryType: number;
    revisionInstructionsFiles: string | undefined;
    lastPlanningDate: moment.Moment | undefined;
    instructions: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    planningUserId: number | undefined;
    revisionPlanningDate: moment.Moment | undefined;
}

export class StockConfigDto implements IStockConfigDto {
    name: string | undefined;
    category: number;
    costCenterId: string | undefined;
    physicalStock: number;
    accountingStock: number;

    constructor(data?: IStockConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.category = _data["category"];
            this.costCenterId = _data["costCenterId"];
            this.physicalStock = _data["physicalStock"];
            this.accountingStock = _data["accountingStock"];
        }
    }

    static fromJS(data: any): StockConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["category"] = this.category;
        data["costCenterId"] = this.costCenterId;
        data["physicalStock"] = this.physicalStock;
        data["accountingStock"] = this.accountingStock;
        return data;
    }

    clone(): StockConfigDto {
        const json = this.toJSON();
        let result = new StockConfigDto();
        result.init(json);
        return result;
    }
}

export interface IStockConfigDto {
    name: string | undefined;
    category: number;
    costCenterId: string | undefined;
    physicalStock: number;
    accountingStock: number;
}

export class StocksInputParams implements IStocksInputParams {
    name: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    costCenterIds: string[] | undefined;
    category: number | undefined;
    groupCostCenter: boolean;

    constructor(data?: IStocksInputParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["costCenterIds"])) {
                this.costCenterIds = [] as any;
                for (let item of _data["costCenterIds"])
                    this.costCenterIds.push(item);
            }
            this.category = _data["category"];
            this.groupCostCenter = _data["groupCostCenter"];
        }
    }

    static fromJS(data: any): StocksInputParams {
        data = typeof data === 'object' ? data : {};
        let result = new StocksInputParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.costCenterIds)) {
            data["costCenterIds"] = [];
            for (let item of this.costCenterIds)
                data["costCenterIds"].push(item);
        }
        data["category"] = this.category;
        data["groupCostCenter"] = this.groupCostCenter;
        return data;
    }

    clone(): StocksInputParams {
        const json = this.toJSON();
        let result = new StocksInputParams();
        result.init(json);
        return result;
    }
}

export interface IStocksInputParams {
    name: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    costCenterIds: string[] | undefined;
    category: number | undefined;
    groupCostCenter: boolean;
}

export class AssetRepairDto implements IAssetRepairDto {
    tenantId: number;
    id: string;
    name: string | undefined;
    number: string | undefined;
    description: string | undefined;
    costCenterId: string;
    costCenterName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    physicalLocationAddress: string | undefined;
    latitude: number;
    longitude: number;
    pictureFileId: string | undefined;
    lastScanDate: moment.Moment | undefined;
    lastScanUserId: number | undefined;
    lastScanUserName: string | undefined;
    status: number | undefined;
    lastRepair: moment.Moment | undefined;
    nextRepair: moment.Moment | undefined;
    repairInterval: number | undefined;
    repairComments: string | undefined;
    markedForRemove: boolean;
    markedForRemoveUserId: number | undefined;
    assignedRepairUsers: TechnicianUserDto[] | undefined;
    repairInstructions: string | undefined;
    repairDocumentsNo: number;
    planningUserId: number | undefined;
    planningUserName: string | undefined;
    lastRevision: moment.Moment | undefined;

    constructor(data?: IAssetRepairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.description = _data["description"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocationName = _data["physicalLocationName"];
            this.physicalLocationAddress = _data["physicalLocationAddress"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.pictureFileId = _data["pictureFileId"];
            this.lastScanDate = _data["lastScanDate"] ? moment(_data["lastScanDate"].toString()) : <any>undefined;
            this.lastScanUserId = _data["lastScanUserId"];
            this.lastScanUserName = _data["lastScanUserName"];
            this.status = _data["status"];
            this.lastRepair = _data["lastRepair"] ? moment(_data["lastRepair"].toString()) : <any>undefined;
            this.nextRepair = _data["nextRepair"] ? moment(_data["nextRepair"].toString()) : <any>undefined;
            this.repairInterval = _data["repairInterval"];
            this.repairComments = _data["repairComments"];
            this.markedForRemove = _data["markedForRemove"];
            this.markedForRemoveUserId = _data["markedForRemoveUserId"];
            if (Array.isArray(_data["assignedRepairUsers"])) {
                this.assignedRepairUsers = [] as any;
                for (let item of _data["assignedRepairUsers"])
                    this.assignedRepairUsers.push(TechnicianUserDto.fromJS(item));
            }
            this.repairInstructions = _data["repairInstructions"];
            this.repairDocumentsNo = _data["repairDocumentsNo"];
            this.planningUserId = _data["planningUserId"];
            this.planningUserName = _data["planningUserName"];
            this.lastRevision = _data["lastRevision"] ? moment(_data["lastRevision"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetRepairDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetRepairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["description"] = this.description;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocationName"] = this.physicalLocationName;
        data["physicalLocationAddress"] = this.physicalLocationAddress;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["pictureFileId"] = this.pictureFileId;
        data["lastScanDate"] = this.lastScanDate ? this.lastScanDate.toISOString() : <any>undefined;
        data["lastScanUserId"] = this.lastScanUserId;
        data["lastScanUserName"] = this.lastScanUserName;
        data["status"] = this.status;
        data["lastRepair"] = this.lastRepair ? this.lastRepair.toISOString() : <any>undefined;
        data["nextRepair"] = this.nextRepair ? this.nextRepair.toISOString() : <any>undefined;
        data["repairInterval"] = this.repairInterval;
        data["repairComments"] = this.repairComments;
        data["markedForRemove"] = this.markedForRemove;
        data["markedForRemoveUserId"] = this.markedForRemoveUserId;
        if (Array.isArray(this.assignedRepairUsers)) {
            data["assignedRepairUsers"] = [];
            for (let item of this.assignedRepairUsers)
                data["assignedRepairUsers"].push(item.toJSON());
        }
        data["repairInstructions"] = this.repairInstructions;
        data["repairDocumentsNo"] = this.repairDocumentsNo;
        data["planningUserId"] = this.planningUserId;
        data["planningUserName"] = this.planningUserName;
        data["lastRevision"] = this.lastRevision ? this.lastRevision.toISOString() : <any>undefined;
        return data;
    }

    clone(): AssetRepairDto {
        const json = this.toJSON();
        let result = new AssetRepairDto();
        result.init(json);
        return result;
    }
}

export interface IAssetRepairDto {
    tenantId: number;
    id: string;
    name: string | undefined;
    number: string | undefined;
    description: string | undefined;
    costCenterId: string;
    costCenterName: string | undefined;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    physicalLocationAddress: string | undefined;
    latitude: number;
    longitude: number;
    pictureFileId: string | undefined;
    lastScanDate: moment.Moment | undefined;
    lastScanUserId: number | undefined;
    lastScanUserName: string | undefined;
    status: number | undefined;
    lastRepair: moment.Moment | undefined;
    nextRepair: moment.Moment | undefined;
    repairInterval: number | undefined;
    repairComments: string | undefined;
    markedForRemove: boolean;
    markedForRemoveUserId: number | undefined;
    assignedRepairUsers: TechnicianUserDto[] | undefined;
    repairInstructions: string | undefined;
    repairDocumentsNo: number;
    planningUserId: number | undefined;
    planningUserName: string | undefined;
    lastRevision: moment.Moment | undefined;
}

export class RepairUserPDIAsset implements IRepairUserPDIAsset {
    assetId: string;
    repairId: string;
    assetName: string | undefined;
    assetNumber: string | undefined;
    repairDate: moment.Moment;
    lastRepairDate: moment.Moment | undefined;
    comment: string | undefined;
    repairFiles: string | undefined;
    repairFilesNo: number;
    selected: boolean;
    inventoryType: number;
    repairInstructionsFiles: string | undefined;
    repairInstructionsFilesNo: number;
    lastPlanningDate: moment.Moment | undefined;
    instructions: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    planningUser: string | undefined;
    repairPlanningDate: moment.Moment | undefined;

    constructor(data?: IRepairUserPDIAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.repairId = _data["repairId"];
            this.assetName = _data["assetName"];
            this.assetNumber = _data["assetNumber"];
            this.repairDate = _data["repairDate"] ? moment(_data["repairDate"].toString()) : <any>undefined;
            this.lastRepairDate = _data["lastRepairDate"] ? moment(_data["lastRepairDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.repairFiles = _data["repairFiles"];
            this.repairFilesNo = _data["repairFilesNo"];
            this.selected = _data["selected"];
            this.inventoryType = _data["inventoryType"];
            this.repairInstructionsFiles = _data["repairInstructionsFiles"];
            this.repairInstructionsFilesNo = _data["repairInstructionsFilesNo"];
            this.lastPlanningDate = _data["lastPlanningDate"] ? moment(_data["lastPlanningDate"].toString()) : <any>undefined;
            this.instructions = _data["instructions"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.planningUser = _data["planningUser"];
            this.repairPlanningDate = _data["repairPlanningDate"] ? moment(_data["repairPlanningDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RepairUserPDIAsset {
        data = typeof data === 'object' ? data : {};
        let result = new RepairUserPDIAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["repairId"] = this.repairId;
        data["assetName"] = this.assetName;
        data["assetNumber"] = this.assetNumber;
        data["repairDate"] = this.repairDate ? this.repairDate.toISOString() : <any>undefined;
        data["lastRepairDate"] = this.lastRepairDate ? this.lastRepairDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["repairFiles"] = this.repairFiles;
        data["repairFilesNo"] = this.repairFilesNo;
        data["selected"] = this.selected;
        data["inventoryType"] = this.inventoryType;
        data["repairInstructionsFiles"] = this.repairInstructionsFiles;
        data["repairInstructionsFilesNo"] = this.repairInstructionsFilesNo;
        data["lastPlanningDate"] = this.lastPlanningDate ? this.lastPlanningDate.toISOString() : <any>undefined;
        data["instructions"] = this.instructions;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["planningUser"] = this.planningUser;
        data["repairPlanningDate"] = this.repairPlanningDate ? this.repairPlanningDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): RepairUserPDIAsset {
        const json = this.toJSON();
        let result = new RepairUserPDIAsset();
        result.init(json);
        return result;
    }
}

export interface IRepairUserPDIAsset {
    assetId: string;
    repairId: string;
    assetName: string | undefined;
    assetNumber: string | undefined;
    repairDate: moment.Moment;
    lastRepairDate: moment.Moment | undefined;
    comment: string | undefined;
    repairFiles: string | undefined;
    repairFilesNo: number;
    selected: boolean;
    inventoryType: number;
    repairInstructionsFiles: string | undefined;
    repairInstructionsFilesNo: number;
    lastPlanningDate: moment.Moment | undefined;
    instructions: string | undefined;
    costCenterId: string | undefined;
    costCenterName: string | undefined;
    planningUser: string | undefined;
    repairPlanningDate: moment.Moment | undefined;
}

export class RepairUserPDI implements IRepairUserPDI {
    pdiId: string;
    pdiName: string | undefined;
    assets: RepairUserPDIAsset[] | undefined;
    assetsCount: number;
    commentsCount: number;
    commentItems: CommentsItem[] | undefined;
    documentsCount: number;

    constructor(data?: IRepairUserPDI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdiId = _data["pdiId"];
            this.pdiName = _data["pdiName"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets.push(RepairUserPDIAsset.fromJS(item));
            }
            this.assetsCount = _data["assetsCount"];
            this.commentsCount = _data["commentsCount"];
            if (Array.isArray(_data["commentItems"])) {
                this.commentItems = [] as any;
                for (let item of _data["commentItems"])
                    this.commentItems.push(CommentsItem.fromJS(item));
            }
            this.documentsCount = _data["documentsCount"];
        }
    }

    static fromJS(data: any): RepairUserPDI {
        data = typeof data === 'object' ? data : {};
        let result = new RepairUserPDI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdiId"] = this.pdiId;
        data["pdiName"] = this.pdiName;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["assetsCount"] = this.assetsCount;
        data["commentsCount"] = this.commentsCount;
        if (Array.isArray(this.commentItems)) {
            data["commentItems"] = [];
            for (let item of this.commentItems)
                data["commentItems"].push(item.toJSON());
        }
        data["documentsCount"] = this.documentsCount;
        return data;
    }

    clone(): RepairUserPDI {
        const json = this.toJSON();
        let result = new RepairUserPDI();
        result.init(json);
        return result;
    }
}

export interface IRepairUserPDI {
    pdiId: string;
    pdiName: string | undefined;
    assets: RepairUserPDIAsset[] | undefined;
    assetsCount: number;
    commentsCount: number;
    commentItems: CommentsItem[] | undefined;
    documentsCount: number;
}

export class RepairUser implements IRepairUser {
    user: TechnicianUserDto;
    pdIs: RepairUserPDI[] | undefined;
    selected: boolean;

    constructor(data?: IRepairUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? TechnicianUserDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["pdIs"])) {
                this.pdIs = [] as any;
                for (let item of _data["pdIs"])
                    this.pdIs.push(RepairUserPDI.fromJS(item));
            }
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): RepairUser {
        data = typeof data === 'object' ? data : {};
        let result = new RepairUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.pdIs)) {
            data["pdIs"] = [];
            for (let item of this.pdIs)
                data["pdIs"].push(item.toJSON());
        }
        data["selected"] = this.selected;
        return data;
    }

    clone(): RepairUser {
        const json = this.toJSON();
        let result = new RepairUser();
        result.init(json);
        return result;
    }
}

export interface IRepairUser {
    user: TechnicianUserDto;
    pdIs: RepairUserPDI[] | undefined;
    selected: boolean;
}

export class RepairPDIUser implements IRepairPDIUser {
    assignedUsers: TechnicianUserDto[] | undefined;
    repairUsers: TechnicianUserDto[] | undefined;
    assets: RepairUserPDIAsset[] | undefined;
    assetsCount: number;
    commentsCount: number;
    commentItems: CommentsItem[] | undefined;
    documentsCount: number;

    constructor(data?: IRepairPDIUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignedUsers"])) {
                this.assignedUsers = [] as any;
                for (let item of _data["assignedUsers"])
                    this.assignedUsers.push(TechnicianUserDto.fromJS(item));
            }
            if (Array.isArray(_data["repairUsers"])) {
                this.repairUsers = [] as any;
                for (let item of _data["repairUsers"])
                    this.repairUsers.push(TechnicianUserDto.fromJS(item));
            }
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets.push(RepairUserPDIAsset.fromJS(item));
            }
            this.assetsCount = _data["assetsCount"];
            this.commentsCount = _data["commentsCount"];
            if (Array.isArray(_data["commentItems"])) {
                this.commentItems = [] as any;
                for (let item of _data["commentItems"])
                    this.commentItems.push(CommentsItem.fromJS(item));
            }
            this.documentsCount = _data["documentsCount"];
        }
    }

    static fromJS(data: any): RepairPDIUser {
        data = typeof data === 'object' ? data : {};
        let result = new RepairPDIUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignedUsers)) {
            data["assignedUsers"] = [];
            for (let item of this.assignedUsers)
                data["assignedUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.repairUsers)) {
            data["repairUsers"] = [];
            for (let item of this.repairUsers)
                data["repairUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["assetsCount"] = this.assetsCount;
        data["commentsCount"] = this.commentsCount;
        if (Array.isArray(this.commentItems)) {
            data["commentItems"] = [];
            for (let item of this.commentItems)
                data["commentItems"].push(item.toJSON());
        }
        data["documentsCount"] = this.documentsCount;
        return data;
    }

    clone(): RepairPDIUser {
        const json = this.toJSON();
        let result = new RepairPDIUser();
        result.init(json);
        return result;
    }
}

export interface IRepairPDIUser {
    assignedUsers: TechnicianUserDto[] | undefined;
    repairUsers: TechnicianUserDto[] | undefined;
    assets: RepairUserPDIAsset[] | undefined;
    assetsCount: number;
    commentsCount: number;
    commentItems: CommentsItem[] | undefined;
    documentsCount: number;
}

export class RepairPDI implements IRepairPDI {
    pdiId: string;
    pdiName: string | undefined;
    users: RepairPDIUser[] | undefined;
    selected: boolean;

    constructor(data?: IRepairPDI) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdiId = _data["pdiId"];
            this.pdiName = _data["pdiName"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users.push(RepairPDIUser.fromJS(item));
            }
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): RepairPDI {
        data = typeof data === 'object' ? data : {};
        let result = new RepairPDI();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdiId"] = this.pdiId;
        data["pdiName"] = this.pdiName;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["selected"] = this.selected;
        return data;
    }

    clone(): RepairPDI {
        const json = this.toJSON();
        let result = new RepairPDI();
        result.init(json);
        return result;
    }
}

export interface IRepairPDI {
    pdiId: string;
    pdiName: string | undefined;
    users: RepairPDIUser[] | undefined;
    selected: boolean;
}

export class GetBeneficiaryAssetsInput implements IGetBeneficiaryAssetsInput {
    filter: string | undefined;
    physicalLocationId: string | undefined;
    beneficiaryId: string | undefined;
    costCenterIds: string[] | undefined;
    status: number | undefined;

    constructor(data?: IGetBeneficiaryAssetsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.beneficiaryId = _data["beneficiaryId"];
            if (Array.isArray(_data["costCenterIds"])) {
                this.costCenterIds = [] as any;
                for (let item of _data["costCenterIds"])
                    this.costCenterIds.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetBeneficiaryAssetsInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBeneficiaryAssetsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter;
        data["physicalLocationId"] = this.physicalLocationId;
        data["beneficiaryId"] = this.beneficiaryId;
        if (Array.isArray(this.costCenterIds)) {
            data["costCenterIds"] = [];
            for (let item of this.costCenterIds)
                data["costCenterIds"].push(item);
        }
        data["status"] = this.status;
        return data;
    }

    clone(): GetBeneficiaryAssetsInput {
        const json = this.toJSON();
        let result = new GetBeneficiaryAssetsInput();
        result.init(json);
        return result;
    }
}

export interface IGetBeneficiaryAssetsInput {
    filter: string | undefined;
    physicalLocationId: string | undefined;
    beneficiaryId: string | undefined;
    costCenterIds: string[] | undefined;
    status: number | undefined;
}

export class BeneficiaryAssetReportDto implements IBeneficiaryAssetReportDto {
    name: string | undefined;
    number: string | undefined;
    description: string | undefined;
    costCenterId: string;
    costCenterName: string | undefined;
    category: number;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    creationTime: moment.Moment;
    status: number | undefined;
    lastScanDate: moment.Moment | undefined;
    id: string;

    constructor(data?: IBeneficiaryAssetReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.number = _data["number"];
            this.description = _data["description"];
            this.costCenterId = _data["costCenterId"];
            this.costCenterName = _data["costCenterName"];
            this.category = _data["category"];
            this.physicalLocationId = _data["physicalLocationId"];
            this.physicalLocationName = _data["physicalLocationName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.lastScanDate = _data["lastScanDate"] ? moment(_data["lastScanDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BeneficiaryAssetReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryAssetReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["number"] = this.number;
        data["description"] = this.description;
        data["costCenterId"] = this.costCenterId;
        data["costCenterName"] = this.costCenterName;
        data["category"] = this.category;
        data["physicalLocationId"] = this.physicalLocationId;
        data["physicalLocationName"] = this.physicalLocationName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["lastScanDate"] = this.lastScanDate ? this.lastScanDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): BeneficiaryAssetReportDto {
        const json = this.toJSON();
        let result = new BeneficiaryAssetReportDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryAssetReportDto {
    name: string | undefined;
    number: string | undefined;
    description: string | undefined;
    costCenterId: string;
    costCenterName: string | undefined;
    category: number;
    physicalLocationId: string | undefined;
    physicalLocationName: string | undefined;
    creationTime: moment.Moment;
    status: number | undefined;
    lastScanDate: moment.Moment | undefined;
    id: string;
}

export class BeneficiaryReportDto implements IBeneficiaryReportDto {
    mark: string | undefined;
    name: string | undefined;
    assets: BeneficiaryAssetReportDto[] | undefined;
    id: string;

    constructor(data?: IBeneficiaryReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mark = _data["mark"];
            this.name = _data["name"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets.push(BeneficiaryAssetReportDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BeneficiaryReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new BeneficiaryReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mark"] = this.mark;
        data["name"] = this.name;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }

    clone(): BeneficiaryReportDto {
        const json = this.toJSON();
        let result = new BeneficiaryReportDto();
        result.init(json);
        return result;
    }
}

export interface IBeneficiaryReportDto {
    mark: string | undefined;
    name: string | undefined;
    assets: BeneficiaryAssetReportDto[] | undefined;
    id: string;
}

export class AssetHistoryDto implements IAssetHistoryDto {
    tenantId: number;
    name: string | undefined;
    number: string | undefined;
    field: string | undefined;
    oldValue: string | undefined;
    newValue: string | undefined;
    type: number;
    fileId: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;

    constructor(data?: IAssetHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.field = _data["field"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.type = _data["type"];
            this.fileId = _data["fileId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssetHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["number"] = this.number;
        data["field"] = this.field;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["type"] = this.type;
        data["fileId"] = this.fileId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }

    clone(): AssetHistoryDto {
        const json = this.toJSON();
        let result = new AssetHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IAssetHistoryDto {
    tenantId: number;
    name: string | undefined;
    number: string | undefined;
    field: string | undefined;
    oldValue: string | undefined;
    newValue: string | undefined;
    type: number;
    fileId: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: string;
}

export class AssetsHistoryInputParams implements IAssetsHistoryInputParams {
    name: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    costCenters: string[] | undefined;
    skip: number;
    take: number;

    constructor(data?: IAssetsHistoryInputParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["costCenters"])) {
                this.costCenters = [] as any;
                for (let item of _data["costCenters"])
                    this.costCenters.push(item);
            }
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): AssetsHistoryInputParams {
        data = typeof data === 'object' ? data : {};
        let result = new AssetsHistoryInputParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.costCenters)) {
            data["costCenters"] = [];
            for (let item of this.costCenters)
                data["costCenters"].push(item);
        }
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }

    clone(): AssetsHistoryInputParams {
        const json = this.toJSON();
        let result = new AssetsHistoryInputParams();
        result.init(json);
        return result;
    }
}

export interface IAssetsHistoryInputParams {
    name: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    costCenters: string[] | undefined;
    skip: number;
    take: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
    onPremise: boolean;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
            this.onPremise = _data["onPremise"];
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        data["onPremise"] = this.onPremise;
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
    onPremise: boolean;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    id: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class BooleanSettingDto implements IBooleanSettingDto {
    key: string | undefined;
    value: boolean;

    constructor(data?: IBooleanSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BooleanSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): BooleanSettingDto {
        const json = this.toJSON();
        let result = new BooleanSettingDto();
        result.init(json);
        return result;
    }
}

export interface IBooleanSettingDto {
    key: string | undefined;
    value: boolean;
}

export class Int32SettingDto implements IInt32SettingDto {
    key: string | undefined;
    value: number;

    constructor(data?: IInt32SettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Int32SettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32SettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): Int32SettingDto {
        const json = this.toJSON();
        let result = new Int32SettingDto();
        result.init(json);
        return result;
    }
}

export interface IInt32SettingDto {
    key: string | undefined;
    value: number;
}

export class StringSettingDto implements IStringSettingDto {
    key: string | undefined;
    value: string | undefined;

    constructor(data?: IStringSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StringSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new StringSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): StringSettingDto {
        const json = this.toJSON();
        let result = new StringSettingDto();
        result.init(json);
        return result;
    }
}

export interface IStringSettingDto {
    key: string | undefined;
    value: string | undefined;
}

export class SettingsDto implements ISettingsDto {
    inventoryWithCoordinates: BooleanSettingDto;
    locationRadius: Int32SettingDto;
    sendNextMaintenancePlanning: StringSettingDto;
    sendOutdatedMaintenancePlanning: StringSettingDto;
    sendMaintenancePlanningToAdmins: BooleanSettingDto;
    sendNextRepairPlanning: StringSettingDto;
    sendOutdatedRepairPlanning: StringSettingDto;
    sendRepairPlanningToAdmins: BooleanSettingDto;
    addMaintenanceIndex: BooleanSettingDto;
    maintenanceMaxDuration: Int32SettingDto;
    repairMaxDuration: Int32SettingDto;
    sendMaintenanceDoneToPlanner: BooleanSettingDto;
    sendRepairDoneToPlanner: BooleanSettingDto;
    enableCostCenterFilter: BooleanSettingDto;
    repairPlanningUser: Int32SettingDto;
    technicianTeamSingleScan: BooleanSettingDto;
    documentsNumberCounter: StringSettingDto;
    printLabelWidth: Int32SettingDto;
    printLabelHeight: Int32SettingDto;

    constructor(data?: ISettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inventoryWithCoordinates = _data["inventoryWithCoordinates"] ? BooleanSettingDto.fromJS(_data["inventoryWithCoordinates"]) : <any>undefined;
            this.locationRadius = _data["locationRadius"] ? Int32SettingDto.fromJS(_data["locationRadius"]) : <any>undefined;
            this.sendNextMaintenancePlanning = _data["sendNextMaintenancePlanning"] ? StringSettingDto.fromJS(_data["sendNextMaintenancePlanning"]) : <any>undefined;
            this.sendOutdatedMaintenancePlanning = _data["sendOutdatedMaintenancePlanning"] ? StringSettingDto.fromJS(_data["sendOutdatedMaintenancePlanning"]) : <any>undefined;
            this.sendMaintenancePlanningToAdmins = _data["sendMaintenancePlanningToAdmins"] ? BooleanSettingDto.fromJS(_data["sendMaintenancePlanningToAdmins"]) : <any>undefined;
            this.sendNextRepairPlanning = _data["sendNextRepairPlanning"] ? StringSettingDto.fromJS(_data["sendNextRepairPlanning"]) : <any>undefined;
            this.sendOutdatedRepairPlanning = _data["sendOutdatedRepairPlanning"] ? StringSettingDto.fromJS(_data["sendOutdatedRepairPlanning"]) : <any>undefined;
            this.sendRepairPlanningToAdmins = _data["sendRepairPlanningToAdmins"] ? BooleanSettingDto.fromJS(_data["sendRepairPlanningToAdmins"]) : <any>undefined;
            this.addMaintenanceIndex = _data["addMaintenanceIndex"] ? BooleanSettingDto.fromJS(_data["addMaintenanceIndex"]) : <any>undefined;
            this.maintenanceMaxDuration = _data["maintenanceMaxDuration"] ? Int32SettingDto.fromJS(_data["maintenanceMaxDuration"]) : <any>undefined;
            this.repairMaxDuration = _data["repairMaxDuration"] ? Int32SettingDto.fromJS(_data["repairMaxDuration"]) : <any>undefined;
            this.sendMaintenanceDoneToPlanner = _data["sendMaintenanceDoneToPlanner"] ? BooleanSettingDto.fromJS(_data["sendMaintenanceDoneToPlanner"]) : <any>undefined;
            this.sendRepairDoneToPlanner = _data["sendRepairDoneToPlanner"] ? BooleanSettingDto.fromJS(_data["sendRepairDoneToPlanner"]) : <any>undefined;
            this.enableCostCenterFilter = _data["enableCostCenterFilter"] ? BooleanSettingDto.fromJS(_data["enableCostCenterFilter"]) : <any>undefined;
            this.repairPlanningUser = _data["repairPlanningUser"] ? Int32SettingDto.fromJS(_data["repairPlanningUser"]) : <any>undefined;
            this.technicianTeamSingleScan = _data["technicianTeamSingleScan"] ? BooleanSettingDto.fromJS(_data["technicianTeamSingleScan"]) : <any>undefined;
            this.documentsNumberCounter = _data["documentsNumberCounter"] ? StringSettingDto.fromJS(_data["documentsNumberCounter"]) : <any>undefined;
            this.printLabelWidth = _data["printLabelWidth"] ? Int32SettingDto.fromJS(_data["printLabelWidth"]) : <any>undefined;
            this.printLabelHeight = _data["printLabelHeight"] ? Int32SettingDto.fromJS(_data["printLabelHeight"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inventoryWithCoordinates"] = this.inventoryWithCoordinates ? this.inventoryWithCoordinates.toJSON() : <any>undefined;
        data["locationRadius"] = this.locationRadius ? this.locationRadius.toJSON() : <any>undefined;
        data["sendNextMaintenancePlanning"] = this.sendNextMaintenancePlanning ? this.sendNextMaintenancePlanning.toJSON() : <any>undefined;
        data["sendOutdatedMaintenancePlanning"] = this.sendOutdatedMaintenancePlanning ? this.sendOutdatedMaintenancePlanning.toJSON() : <any>undefined;
        data["sendMaintenancePlanningToAdmins"] = this.sendMaintenancePlanningToAdmins ? this.sendMaintenancePlanningToAdmins.toJSON() : <any>undefined;
        data["sendNextRepairPlanning"] = this.sendNextRepairPlanning ? this.sendNextRepairPlanning.toJSON() : <any>undefined;
        data["sendOutdatedRepairPlanning"] = this.sendOutdatedRepairPlanning ? this.sendOutdatedRepairPlanning.toJSON() : <any>undefined;
        data["sendRepairPlanningToAdmins"] = this.sendRepairPlanningToAdmins ? this.sendRepairPlanningToAdmins.toJSON() : <any>undefined;
        data["addMaintenanceIndex"] = this.addMaintenanceIndex ? this.addMaintenanceIndex.toJSON() : <any>undefined;
        data["maintenanceMaxDuration"] = this.maintenanceMaxDuration ? this.maintenanceMaxDuration.toJSON() : <any>undefined;
        data["repairMaxDuration"] = this.repairMaxDuration ? this.repairMaxDuration.toJSON() : <any>undefined;
        data["sendMaintenanceDoneToPlanner"] = this.sendMaintenanceDoneToPlanner ? this.sendMaintenanceDoneToPlanner.toJSON() : <any>undefined;
        data["sendRepairDoneToPlanner"] = this.sendRepairDoneToPlanner ? this.sendRepairDoneToPlanner.toJSON() : <any>undefined;
        data["enableCostCenterFilter"] = this.enableCostCenterFilter ? this.enableCostCenterFilter.toJSON() : <any>undefined;
        data["repairPlanningUser"] = this.repairPlanningUser ? this.repairPlanningUser.toJSON() : <any>undefined;
        data["technicianTeamSingleScan"] = this.technicianTeamSingleScan ? this.technicianTeamSingleScan.toJSON() : <any>undefined;
        data["documentsNumberCounter"] = this.documentsNumberCounter ? this.documentsNumberCounter.toJSON() : <any>undefined;
        data["printLabelWidth"] = this.printLabelWidth ? this.printLabelWidth.toJSON() : <any>undefined;
        data["printLabelHeight"] = this.printLabelHeight ? this.printLabelHeight.toJSON() : <any>undefined;
        return data;
    }

    clone(): SettingsDto {
        const json = this.toJSON();
        let result = new SettingsDto();
        result.init(json);
        return result;
    }
}

export interface ISettingsDto {
    inventoryWithCoordinates: BooleanSettingDto;
    locationRadius: Int32SettingDto;
    sendNextMaintenancePlanning: StringSettingDto;
    sendOutdatedMaintenancePlanning: StringSettingDto;
    sendMaintenancePlanningToAdmins: BooleanSettingDto;
    sendNextRepairPlanning: StringSettingDto;
    sendOutdatedRepairPlanning: StringSettingDto;
    sendRepairPlanningToAdmins: BooleanSettingDto;
    addMaintenanceIndex: BooleanSettingDto;
    maintenanceMaxDuration: Int32SettingDto;
    repairMaxDuration: Int32SettingDto;
    sendMaintenanceDoneToPlanner: BooleanSettingDto;
    sendRepairDoneToPlanner: BooleanSettingDto;
    enableCostCenterFilter: BooleanSettingDto;
    repairPlanningUser: Int32SettingDto;
    technicianTeamSingleScan: BooleanSettingDto;
    documentsNumberCounter: StringSettingDto;
    printLabelWidth: Int32SettingDto;
    printLabelHeight: Int32SettingDto;
}

export class UpdateSettingDto implements IUpdateSettingDto {
    key: string | undefined;
    value: string | undefined;
    userSetting: boolean;

    constructor(data?: IUpdateSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.userSetting = _data["userSetting"];
        }
    }

    static fromJS(data: any): UpdateSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["userSetting"] = this.userSetting;
        return data;
    }

    clone(): UpdateSettingDto {
        const json = this.toJSON();
        let result = new UpdateSettingDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSettingDto {
    key: string | undefined;
    value: string | undefined;
    userSetting: boolean;
}

export class CreateTenantProfileDto implements ICreateTenantProfileDto {
    address: string | undefined;
    cui: string | undefined;
    registerNumber: string | undefined;
    phoneNumber: string | undefined;
    representativeName: string | undefined;

    constructor(data?: ICreateTenantProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.cui = _data["cui"];
            this.registerNumber = _data["registerNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.representativeName = _data["representativeName"];
        }
    }

    static fromJS(data: any): CreateTenantProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["cui"] = this.cui;
        data["registerNumber"] = this.registerNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["representativeName"] = this.representativeName;
        return data;
    }

    clone(): CreateTenantProfileDto {
        const json = this.toJSON();
        let result = new CreateTenantProfileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantProfileDto {
    address: string | undefined;
    cui: string | undefined;
    registerNumber: string | undefined;
    phoneNumber: string | undefined;
    representativeName: string | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
    licenceNo: number;
    profile: CreateTenantProfileDto;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.licenceNo = _data["licenceNo"];
            this.profile = _data["profile"] ? CreateTenantProfileDto.fromJS(_data["profile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["licenceNo"] = this.licenceNo;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
    licenceNo: number;
    profile: CreateTenantProfileDto;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    licenceNo: number;
    profile: TenantProfileDto;
    id: number;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
            this.licenceNo = _data["licenceNo"];
            this.profile = _data["profile"] ? TenantProfileDto.fromJS(_data["profile"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["licenceNo"] = this.licenceNo;
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean;
    licenceNo: number;
    profile: TenantProfileDto;
    id: number;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    totalCount: number;
    items: TenantDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
    tenancyName: string | undefined;
    tenantSelected: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
            this.tenancyName = _data["tenancyName"];
            this.tenantSelected = _data["tenantSelected"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        data["tenancyName"] = this.tenancyName;
        data["tenantSelected"] = this.tenantSelected;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
    tenancyName: string | undefined;
    tenantSelected: boolean;
}

export class AuthenticateTenantItem implements IAuthenticateTenantItem {
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: IAuthenticateTenantItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AuthenticateTenantItem {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateTenantItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): AuthenticateTenantItem {
        const json = this.toJSON();
        let result = new AuthenticateTenantItem();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateTenantItem {
    tenancyName: string | undefined;
    name: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    tenants: AuthenticateTenantItem[] | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants.push(AuthenticateTenantItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
    tenants: AuthenticateTenantItem[] | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ResetPasswordResult implements IResetPasswordResult {
    tenants: AuthenticateTenantItem[] | undefined;
    emailSent: boolean;

    constructor(data?: IResetPasswordResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenants"])) {
                this.tenants = [] as any;
                for (let item of _data["tenants"])
                    this.tenants.push(AuthenticateTenantItem.fromJS(item));
            }
            this.emailSent = _data["emailSent"];
        }
    }

    static fromJS(data: any): ResetPasswordResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenants)) {
            data["tenants"] = [];
            for (let item of this.tenants)
                data["tenants"].push(item.toJSON());
        }
        data["emailSent"] = this.emailSent;
        return data;
    }

    clone(): ResetPasswordResult {
        const json = this.toJSON();
        let result = new ResetPasswordResult();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResult {
    tenants: AuthenticateTenantItem[] | undefined;
    emailSent: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    isTechnician: boolean;
    isClient: boolean;
    costCenterIds: string[] | undefined;
    roleNames: string[] | undefined;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.isTechnician = _data["isTechnician"];
            this.isClient = _data["isClient"];
            if (Array.isArray(_data["costCenterIds"])) {
                this.costCenterIds = [] as any;
                for (let item of _data["costCenterIds"])
                    this.costCenterIds.push(item);
            }
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["isTechnician"] = this.isTechnician;
        data["isClient"] = this.isClient;
        if (Array.isArray(this.costCenterIds)) {
            data["costCenterIds"] = [];
            for (let item of this.costCenterIds)
                data["costCenterIds"].push(item);
        }
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    isTechnician: boolean;
    isClient: boolean;
    costCenterIds: string[] | undefined;
    roleNames: string[] | undefined;
    password: string;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    totalCount: number;
    items: UserDto[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}